/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Champ crm
 * API description dev
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AdvertisementControllerGetAdvertisementHistoryParams,
  AppointManagerDTO,
  CategoryControllerGetOptionsParams,
  CompetitorControllerGetBriefcaseStatParams,
  CompetitorControllerGetCategoryStatParams,
  CompetitorControllerGetCompetitorListParams,
  CompetitorControllerGetCompetitorRelationParams,
  CompetitorControllerGetLostParams,
  CompetitorControllerGetMonthlyStatsParams,
  CompetitorControllerGetSkuStatParams,
  CompetitorControllerGetSkusWithoutStatsParams,
  CompetitorControllerMarkParams,
  CompetitorControllerSearchSkuParams,
  CreateCommentDTO,
  CreateCompetitorRelationDataDTO,
  CreateCompetitorStatsRequestDTO,
  CreateManualCompetitorRelationDTO,
  GetCommentResponseDTO,
  GetNetProfitRequest,
  ImportFinrezDailyRequestDTO,
  LoginBodyDto,
  MarkRelationBodyDTO,
  MarketShareControllerGetBriefcaseBrandListParams,
  MarketShareControllerGetBriefcaseShareStatsParams,
  MarketShareControllerGetCategoryBrandListParams,
  MarketShareControllerGetCategoryShareStatsParams,
  MarketShareControllerGetPeriodSegmentParams,
  MarketShareControllerGetPeriodValueParams,
  MarketShareControllerGetSegmentParams,
  NetProfitControllerGetNetProfitsHistoryFprProductsParams,
  OrderHistoryControllerGetOrderHistoryForProductParams,
  ProductReportControllerGetProductCardEconomyParams,
  ProductReportControllerGetProductCardReportParams,
  ProductReportControllerGetProductCardSummaryParams,
  ProductReportControllerGetProductPriceHistoryParams,
  ProductReportControllerGetPurchaseFunnelParams,
  RatingControllerGetProductRatingHistoryParams,
  RegistrationBodyDto,
  RequestLoggerControllerGetParams,
  ResetPasswordRequestDTO,
  ReviewControllerGetInfoByBriefcaseForPeriodParams,
  ReviewControllerGetInfoByGeneralArticleParams,
  ReviewControllerGetTFIDFParams,
  SalesChannelControllerGetMarketplaceDetailParams,
  SalesChannelControllerGetOverviewParams,
  SearchProductRequestDTO,
  SearchProductResponseDTO,
  SendResetPasswordLinkDTO,
  TableControllerGetProductsOrderHistoryParams,
  TableControllerGetProductsOverviewParams,
  TableControllerGetRemainingProductsParams,
  TableControllerGetRevenueParams,
  UpdateFavoriteRequestDTO,
  UpdateFavoriteResponseDTO,
  UpdateUserRequest,
} from "./schemas";

import { faker } from "@faker-js/faker";

import { HttpResponse, delay, http } from "msw";

import {
  AlertKind,
  ArticleStatus,
  BrandOrder,
  ChannelKey,
  DeltaUnit,
  Department,
  ExpenseKey,
  Gender,
  MarketPlace,
  MetricKey,
  MetricUnit,
  PeriodType,
  ProductCardStatus,
  ReviewClassification,
  Role,
  Severity,
  Trend,
} from "./schemas";
import type {
  AlertResponseDTO,
  ArticleCategoryResponse,
  AuthResponseDto,
  BrandListByBriefcaseResponse,
  BrandListByCategoryResponse,
  BriefcaseCompetitorRelationStatsResponse,
  BriefcaseDto,
  CategoryStatsResponse,
  CompetitorRelationDetailResponse,
  CompetitorRelationListResponse,
  DashboardResponseDTO,
  DeleteUserResponse,
  EmptyStatsResponse,
  GetAdDailyCompanyStatsBySkuResponse,
  GetAdDailyCompanyStatsResponseDto,
  GetAdvertisementHistoryByCampaignsResponseDTO,
  GetOrderHistoryForProductResponseDTO,
  GetProductCardEconomyResponseDTO,
  GetProductCardReportResponseDTO,
  GetProductCardSummaryResponseDTO,
  GetProductOrderHistoryWithManagerResponseDTO,
  GetProductPriceHistoryResponseDTO,
  GetProductRatingHistoryResponseDTO,
  GetProductsOverviewResponseDTO,
  GetPurchaseFunnelResponseDTO,
  GetRemainingProductsResponseDTO,
  GetRevenuesResponseDTO,
  GetUnassignedProductsDTO,
  LogPaginatedResponse,
  LogoutResponseDto,
  ManualRelationResponse,
  MarkRelationResponseDTO,
  MarketShareByCategoryStatsResponse,
  MarketShareStatsByBriefcaseResponse,
  MarketplaceDetailResponseDto,
  MonthCompetitorStatsResponse,
  OptionResponseDto,
  Options,
  OptionsCompetitorResponse,
  OverviewResponseDto,
  PeriodValueResponse,
  ReadUserResponse,
  ReviewByArticleResponse,
  ReviewsByBriefcaseResponseDto,
  SearchCompetitorResponse,
  SegmentPeriodResponseDTO,
  SegmentResponseDTO,
  SkuCompetitorRelationStatsResponse,
  SkuMonthlyCompetitorRelationStatsResponse,
  StatusResponseDTO,
  UserInfoDto,
  WordCloudRes,
} from "./schemas";

import { createInstance } from "../../api.instance";
import type { ErrorType, BodyType } from "../../api.instance";
/**
 * @summary Получение истории по рекламе
 */
export const advertisementControllerGetAdvertisementHistory = (
  productId: number,
  params?: AdvertisementControllerGetAdvertisementHistoryParams,
  signal?: AbortSignal
) => {
  return createInstance<GetAdvertisementHistoryByCampaignsResponseDTO>({
    url: `/api/advertisement/getAdvertisementHistory/${productId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getAdvertisementControllerGetAdvertisementHistoryQueryKey = (
  productId: number,
  params?: AdvertisementControllerGetAdvertisementHistoryParams
) => {
  return [
    `/api/advertisement/getAdvertisementHistory/${productId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdvertisementControllerGetAdvertisementHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: AdvertisementControllerGetAdvertisementHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAdvertisementControllerGetAdvertisementHistoryQueryKey(productId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>
  > = ({ signal }) => advertisementControllerGetAdvertisementHistory(productId, params, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdvertisementControllerGetAdvertisementHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>
>;
export type AdvertisementControllerGetAdvertisementHistoryQueryError = ErrorType<unknown>;

export function useAdvertisementControllerGetAdvertisementHistory<
  TData = Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: undefined | AdvertisementControllerGetAdvertisementHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>,
          TError,
          Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdvertisementControllerGetAdvertisementHistory<
  TData = Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: AdvertisementControllerGetAdvertisementHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>,
          TError,
          Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdvertisementControllerGetAdvertisementHistory<
  TData = Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: AdvertisementControllerGetAdvertisementHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение истории по рекламе
 */

export function useAdvertisementControllerGetAdvertisementHistory<
  TData = Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: AdvertisementControllerGetAdvertisementHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof advertisementControllerGetAdvertisementHistory>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdvertisementControllerGetAdvertisementHistoryQueryOptions(
    productId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Возвращает агрегированную статистику рекламы по всем продуктам за текущий день
 * @summary Получение дневной статистики рекламы по всем продуктам
 */
export const advertisementControllerGetDailyInnerAdStat = (signal?: AbortSignal) => {
  return createInstance<GetAdDailyCompanyStatsResponseDto>({
    url: `/api/advertisement/daily`,
    method: "GET",
    signal,
  });
};

export const getAdvertisementControllerGetDailyInnerAdStatQueryKey = () => {
  return [`/api/advertisement/daily`] as const;
};

export const getAdvertisementControllerGetDailyInnerAdStatQueryOptions = <
  TData = Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdvertisementControllerGetDailyInnerAdStatQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>
  > = ({ signal }) => advertisementControllerGetDailyInnerAdStat(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdvertisementControllerGetDailyInnerAdStatQueryResult = NonNullable<
  Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>
>;
export type AdvertisementControllerGetDailyInnerAdStatQueryError = ErrorType<unknown>;

export function useAdvertisementControllerGetDailyInnerAdStat<
  TData = Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>,
        TError,
        Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdvertisementControllerGetDailyInnerAdStat<
  TData = Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>,
        TError,
        Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdvertisementControllerGetDailyInnerAdStat<
  TData = Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение дневной статистики рекламы по всем продуктам
 */

export function useAdvertisementControllerGetDailyInnerAdStat<
  TData = Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof advertisementControllerGetDailyInnerAdStat>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdvertisementControllerGetDailyInnerAdStatQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Возвращает отчет по ключевым словам (плохие, хорошие, рекомендованные) для указанного SKU за текущий день
 * @summary Получение ключевых слов для продукта по SKU
 */
export const advertisementControllerGetAdKeyword = (sku: number, signal?: AbortSignal) => {
  return createInstance<GetAdDailyCompanyStatsBySkuResponse>({
    url: `/api/advertisement/keywords/${sku}`,
    method: "GET",
    signal,
  });
};

export const getAdvertisementControllerGetAdKeywordQueryKey = (sku: number) => {
  return [`/api/advertisement/keywords/${sku}`] as const;
};

export const getAdvertisementControllerGetAdKeywordQueryOptions = <
  TData = Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdvertisementControllerGetAdKeywordQueryKey(sku);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>> = ({
    signal,
  }) => advertisementControllerGetAdKeyword(sku, signal);

  return { queryKey, queryFn, enabled: !!sku, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdvertisementControllerGetAdKeywordQueryResult = NonNullable<
  Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>
>;
export type AdvertisementControllerGetAdKeywordQueryError = ErrorType<unknown>;

export function useAdvertisementControllerGetAdKeyword<
  TData = Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>,
          TError,
          Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdvertisementControllerGetAdKeyword<
  TData = Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>,
          TError,
          Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdvertisementControllerGetAdKeyword<
  TData = Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение ключевых слов для продукта по SKU
 */

export function useAdvertisementControllerGetAdKeyword<
  TData = Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof advertisementControllerGetAdKeyword>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdvertisementControllerGetAdKeywordQueryOptions(sku, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const authControllerLogin = (loginBodyDto: BodyType<LoginBodyDto>, signal?: AbortSignal) => {
  return createInstance<AuthResponseDto>({
    url: `/api/auth/login`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: loginBodyDto,
    signal,
  });
};

export const getAuthControllerLoginMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerLogin>>,
    TError,
    { data: BodyType<LoginBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerLogin>>,
  TError,
  { data: BodyType<LoginBodyDto> },
  TContext
> => {
  const mutationKey = ["authControllerLogin"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerLogin>>,
    { data: BodyType<LoginBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerLogin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerLogin>>
>;
export type AuthControllerLoginMutationBody = BodyType<LoginBodyDto>;
export type AuthControllerLoginMutationError = ErrorType<unknown>;

export const useAuthControllerLogin = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerLogin>>,
    TError,
    { data: BodyType<LoginBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof authControllerLogin>>,
  TError,
  { data: BodyType<LoginBodyDto> },
  TContext
> => {
  const mutationOptions = getAuthControllerLoginMutationOptions(options);

  return useMutation(mutationOptions);
};

export const authControllerLogout = (signal?: AbortSignal) => {
  return createInstance<LogoutResponseDto>({ url: `/api/auth/logout`, method: "POST", signal });
};

export const getAuthControllerLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerLogout>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerLogout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["authControllerLogout"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerLogout>>,
    void
  > = () => {
    return authControllerLogout();
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerLogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerLogout>>
>;

export type AuthControllerLogoutMutationError = ErrorType<unknown>;

export const useAuthControllerLogout = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerLogout>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<typeof authControllerLogout>>, TError, void, TContext> => {
  const mutationOptions = getAuthControllerLogoutMutationOptions(options);

  return useMutation(mutationOptions);
};

export const authControllerRegistration = (
  registrationBodyDto: BodyType<RegistrationBodyDto>,
  signal?: AbortSignal
) => {
  return createInstance<AuthResponseDto>({
    url: `/api/auth/registration`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: registrationBodyDto,
    signal,
  });
};

export const getAuthControllerRegistrationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerRegistration>>,
    TError,
    { data: BodyType<RegistrationBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerRegistration>>,
  TError,
  { data: BodyType<RegistrationBodyDto> },
  TContext
> => {
  const mutationKey = ["authControllerRegistration"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerRegistration>>,
    { data: BodyType<RegistrationBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerRegistration(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerRegistrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerRegistration>>
>;
export type AuthControllerRegistrationMutationBody = BodyType<RegistrationBodyDto>;
export type AuthControllerRegistrationMutationError = ErrorType<unknown>;

export const useAuthControllerRegistration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerRegistration>>,
    TError,
    { data: BodyType<RegistrationBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof authControllerRegistration>>,
  TError,
  { data: BodyType<RegistrationBodyDto> },
  TContext
> => {
  const mutationOptions = getAuthControllerRegistrationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const authControllerActivateAccount = (link: string, signal?: AbortSignal) => {
  return createInstance<void>({ url: `/api/auth/activation/${link}`, method: "GET", signal });
};

export const getAuthControllerActivateAccountQueryKey = (link: string) => {
  return [`/api/auth/activation/${link}`] as const;
};

export const getAuthControllerActivateAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerActivateAccount>>,
  TError = ErrorType<unknown>,
>(
  link: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerActivateAccount>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthControllerActivateAccountQueryKey(link);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerActivateAccount>>> = ({
    signal,
  }) => authControllerActivateAccount(link, signal);

  return { queryKey, queryFn, enabled: !!link, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerActivateAccount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AuthControllerActivateAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerActivateAccount>>
>;
export type AuthControllerActivateAccountQueryError = ErrorType<unknown>;

export function useAuthControllerActivateAccount<
  TData = Awaited<ReturnType<typeof authControllerActivateAccount>>,
  TError = ErrorType<unknown>,
>(
  link: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerActivateAccount>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerActivateAccount>>,
          TError,
          Awaited<ReturnType<typeof authControllerActivateAccount>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAuthControllerActivateAccount<
  TData = Awaited<ReturnType<typeof authControllerActivateAccount>>,
  TError = ErrorType<unknown>,
>(
  link: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerActivateAccount>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerActivateAccount>>,
          TError,
          Awaited<ReturnType<typeof authControllerActivateAccount>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAuthControllerActivateAccount<
  TData = Awaited<ReturnType<typeof authControllerActivateAccount>>,
  TError = ErrorType<unknown>,
>(
  link: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerActivateAccount>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useAuthControllerActivateAccount<
  TData = Awaited<ReturnType<typeof authControllerActivateAccount>>,
  TError = ErrorType<unknown>,
>(
  link: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerActivateAccount>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAuthControllerActivateAccountQueryOptions(link, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const authControllerSendNewActivateLink = (signal?: AbortSignal) => {
  return createInstance<void>({ url: `/api/auth/link`, method: "GET", signal });
};

export const getAuthControllerSendNewActivateLinkQueryKey = () => {
  return [`/api/auth/link`] as const;
};

export const getAuthControllerSendNewActivateLinkQueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerSendNewActivateLink>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerSendNewActivateLink>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthControllerSendNewActivateLinkQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerSendNewActivateLink>>> = ({
    signal,
  }) => authControllerSendNewActivateLink(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerSendNewActivateLink>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AuthControllerSendNewActivateLinkQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerSendNewActivateLink>>
>;
export type AuthControllerSendNewActivateLinkQueryError = ErrorType<unknown>;

export function useAuthControllerSendNewActivateLink<
  TData = Awaited<ReturnType<typeof authControllerSendNewActivateLink>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerSendNewActivateLink>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof authControllerSendNewActivateLink>>,
        TError,
        Awaited<ReturnType<typeof authControllerSendNewActivateLink>>
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAuthControllerSendNewActivateLink<
  TData = Awaited<ReturnType<typeof authControllerSendNewActivateLink>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerSendNewActivateLink>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof authControllerSendNewActivateLink>>,
        TError,
        Awaited<ReturnType<typeof authControllerSendNewActivateLink>>
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAuthControllerSendNewActivateLink<
  TData = Awaited<ReturnType<typeof authControllerSendNewActivateLink>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerSendNewActivateLink>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useAuthControllerSendNewActivateLink<
  TData = Awaited<ReturnType<typeof authControllerSendNewActivateLink>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerSendNewActivateLink>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAuthControllerSendNewActivateLinkQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Запросить ссылку для сброса пароля
 */
export const authControllerSendResetPasswordLink = (
  sendResetPasswordLinkDTO: BodyType<SendResetPasswordLinkDTO>,
  signal?: AbortSignal
) => {
  return createInstance<void>({
    url: `/api/auth/sendResetPasswordLink`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: sendResetPasswordLinkDTO,
    signal,
  });
};

export const getAuthControllerSendResetPasswordLinkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerSendResetPasswordLink>>,
    TError,
    { data: BodyType<SendResetPasswordLinkDTO> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerSendResetPasswordLink>>,
  TError,
  { data: BodyType<SendResetPasswordLinkDTO> },
  TContext
> => {
  const mutationKey = ["authControllerSendResetPasswordLink"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerSendResetPasswordLink>>,
    { data: BodyType<SendResetPasswordLinkDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerSendResetPasswordLink(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerSendResetPasswordLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerSendResetPasswordLink>>
>;
export type AuthControllerSendResetPasswordLinkMutationBody = BodyType<SendResetPasswordLinkDTO>;
export type AuthControllerSendResetPasswordLinkMutationError = ErrorType<unknown>;

/**
 * @summary Запросить ссылку для сброса пароля
 */
export const useAuthControllerSendResetPasswordLink = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerSendResetPasswordLink>>,
    TError,
    { data: BodyType<SendResetPasswordLinkDTO> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof authControllerSendResetPasswordLink>>,
  TError,
  { data: BodyType<SendResetPasswordLinkDTO> },
  TContext
> => {
  const mutationOptions = getAuthControllerSendResetPasswordLinkMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Задать новый пароль
 */
export const authControllerResetPassword = (
  link: string,
  resetPasswordRequestDTO: BodyType<ResetPasswordRequestDTO>,
  signal?: AbortSignal
) => {
  return createInstance<StatusResponseDTO>({
    url: `/api/auth/resetPassword/${link}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: resetPasswordRequestDTO,
    signal,
  });
};

export const getAuthControllerResetPasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerResetPassword>>,
    TError,
    { link: string; data: BodyType<ResetPasswordRequestDTO> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerResetPassword>>,
  TError,
  { link: string; data: BodyType<ResetPasswordRequestDTO> },
  TContext
> => {
  const mutationKey = ["authControllerResetPassword"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerResetPassword>>,
    { link: string; data: BodyType<ResetPasswordRequestDTO> }
  > = (props) => {
    const { link, data } = props ?? {};

    return authControllerResetPassword(link, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerResetPassword>>
>;
export type AuthControllerResetPasswordMutationBody = BodyType<ResetPasswordRequestDTO>;
export type AuthControllerResetPasswordMutationError = ErrorType<unknown>;

/**
 * @summary Задать новый пароль
 */
export const useAuthControllerResetPassword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerResetPassword>>,
    TError,
    { link: string; data: BodyType<ResetPasswordRequestDTO> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof authControllerResetPassword>>,
  TError,
  { link: string; data: BodyType<ResetPasswordRequestDTO> },
  TContext
> => {
  const mutationOptions = getAuthControllerResetPasswordMutationOptions(options);

  return useMutation(mutationOptions);
};

export const authControllerRefresh = (signal?: AbortSignal) => {
  return createInstance<AuthResponseDto>({ url: `/api/auth/refresh`, method: "GET", signal });
};

export const getAuthControllerRefreshQueryKey = () => {
  return [`/api/auth/refresh`] as const;
};

export const getAuthControllerRefreshQueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerRefresh>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthControllerRefreshQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerRefresh>>> = ({ signal }) =>
    authControllerRefresh(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerRefresh>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AuthControllerRefreshQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerRefresh>>
>;
export type AuthControllerRefreshQueryError = ErrorType<unknown>;

export function useAuthControllerRefresh<
  TData = Awaited<ReturnType<typeof authControllerRefresh>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof authControllerRefresh>>,
        TError,
        Awaited<ReturnType<typeof authControllerRefresh>>
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAuthControllerRefresh<
  TData = Awaited<ReturnType<typeof authControllerRefresh>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof authControllerRefresh>>,
        TError,
        Awaited<ReturnType<typeof authControllerRefresh>>
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAuthControllerRefresh<
  TData = Awaited<ReturnType<typeof authControllerRefresh>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useAuthControllerRefresh<
  TData = Awaited<ReturnType<typeof authControllerRefresh>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAuthControllerRefreshQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @deprecated
 */
export const userControllerGetAll = (signal?: AbortSignal) => {
  return createInstance<UserInfoDto[]>({ url: `/api/user/all`, method: "GET", signal });
};

export const getUserControllerGetAllQueryKey = () => {
  return [`/api/user/all`] as const;
};

export const getUserControllerGetAllQueryOptions = <
  TData = Awaited<ReturnType<typeof userControllerGetAll>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAll>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserControllerGetAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetAll>>> = ({ signal }) =>
    userControllerGetAll(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userControllerGetAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type UserControllerGetAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof userControllerGetAll>>
>;
export type UserControllerGetAllQueryError = ErrorType<unknown>;

export function useUserControllerGetAll<
  TData = Awaited<ReturnType<typeof userControllerGetAll>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAll>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof userControllerGetAll>>,
        TError,
        Awaited<ReturnType<typeof userControllerGetAll>>
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUserControllerGetAll<
  TData = Awaited<ReturnType<typeof userControllerGetAll>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAll>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof userControllerGetAll>>,
        TError,
        Awaited<ReturnType<typeof userControllerGetAll>>
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUserControllerGetAll<
  TData = Awaited<ReturnType<typeof userControllerGetAll>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAll>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 */

export function useUserControllerGetAll<
  TData = Awaited<ReturnType<typeof userControllerGetAll>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAll>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getUserControllerGetAllQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @deprecated
 */
export const userControllerFindOne = (id: string, signal?: AbortSignal) => {
  return createInstance<ReadUserResponse>({ url: `/api/user/${id}`, method: "GET", signal });
};

export const getUserControllerFindOneQueryKey = (id: string) => {
  return [`/api/user/${id}`] as const;
};

export const getUserControllerFindOneQueryOptions = <
  TData = Awaited<ReturnType<typeof userControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userControllerFindOne>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserControllerFindOneQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerFindOne>>> = ({ signal }) =>
    userControllerFindOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userControllerFindOne>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type UserControllerFindOneQueryResult = NonNullable<
  Awaited<ReturnType<typeof userControllerFindOne>>
>;
export type UserControllerFindOneQueryError = ErrorType<unknown>;

export function useUserControllerFindOne<
  TData = Awaited<ReturnType<typeof userControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userControllerFindOne>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof userControllerFindOne>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUserControllerFindOne<
  TData = Awaited<ReturnType<typeof userControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userControllerFindOne>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof userControllerFindOne>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUserControllerFindOne<
  TData = Awaited<ReturnType<typeof userControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userControllerFindOne>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 */

export function useUserControllerFindOne<
  TData = Awaited<ReturnType<typeof userControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userControllerFindOne>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getUserControllerFindOneQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Обновление сотрудника - роль, департамент ....
 */
export const userControllerUpdate = (
  id: string,
  updateUserRequest: BodyType<UpdateUserRequest>
) => {
  return createInstance<ReadUserResponse>({
    url: `/api/user/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateUserRequest,
  });
};

export const getUserControllerUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerUpdate>>,
    TError,
    { id: string; data: BodyType<UpdateUserRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userControllerUpdate>>,
  TError,
  { id: string; data: BodyType<UpdateUserRequest> },
  TContext
> => {
  const mutationKey = ["userControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userControllerUpdate>>,
    { id: string; data: BodyType<UpdateUserRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return userControllerUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof userControllerUpdate>>
>;
export type UserControllerUpdateMutationBody = BodyType<UpdateUserRequest>;
export type UserControllerUpdateMutationError = ErrorType<unknown>;

/**
 * @summary Обновление сотрудника - роль, департамент ....
 */
export const useUserControllerUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerUpdate>>,
    TError,
    { id: string; data: BodyType<UpdateUserRequest> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userControllerUpdate>>,
  TError,
  { id: string; data: BodyType<UpdateUserRequest> },
  TContext
> => {
  const mutationOptions = getUserControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @deprecated
 */
export const userControllerRemove = (id: string) => {
  return createInstance<DeleteUserResponse>({ url: `/api/user/${id}`, method: "DELETE" });
};

export const getUserControllerRemoveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerRemove>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["userControllerRemove"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userControllerRemove>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return userControllerRemove(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof userControllerRemove>>
>;

export type UserControllerRemoveMutationError = ErrorType<unknown>;

/**
 * @deprecated
 */
export const useUserControllerRemove = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerRemove>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getUserControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Взять сотрудника в подчинение
 */
export const userControllerMakeSubordinate = (userId: string, signal?: AbortSignal) => {
  return createInstance<StatusResponseDTO>({
    url: `/api/user/makeSubordinate/${userId}`,
    method: "POST",
    signal,
  });
};

export const getUserControllerMakeSubordinateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerMakeSubordinate>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userControllerMakeSubordinate>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ["userControllerMakeSubordinate"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userControllerMakeSubordinate>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return userControllerMakeSubordinate(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserControllerMakeSubordinateMutationResult = NonNullable<
  Awaited<ReturnType<typeof userControllerMakeSubordinate>>
>;

export type UserControllerMakeSubordinateMutationError = ErrorType<unknown>;

/**
 * @summary Взять сотрудника в подчинение
 */
export const useUserControllerMakeSubordinate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerMakeSubordinate>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userControllerMakeSubordinate>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getUserControllerMakeSubordinateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const userControllerUpdateSelf = (updateUserRequest: BodyType<UpdateUserRequest>) => {
  return createInstance<ReadUserResponse>({
    url: `/api/user`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateUserRequest,
  });
};

export const getUserControllerUpdateSelfMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerUpdateSelf>>,
    TError,
    { data: BodyType<UpdateUserRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userControllerUpdateSelf>>,
  TError,
  { data: BodyType<UpdateUserRequest> },
  TContext
> => {
  const mutationKey = ["userControllerUpdateSelf"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userControllerUpdateSelf>>,
    { data: BodyType<UpdateUserRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return userControllerUpdateSelf(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserControllerUpdateSelfMutationResult = NonNullable<
  Awaited<ReturnType<typeof userControllerUpdateSelf>>
>;
export type UserControllerUpdateSelfMutationBody = BodyType<UpdateUserRequest>;
export type UserControllerUpdateSelfMutationError = ErrorType<unknown>;

export const useUserControllerUpdateSelf = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerUpdateSelf>>,
    TError,
    { data: BodyType<UpdateUserRequest> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userControllerUpdateSelf>>,
  TError,
  { data: BodyType<UpdateUserRequest> },
  TContext
> => {
  const mutationOptions = getUserControllerUpdateSelfMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary server-side events
 */
export const alertControllerSse = (signal?: AbortSignal) => {
  return createInstance<AlertResponseDTO>({ url: `/api/alert/sse`, method: "GET", signal });
};

export const getAlertControllerSseQueryKey = () => {
  return [`/api/alert/sse`] as const;
};

export const getAlertControllerSseQueryOptions = <
  TData = Awaited<ReturnType<typeof alertControllerSse>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof alertControllerSse>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAlertControllerSseQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof alertControllerSse>>> = ({ signal }) =>
    alertControllerSse(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof alertControllerSse>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AlertControllerSseQueryResult = NonNullable<
  Awaited<ReturnType<typeof alertControllerSse>>
>;
export type AlertControllerSseQueryError = ErrorType<unknown>;

export function useAlertControllerSse<
  TData = Awaited<ReturnType<typeof alertControllerSse>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof alertControllerSse>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof alertControllerSse>>,
        TError,
        Awaited<ReturnType<typeof alertControllerSse>>
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAlertControllerSse<
  TData = Awaited<ReturnType<typeof alertControllerSse>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof alertControllerSse>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof alertControllerSse>>,
        TError,
        Awaited<ReturnType<typeof alertControllerSse>>
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAlertControllerSse<
  TData = Awaited<ReturnType<typeof alertControllerSse>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof alertControllerSse>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary server-side events
 */

export function useAlertControllerSse<
  TData = Awaited<ReturnType<typeof alertControllerSse>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof alertControllerSse>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAlertControllerSseQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Только для DAG
 */
export const logisticControllerUpdateDeliveryData = (
  logisticControllerUpdateDeliveryDataBody: BodyType<string[]>,
  signal?: AbortSignal
) => {
  return createInstance<StatusResponseDTO>({
    url: `/api/logistic/updateDeliveryData`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: logisticControllerUpdateDeliveryDataBody,
    signal,
  });
};

export const getLogisticControllerUpdateDeliveryDataMutationOptions = <
  TError = ErrorType<StatusResponseDTO>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logisticControllerUpdateDeliveryData>>,
    TError,
    { data: BodyType<string[]> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logisticControllerUpdateDeliveryData>>,
  TError,
  { data: BodyType<string[]> },
  TContext
> => {
  const mutationKey = ["logisticControllerUpdateDeliveryData"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logisticControllerUpdateDeliveryData>>,
    { data: BodyType<string[]> }
  > = (props) => {
    const { data } = props ?? {};

    return logisticControllerUpdateDeliveryData(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogisticControllerUpdateDeliveryDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof logisticControllerUpdateDeliveryData>>
>;
export type LogisticControllerUpdateDeliveryDataMutationBody = BodyType<string[]>;
export type LogisticControllerUpdateDeliveryDataMutationError = ErrorType<StatusResponseDTO>;

/**
 * @summary Только для DAG
 */
export const useLogisticControllerUpdateDeliveryData = <
  TError = ErrorType<StatusResponseDTO>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logisticControllerUpdateDeliveryData>>,
    TError,
    { data: BodyType<string[]> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof logisticControllerUpdateDeliveryData>>,
  TError,
  { data: BodyType<string[]> },
  TContext
> => {
  const mutationOptions = getLogisticControllerUpdateDeliveryDataMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Получение списка портфелей
 */
export const briefcaseControllerGetBriefcases = (signal?: AbortSignal) => {
  return createInstance<BriefcaseDto[]>({ url: `/api/briefcase`, method: "GET", signal });
};

export const getBriefcaseControllerGetBriefcasesQueryKey = () => {
  return [`/api/briefcase`] as const;
};

export const getBriefcaseControllerGetBriefcasesQueryOptions = <
  TData = Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBriefcaseControllerGetBriefcasesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>> = ({
    signal,
  }) => briefcaseControllerGetBriefcases(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type BriefcaseControllerGetBriefcasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>
>;
export type BriefcaseControllerGetBriefcasesQueryError = ErrorType<unknown>;

export function useBriefcaseControllerGetBriefcases<
  TData = Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>,
        TError,
        Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useBriefcaseControllerGetBriefcases<
  TData = Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>,
        TError,
        Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useBriefcaseControllerGetBriefcases<
  TData = Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение списка портфелей
 */

export function useBriefcaseControllerGetBriefcases<
  TData = Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof briefcaseControllerGetBriefcases>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getBriefcaseControllerGetBriefcasesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @deprecated
 */
export const productControllerRemove = (id: number) => {
  return createInstance<void>({ url: `/api/product/${id}`, method: "DELETE" });
};

export const getProductControllerRemoveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productControllerRemove>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof productControllerRemove>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["productControllerRemove"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof productControllerRemove>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return productControllerRemove(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProductControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof productControllerRemove>>
>;

export type ProductControllerRemoveMutationError = ErrorType<unknown>;

/**
 * @deprecated
 */
export const useProductControllerRemove = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productControllerRemove>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof productControllerRemove>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getProductControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Поиск товара по sku, общему артиклю или названию
 */
export const productControllerSearchProduct = (
  searchProductRequestDTO: BodyType<SearchProductRequestDTO>,
  signal?: AbortSignal
) => {
  return createInstance<SearchProductResponseDTO[]>({
    url: `/api/product/searchProduct`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: searchProductRequestDTO,
    signal,
  });
};

export const getProductControllerSearchProductMutationOptions = <
  TError = ErrorType<SearchProductResponseDTO[]>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productControllerSearchProduct>>,
    TError,
    { data: BodyType<SearchProductRequestDTO> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof productControllerSearchProduct>>,
  TError,
  { data: BodyType<SearchProductRequestDTO> },
  TContext
> => {
  const mutationKey = ["productControllerSearchProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof productControllerSearchProduct>>,
    { data: BodyType<SearchProductRequestDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return productControllerSearchProduct(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProductControllerSearchProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof productControllerSearchProduct>>
>;
export type ProductControllerSearchProductMutationBody = BodyType<SearchProductRequestDTO>;
export type ProductControllerSearchProductMutationError = ErrorType<SearchProductResponseDTO[]>;

/**
 * @summary Поиск товара по sku, общему артиклю или названию
 */
export const useProductControllerSearchProduct = <
  TError = ErrorType<SearchProductResponseDTO[]>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productControllerSearchProduct>>,
    TError,
    { data: BodyType<SearchProductRequestDTO> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof productControllerSearchProduct>>,
  TError,
  { data: BodyType<SearchProductRequestDTO> },
  TContext
> => {
  const mutationOptions = getProductControllerSearchProductMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @deprecated
 */
export const productControllerSaveNewProducts = (
  productControllerSaveNewProductsBody: BodyType<string[]>,
  signal?: AbortSignal
) => {
  return createInstance<void>({
    url: `/api/product/saveNewProducts`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: productControllerSaveNewProductsBody,
    signal,
  });
};

export const getProductControllerSaveNewProductsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productControllerSaveNewProducts>>,
    TError,
    { data: BodyType<string[]> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof productControllerSaveNewProducts>>,
  TError,
  { data: BodyType<string[]> },
  TContext
> => {
  const mutationKey = ["productControllerSaveNewProducts"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof productControllerSaveNewProducts>>,
    { data: BodyType<string[]> }
  > = (props) => {
    const { data } = props ?? {};

    return productControllerSaveNewProducts(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProductControllerSaveNewProductsMutationResult = NonNullable<
  Awaited<ReturnType<typeof productControllerSaveNewProducts>>
>;
export type ProductControllerSaveNewProductsMutationBody = BodyType<string[]>;
export type ProductControllerSaveNewProductsMutationError = ErrorType<unknown>;

/**
 * @deprecated
 */
export const useProductControllerSaveNewProducts = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productControllerSaveNewProducts>>,
    TError,
    { data: BodyType<string[]> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof productControllerSaveNewProducts>>,
  TError,
  { data: BodyType<string[]> },
  TContext
> => {
  const mutationOptions = getProductControllerSaveNewProductsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Получение списка не назначенных никому продуктов
 */
export const productControllerGetUnassignedProducts = (signal?: AbortSignal) => {
  return createInstance<GetUnassignedProductsDTO[]>({
    url: `/api/product/getUnassignedProducts`,
    method: "GET",
    signal,
  });
};

export const getProductControllerGetUnassignedProductsQueryKey = () => {
  return [`/api/product/getUnassignedProducts`] as const;
};

export const getProductControllerGetUnassignedProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProductControllerGetUnassignedProductsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>
  > = ({ signal }) => productControllerGetUnassignedProducts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ProductControllerGetUnassignedProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>
>;
export type ProductControllerGetUnassignedProductsQueryError = ErrorType<unknown>;

export function useProductControllerGetUnassignedProducts<
  TData = Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>,
        TError,
        Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProductControllerGetUnassignedProducts<
  TData = Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>,
        TError,
        Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProductControllerGetUnassignedProducts<
  TData = Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение списка не назначенных никому продуктов
 */

export function useProductControllerGetUnassignedProducts<
  TData = Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof productControllerGetUnassignedProducts>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getProductControllerGetUnassignedProductsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const categoryControllerGetAll = (signal?: AbortSignal) => {
  return createInstance<ArticleCategoryResponse[]>({ url: `/api/category`, method: "GET", signal });
};

export const getCategoryControllerGetAllQueryKey = () => {
  return [`/api/category`] as const;
};

export const getCategoryControllerGetAllQueryOptions = <
  TData = Awaited<ReturnType<typeof categoryControllerGetAll>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof categoryControllerGetAll>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCategoryControllerGetAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof categoryControllerGetAll>>> = ({
    signal,
  }) => categoryControllerGetAll(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof categoryControllerGetAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CategoryControllerGetAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof categoryControllerGetAll>>
>;
export type CategoryControllerGetAllQueryError = ErrorType<unknown>;

export function useCategoryControllerGetAll<
  TData = Awaited<ReturnType<typeof categoryControllerGetAll>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof categoryControllerGetAll>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof categoryControllerGetAll>>,
        TError,
        Awaited<ReturnType<typeof categoryControllerGetAll>>
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCategoryControllerGetAll<
  TData = Awaited<ReturnType<typeof categoryControllerGetAll>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof categoryControllerGetAll>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof categoryControllerGetAll>>,
        TError,
        Awaited<ReturnType<typeof categoryControllerGetAll>>
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCategoryControllerGetAll<
  TData = Awaited<ReturnType<typeof categoryControllerGetAll>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof categoryControllerGetAll>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useCategoryControllerGetAll<
  TData = Awaited<ReturnType<typeof categoryControllerGetAll>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof categoryControllerGetAll>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCategoryControllerGetAllQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить категории для портфелей
 */
export const categoryControllerGetOptions = (
  params?: CategoryControllerGetOptionsParams,
  signal?: AbortSignal
) => {
  return createInstance<OptionsCompetitorResponse[]>({
    url: `/api/category/by-briefcase`,
    method: "GET",
    params,
    signal,
  });
};

export const getCategoryControllerGetOptionsQueryKey = (
  params?: CategoryControllerGetOptionsParams
) => {
  return [`/api/category/by-briefcase`, ...(params ? [params] : [])] as const;
};

export const getCategoryControllerGetOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof categoryControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(
  params?: CategoryControllerGetOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof categoryControllerGetOptions>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCategoryControllerGetOptionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof categoryControllerGetOptions>>> = ({
    signal,
  }) => categoryControllerGetOptions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof categoryControllerGetOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CategoryControllerGetOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof categoryControllerGetOptions>>
>;
export type CategoryControllerGetOptionsQueryError = ErrorType<unknown>;

export function useCategoryControllerGetOptions<
  TData = Awaited<ReturnType<typeof categoryControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | CategoryControllerGetOptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof categoryControllerGetOptions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof categoryControllerGetOptions>>,
          TError,
          Awaited<ReturnType<typeof categoryControllerGetOptions>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCategoryControllerGetOptions<
  TData = Awaited<ReturnType<typeof categoryControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(
  params?: CategoryControllerGetOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof categoryControllerGetOptions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof categoryControllerGetOptions>>,
          TError,
          Awaited<ReturnType<typeof categoryControllerGetOptions>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCategoryControllerGetOptions<
  TData = Awaited<ReturnType<typeof categoryControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(
  params?: CategoryControllerGetOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof categoryControllerGetOptions>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получить категории для портфелей
 */

export function useCategoryControllerGetOptions<
  TData = Awaited<ReturnType<typeof categoryControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(
  params?: CategoryControllerGetOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof categoryControllerGetOptions>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCategoryControllerGetOptionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const ratingControllerGetProductRatingHistory = (
  productId: number,
  params?: RatingControllerGetProductRatingHistoryParams,
  signal?: AbortSignal
) => {
  return createInstance<GetProductRatingHistoryResponseDTO>({
    url: `/api/rating/getProductRatingHistory/${productId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getRatingControllerGetProductRatingHistoryQueryKey = (
  productId: number,
  params?: RatingControllerGetProductRatingHistoryParams
) => {
  return [`/api/rating/getProductRatingHistory/${productId}`, ...(params ? [params] : [])] as const;
};

export const getRatingControllerGetProductRatingHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: RatingControllerGetProductRatingHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRatingControllerGetProductRatingHistoryQueryKey(productId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>
  > = ({ signal }) => ratingControllerGetProductRatingHistory(productId, params, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type RatingControllerGetProductRatingHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>
>;
export type RatingControllerGetProductRatingHistoryQueryError = ErrorType<unknown>;

export function useRatingControllerGetProductRatingHistory<
  TData = Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: undefined | RatingControllerGetProductRatingHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>,
          TError,
          Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useRatingControllerGetProductRatingHistory<
  TData = Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: RatingControllerGetProductRatingHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>,
          TError,
          Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useRatingControllerGetProductRatingHistory<
  TData = Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: RatingControllerGetProductRatingHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useRatingControllerGetProductRatingHistory<
  TData = Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: RatingControllerGetProductRatingHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ratingControllerGetProductRatingHistory>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getRatingControllerGetProductRatingHistoryQueryOptions(
    productId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Назначение менеджеру продуктов
 */
export const managerAppointmentControllerAppointManager = (
  appointManagerDTO: BodyType<AppointManagerDTO>,
  signal?: AbortSignal
) => {
  return createInstance<StatusResponseDTO>({
    url: `/api/products/appointManager`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: appointManagerDTO,
    signal,
  });
};

export const getManagerAppointmentControllerAppointManagerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managerAppointmentControllerAppointManager>>,
    TError,
    { data: BodyType<AppointManagerDTO> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managerAppointmentControllerAppointManager>>,
  TError,
  { data: BodyType<AppointManagerDTO> },
  TContext
> => {
  const mutationKey = ["managerAppointmentControllerAppointManager"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managerAppointmentControllerAppointManager>>,
    { data: BodyType<AppointManagerDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return managerAppointmentControllerAppointManager(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagerAppointmentControllerAppointManagerMutationResult = NonNullable<
  Awaited<ReturnType<typeof managerAppointmentControllerAppointManager>>
>;
export type ManagerAppointmentControllerAppointManagerMutationBody = BodyType<AppointManagerDTO>;
export type ManagerAppointmentControllerAppointManagerMutationError = ErrorType<unknown>;

/**
 * @summary Назначение менеджеру продуктов
 */
export const useManagerAppointmentControllerAppointManager = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managerAppointmentControllerAppointManager>>,
    TError,
    { data: BodyType<AppointManagerDTO> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managerAppointmentControllerAppointManager>>,
  TError,
  { data: BodyType<AppointManagerDTO> },
  TContext
> => {
  const mutationOptions = getManagerAppointmentControllerAppointManagerMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Добавление / удаление продукта в избранное (только назначенный продукту менеджер или босс)
 */
export const managerAppointmentControllerUpdateFavorite = (
  productId: unknown,
  updateFavoriteRequestDTO: BodyType<UpdateFavoriteRequestDTO>,
  signal?: AbortSignal
) => {
  return createInstance<UpdateFavoriteResponseDTO>({
    url: `/api/products/updateFavorite/${productId}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateFavoriteRequestDTO,
    signal,
  });
};

export const getManagerAppointmentControllerUpdateFavoriteMutationOptions = <
  TError = ErrorType<UpdateFavoriteResponseDTO>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managerAppointmentControllerUpdateFavorite>>,
    TError,
    { productId: unknown; data: BodyType<UpdateFavoriteRequestDTO> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managerAppointmentControllerUpdateFavorite>>,
  TError,
  { productId: unknown; data: BodyType<UpdateFavoriteRequestDTO> },
  TContext
> => {
  const mutationKey = ["managerAppointmentControllerUpdateFavorite"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managerAppointmentControllerUpdateFavorite>>,
    { productId: unknown; data: BodyType<UpdateFavoriteRequestDTO> }
  > = (props) => {
    const { productId, data } = props ?? {};

    return managerAppointmentControllerUpdateFavorite(productId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagerAppointmentControllerUpdateFavoriteMutationResult = NonNullable<
  Awaited<ReturnType<typeof managerAppointmentControllerUpdateFavorite>>
>;
export type ManagerAppointmentControllerUpdateFavoriteMutationBody =
  BodyType<UpdateFavoriteRequestDTO>;
export type ManagerAppointmentControllerUpdateFavoriteMutationError =
  ErrorType<UpdateFavoriteResponseDTO>;

/**
 * @summary Добавление / удаление продукта в избранное (только назначенный продукту менеджер или босс)
 */
export const useManagerAppointmentControllerUpdateFavorite = <
  TError = ErrorType<UpdateFavoriteResponseDTO>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managerAppointmentControllerUpdateFavorite>>,
    TError,
    { productId: unknown; data: BodyType<UpdateFavoriteRequestDTO> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managerAppointmentControllerUpdateFavorite>>,
  TError,
  { productId: unknown; data: BodyType<UpdateFavoriteRequestDTO> },
  TContext
> => {
  const mutationOptions = getManagerAppointmentControllerUpdateFavoriteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Оставить комментарий к продукту
 */
export const commentControllerCreateComment = (
  createCommentDTO: BodyType<CreateCommentDTO>,
  signal?: AbortSignal
) => {
  return createInstance<StatusResponseDTO>({
    url: `/api/comment/create`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createCommentDTO,
    signal,
  });
};

export const getCommentControllerCreateCommentMutationOptions = <
  TError = ErrorType<StatusResponseDTO>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof commentControllerCreateComment>>,
    TError,
    { data: BodyType<CreateCommentDTO> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof commentControllerCreateComment>>,
  TError,
  { data: BodyType<CreateCommentDTO> },
  TContext
> => {
  const mutationKey = ["commentControllerCreateComment"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof commentControllerCreateComment>>,
    { data: BodyType<CreateCommentDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return commentControllerCreateComment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CommentControllerCreateCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof commentControllerCreateComment>>
>;
export type CommentControllerCreateCommentMutationBody = BodyType<CreateCommentDTO>;
export type CommentControllerCreateCommentMutationError = ErrorType<StatusResponseDTO>;

/**
 * @summary Оставить комментарий к продукту
 */
export const useCommentControllerCreateComment = <
  TError = ErrorType<StatusResponseDTO>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof commentControllerCreateComment>>,
    TError,
    { data: BodyType<CreateCommentDTO> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof commentControllerCreateComment>>,
  TError,
  { data: BodyType<CreateCommentDTO> },
  TContext
> => {
  const mutationOptions = getCommentControllerCreateCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Получить все комментарии по продукту
 */
export const commentControllerGetCommentsForProduct = (productId: number, signal?: AbortSignal) => {
  return createInstance<GetCommentResponseDTO[]>({
    url: `/api/comment/${productId}`,
    method: "GET",
    signal,
  });
};

export const getCommentControllerGetCommentsForProductQueryKey = (productId: number) => {
  return [`/api/comment/${productId}`] as const;
};

export const getCommentControllerGetCommentsForProductQueryOptions = <
  TData = Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>,
  TError = ErrorType<GetCommentResponseDTO[]>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCommentControllerGetCommentsForProductQueryKey(productId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>
  > = ({ signal }) => commentControllerGetCommentsForProduct(productId, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CommentControllerGetCommentsForProductQueryResult = NonNullable<
  Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>
>;
export type CommentControllerGetCommentsForProductQueryError = ErrorType<GetCommentResponseDTO[]>;

export function useCommentControllerGetCommentsForProduct<
  TData = Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>,
  TError = ErrorType<GetCommentResponseDTO[]>,
>(
  productId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>,
          TError,
          Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCommentControllerGetCommentsForProduct<
  TData = Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>,
  TError = ErrorType<GetCommentResponseDTO[]>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>,
          TError,
          Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCommentControllerGetCommentsForProduct<
  TData = Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>,
  TError = ErrorType<GetCommentResponseDTO[]>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получить все комментарии по продукту
 */

export function useCommentControllerGetCommentsForProduct<
  TData = Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>,
  TError = ErrorType<GetCommentResponseDTO[]>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof commentControllerGetCommentsForProduct>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCommentControllerGetCommentsForProductQueryOptions(productId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const dagControllerNotifyDagFinished = (signal?: AbortSignal) => {
  return createInstance<void>({ url: `/api/dag/notifyDagFinished`, method: "POST", signal });
};

export const getDagControllerNotifyDagFinishedMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dagControllerNotifyDagFinished>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dagControllerNotifyDagFinished>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["dagControllerNotifyDagFinished"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dagControllerNotifyDagFinished>>,
    void
  > = () => {
    return dagControllerNotifyDagFinished();
  };

  return { mutationFn, ...mutationOptions };
};

export type DagControllerNotifyDagFinishedMutationResult = NonNullable<
  Awaited<ReturnType<typeof dagControllerNotifyDagFinished>>
>;

export type DagControllerNotifyDagFinishedMutationError = ErrorType<unknown>;

export const useDagControllerNotifyDagFinished = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dagControllerNotifyDagFinished>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dagControllerNotifyDagFinished>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDagControllerNotifyDagFinishedMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Получение дашборда
 */
export const dashboardControllerGetDashboard = (productId: number, signal?: AbortSignal) => {
  return createInstance<DashboardResponseDTO>({
    url: `/api/dashboard/getDashboard/${productId}`,
    method: "GET",
    signal,
  });
};

export const getDashboardControllerGetDashboardQueryKey = (productId: number) => {
  return [`/api/dashboard/getDashboard/${productId}`] as const;
};

export const getDashboardControllerGetDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardControllerGetDashboard>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardControllerGetDashboard>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardControllerGetDashboardQueryKey(productId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardControllerGetDashboard>>> = ({
    signal,
  }) => dashboardControllerGetDashboard(productId, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardControllerGetDashboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardControllerGetDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardControllerGetDashboard>>
>;
export type DashboardControllerGetDashboardQueryError = ErrorType<unknown>;

export function useDashboardControllerGetDashboard<
  TData = Awaited<ReturnType<typeof dashboardControllerGetDashboard>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardControllerGetDashboard>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardControllerGetDashboard>>,
          TError,
          Awaited<ReturnType<typeof dashboardControllerGetDashboard>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardControllerGetDashboard<
  TData = Awaited<ReturnType<typeof dashboardControllerGetDashboard>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardControllerGetDashboard>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardControllerGetDashboard>>,
          TError,
          Awaited<ReturnType<typeof dashboardControllerGetDashboard>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardControllerGetDashboard<
  TData = Awaited<ReturnType<typeof dashboardControllerGetDashboard>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardControllerGetDashboard>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение дашборда
 */

export function useDashboardControllerGetDashboard<
  TData = Awaited<ReturnType<typeof dashboardControllerGetDashboard>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardControllerGetDashboard>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardControllerGetDashboardQueryOptions(productId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const netProfitControllerGetNetProfitsHistoryFprProducts = (
  getNetProfitRequest: BodyType<GetNetProfitRequest[]>,
  params?: NetProfitControllerGetNetProfitsHistoryFprProductsParams,
  signal?: AbortSignal
) => {
  return createInstance<void>({
    url: `/api/netProfit/getNetProfitsHistoryForProducts`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: getNetProfitRequest,
    params,
    signal,
  });
};

export const getNetProfitControllerGetNetProfitsHistoryFprProductsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof netProfitControllerGetNetProfitsHistoryFprProducts>>,
    TError,
    {
      data: BodyType<GetNetProfitRequest[]>;
      params?: NetProfitControllerGetNetProfitsHistoryFprProductsParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof netProfitControllerGetNetProfitsHistoryFprProducts>>,
  TError,
  {
    data: BodyType<GetNetProfitRequest[]>;
    params?: NetProfitControllerGetNetProfitsHistoryFprProductsParams;
  },
  TContext
> => {
  const mutationKey = ["netProfitControllerGetNetProfitsHistoryFprProducts"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof netProfitControllerGetNetProfitsHistoryFprProducts>>,
    {
      data: BodyType<GetNetProfitRequest[]>;
      params?: NetProfitControllerGetNetProfitsHistoryFprProductsParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return netProfitControllerGetNetProfitsHistoryFprProducts(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type NetProfitControllerGetNetProfitsHistoryFprProductsMutationResult = NonNullable<
  Awaited<ReturnType<typeof netProfitControllerGetNetProfitsHistoryFprProducts>>
>;
export type NetProfitControllerGetNetProfitsHistoryFprProductsMutationBody = BodyType<
  GetNetProfitRequest[]
>;
export type NetProfitControllerGetNetProfitsHistoryFprProductsMutationError = ErrorType<unknown>;

export const useNetProfitControllerGetNetProfitsHistoryFprProducts = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof netProfitControllerGetNetProfitsHistoryFprProducts>>,
    TError,
    {
      data: BodyType<GetNetProfitRequest[]>;
      params?: NetProfitControllerGetNetProfitsHistoryFprProductsParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof netProfitControllerGetNetProfitsHistoryFprProducts>>,
  TError,
  {
    data: BodyType<GetNetProfitRequest[]>;
    params?: NetProfitControllerGetNetProfitsHistoryFprProductsParams;
  },
  TContext
> => {
  const mutationOptions =
    getNetProfitControllerGetNetProfitsHistoryFprProductsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Получение истории заказов / возвратов / refund-ов по карточке продукта
 */
export const orderHistoryControllerGetOrderHistoryForProduct = (
  productId: number,
  params: OrderHistoryControllerGetOrderHistoryForProductParams,
  signal?: AbortSignal
) => {
  return createInstance<GetOrderHistoryForProductResponseDTO>({
    url: `/api/orders/getOrderHistoryForProduct/${productId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getOrderHistoryControllerGetOrderHistoryForProductQueryKey = (
  productId: number,
  params: OrderHistoryControllerGetOrderHistoryForProductParams
) => {
  return [
    `/api/orders/getOrderHistoryForProduct/${productId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getOrderHistoryControllerGetOrderHistoryForProductQueryOptions = <
  TData = Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: OrderHistoryControllerGetOrderHistoryForProductParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getOrderHistoryControllerGetOrderHistoryForProductQueryKey(productId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>
  > = ({ signal }) => orderHistoryControllerGetOrderHistoryForProduct(productId, params, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type OrderHistoryControllerGetOrderHistoryForProductQueryResult = NonNullable<
  Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>
>;
export type OrderHistoryControllerGetOrderHistoryForProductQueryError = ErrorType<unknown>;

export function useOrderHistoryControllerGetOrderHistoryForProduct<
  TData = Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: OrderHistoryControllerGetOrderHistoryForProductParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>,
          TError,
          Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useOrderHistoryControllerGetOrderHistoryForProduct<
  TData = Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: OrderHistoryControllerGetOrderHistoryForProductParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>,
          TError,
          Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useOrderHistoryControllerGetOrderHistoryForProduct<
  TData = Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: OrderHistoryControllerGetOrderHistoryForProductParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение истории заказов / возвратов / refund-ов по карточке продукта
 */

export function useOrderHistoryControllerGetOrderHistoryForProduct<
  TData = Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: OrderHistoryControllerGetOrderHistoryForProductParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof orderHistoryControllerGetOrderHistoryForProduct>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getOrderHistoryControllerGetOrderHistoryForProductQueryOptions(
    productId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получение истории цен товара в текущем месяце
 */
export const productReportControllerGetProductPriceHistory = (
  id: number,
  params?: ProductReportControllerGetProductPriceHistoryParams,
  signal?: AbortSignal
) => {
  return createInstance<GetProductPriceHistoryResponseDTO>({
    url: `/api/product/productPriceHistory/${id}`,
    method: "GET",
    params,
    signal,
  });
};

export const getProductReportControllerGetProductPriceHistoryQueryKey = (
  id: number,
  params?: ProductReportControllerGetProductPriceHistoryParams
) => {
  return [`/api/product/productPriceHistory/${id}`, ...(params ? [params] : [])] as const;
};

export const getProductReportControllerGetProductPriceHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: ProductReportControllerGetProductPriceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getProductReportControllerGetProductPriceHistoryQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>
  > = ({ signal }) => productReportControllerGetProductPriceHistory(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ProductReportControllerGetProductPriceHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>
>;
export type ProductReportControllerGetProductPriceHistoryQueryError = ErrorType<unknown>;

export function useProductReportControllerGetProductPriceHistory<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params: undefined | ProductReportControllerGetProductPriceHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>,
          TError,
          Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProductReportControllerGetProductPriceHistory<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: ProductReportControllerGetProductPriceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>,
          TError,
          Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProductReportControllerGetProductPriceHistory<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: ProductReportControllerGetProductPriceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение истории цен товара в текущем месяце
 */

export function useProductReportControllerGetProductPriceHistory<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: ProductReportControllerGetProductPriceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductPriceHistory>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getProductReportControllerGetProductPriceHistoryQueryOptions(
    id,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получение сводки по карточке
 */
export const productReportControllerGetProductCardSummary = (
  productId: number,
  params?: ProductReportControllerGetProductCardSummaryParams,
  signal?: AbortSignal
) => {
  return createInstance<GetProductCardSummaryResponseDTO>({
    url: `/api/product/getProductCardSummary/${productId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getProductReportControllerGetProductCardSummaryQueryKey = (
  productId: number,
  params?: ProductReportControllerGetProductCardSummaryParams
) => {
  return [`/api/product/getProductCardSummary/${productId}`, ...(params ? [params] : [])] as const;
};

export const getProductReportControllerGetProductCardSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetProductCardSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getProductReportControllerGetProductCardSummaryQueryKey(productId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>
  > = ({ signal }) => productReportControllerGetProductCardSummary(productId, params, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ProductReportControllerGetProductCardSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>
>;
export type ProductReportControllerGetProductCardSummaryQueryError = ErrorType<unknown>;

export function useProductReportControllerGetProductCardSummary<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: undefined | ProductReportControllerGetProductCardSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>,
          TError,
          Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProductReportControllerGetProductCardSummary<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetProductCardSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>,
          TError,
          Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProductReportControllerGetProductCardSummary<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetProductCardSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение сводки по карточке
 */

export function useProductReportControllerGetProductCardSummary<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetProductCardSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardSummary>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getProductReportControllerGetProductCardSummaryQueryOptions(
    productId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получение сводки по карточке
 */
export const productReportControllerGetProductCardReport = (
  productId: number,
  params?: ProductReportControllerGetProductCardReportParams,
  signal?: AbortSignal
) => {
  return createInstance<GetProductCardReportResponseDTO>({
    url: `/api/product/getProductCardReport/${productId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getProductReportControllerGetProductCardReportQueryKey = (
  productId: number,
  params?: ProductReportControllerGetProductCardReportParams
) => {
  return [`/api/product/getProductCardReport/${productId}`, ...(params ? [params] : [])] as const;
};

export const getProductReportControllerGetProductCardReportQueryOptions = <
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetProductCardReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getProductReportControllerGetProductCardReportQueryKey(productId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>
  > = ({ signal }) => productReportControllerGetProductCardReport(productId, params, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ProductReportControllerGetProductCardReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>
>;
export type ProductReportControllerGetProductCardReportQueryError = ErrorType<unknown>;

export function useProductReportControllerGetProductCardReport<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: undefined | ProductReportControllerGetProductCardReportParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>,
          TError,
          Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProductReportControllerGetProductCardReport<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetProductCardReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>,
          TError,
          Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProductReportControllerGetProductCardReport<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetProductCardReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение сводки по карточке
 */

export function useProductReportControllerGetProductCardReport<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetProductCardReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardReport>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getProductReportControllerGetProductCardReportQueryOptions(
    productId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получение экономики по карточке
 */
export const productReportControllerGetProductCardEconomy = (
  productId: number,
  params?: ProductReportControllerGetProductCardEconomyParams,
  signal?: AbortSignal
) => {
  return createInstance<GetProductCardEconomyResponseDTO>({
    url: `/api/product/getProductCardEconomy/${productId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getProductReportControllerGetProductCardEconomyQueryKey = (
  productId: number,
  params?: ProductReportControllerGetProductCardEconomyParams
) => {
  return [`/api/product/getProductCardEconomy/${productId}`, ...(params ? [params] : [])] as const;
};

export const getProductReportControllerGetProductCardEconomyQueryOptions = <
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetProductCardEconomyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getProductReportControllerGetProductCardEconomyQueryKey(productId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>
  > = ({ signal }) => productReportControllerGetProductCardEconomy(productId, params, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ProductReportControllerGetProductCardEconomyQueryResult = NonNullable<
  Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>
>;
export type ProductReportControllerGetProductCardEconomyQueryError = ErrorType<unknown>;

export function useProductReportControllerGetProductCardEconomy<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: undefined | ProductReportControllerGetProductCardEconomyParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>,
          TError,
          Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProductReportControllerGetProductCardEconomy<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetProductCardEconomyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>,
          TError,
          Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProductReportControllerGetProductCardEconomy<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetProductCardEconomyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение экономики по карточке
 */

export function useProductReportControllerGetProductCardEconomy<
  TData = Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetProductCardEconomyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetProductCardEconomy>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getProductReportControllerGetProductCardEconomyQueryOptions(
    productId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const productReportControllerGetPurchaseFunnel = (
  productId: number,
  params?: ProductReportControllerGetPurchaseFunnelParams,
  signal?: AbortSignal
) => {
  return createInstance<GetPurchaseFunnelResponseDTO>({
    url: `/api/product/getPurchaseFunnel/${productId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getProductReportControllerGetPurchaseFunnelQueryKey = (
  productId: number,
  params?: ProductReportControllerGetPurchaseFunnelParams
) => {
  return [`/api/product/getPurchaseFunnel/${productId}`, ...(params ? [params] : [])] as const;
};

export const getProductReportControllerGetPurchaseFunnelQueryOptions = <
  TData = Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetPurchaseFunnelParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getProductReportControllerGetPurchaseFunnelQueryKey(productId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>
  > = ({ signal }) => productReportControllerGetPurchaseFunnel(productId, params, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ProductReportControllerGetPurchaseFunnelQueryResult = NonNullable<
  Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>
>;
export type ProductReportControllerGetPurchaseFunnelQueryError = ErrorType<unknown>;

export function useProductReportControllerGetPurchaseFunnel<
  TData = Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: undefined | ProductReportControllerGetPurchaseFunnelParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>,
          TError,
          Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProductReportControllerGetPurchaseFunnel<
  TData = Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetPurchaseFunnelParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>,
          TError,
          Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useProductReportControllerGetPurchaseFunnel<
  TData = Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetPurchaseFunnelParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useProductReportControllerGetPurchaseFunnel<
  TData = Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params?: ProductReportControllerGetPurchaseFunnelParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productReportControllerGetPurchaseFunnel>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getProductReportControllerGetPurchaseFunnelQueryOptions(
    productId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Выбор логов по параметрам
 */
export const requestLoggerControllerGet = (
  params?: RequestLoggerControllerGetParams,
  signal?: AbortSignal
) => {
  return createInstance<LogPaginatedResponse>({
    url: `/api/request-logger`,
    method: "GET",
    params,
    signal,
  });
};

export const getRequestLoggerControllerGetQueryKey = (
  params?: RequestLoggerControllerGetParams
) => {
  return [`/api/request-logger`, ...(params ? [params] : [])] as const;
};

export const getRequestLoggerControllerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof requestLoggerControllerGet>>,
  TError = ErrorType<void>,
>(
  params?: RequestLoggerControllerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof requestLoggerControllerGet>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRequestLoggerControllerGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof requestLoggerControllerGet>>> = ({
    signal,
  }) => requestLoggerControllerGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof requestLoggerControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type RequestLoggerControllerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof requestLoggerControllerGet>>
>;
export type RequestLoggerControllerGetQueryError = ErrorType<void>;

export function useRequestLoggerControllerGet<
  TData = Awaited<ReturnType<typeof requestLoggerControllerGet>>,
  TError = ErrorType<void>,
>(
  params: undefined | RequestLoggerControllerGetParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof requestLoggerControllerGet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof requestLoggerControllerGet>>,
          TError,
          Awaited<ReturnType<typeof requestLoggerControllerGet>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useRequestLoggerControllerGet<
  TData = Awaited<ReturnType<typeof requestLoggerControllerGet>>,
  TError = ErrorType<void>,
>(
  params?: RequestLoggerControllerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof requestLoggerControllerGet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof requestLoggerControllerGet>>,
          TError,
          Awaited<ReturnType<typeof requestLoggerControllerGet>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useRequestLoggerControllerGet<
  TData = Awaited<ReturnType<typeof requestLoggerControllerGet>>,
  TError = ErrorType<void>,
>(
  params?: RequestLoggerControllerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof requestLoggerControllerGet>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Выбор логов по параметрам
 */

export function useRequestLoggerControllerGet<
  TData = Awaited<ReturnType<typeof requestLoggerControllerGet>>,
  TError = ErrorType<void>,
>(
  params?: RequestLoggerControllerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof requestLoggerControllerGet>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getRequestLoggerControllerGetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Ревью за период
 */
export const reviewControllerGetInfoByBriefcaseForPeriod = (
  params: ReviewControllerGetInfoByBriefcaseForPeriodParams,
  signal?: AbortSignal
) => {
  return createInstance<ReviewsByBriefcaseResponseDto[]>({
    url: `/api/review/getAllForPeriod`,
    method: "GET",
    params,
    signal,
  });
};

export const getReviewControllerGetInfoByBriefcaseForPeriodQueryKey = (
  params: ReviewControllerGetInfoByBriefcaseForPeriodParams
) => {
  return [`/api/review/getAllForPeriod`, ...(params ? [params] : [])] as const;
};

export const getReviewControllerGetInfoByBriefcaseForPeriodQueryOptions = <
  TData = Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetInfoByBriefcaseForPeriodParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReviewControllerGetInfoByBriefcaseForPeriodQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>
  > = ({ signal }) => reviewControllerGetInfoByBriefcaseForPeriod(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ReviewControllerGetInfoByBriefcaseForPeriodQueryResult = NonNullable<
  Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>
>;
export type ReviewControllerGetInfoByBriefcaseForPeriodQueryError = ErrorType<unknown>;

export function useReviewControllerGetInfoByBriefcaseForPeriod<
  TData = Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetInfoByBriefcaseForPeriodParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>,
          TError,
          Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useReviewControllerGetInfoByBriefcaseForPeriod<
  TData = Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetInfoByBriefcaseForPeriodParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>,
          TError,
          Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useReviewControllerGetInfoByBriefcaseForPeriod<
  TData = Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetInfoByBriefcaseForPeriodParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Ревью за период
 */

export function useReviewControllerGetInfoByBriefcaseForPeriod<
  TData = Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetInfoByBriefcaseForPeriodParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reviewControllerGetInfoByBriefcaseForPeriod>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getReviewControllerGetInfoByBriefcaseForPeriodQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Ревью за период по артиклю
 */
export const reviewControllerGetInfoByGeneralArticle = (
  params: ReviewControllerGetInfoByGeneralArticleParams,
  signal?: AbortSignal
) => {
  return createInstance<ReviewByArticleResponse>({
    url: `/api/review/getByArticleForPeriod`,
    method: "GET",
    params,
    signal,
  });
};

export const getReviewControllerGetInfoByGeneralArticleQueryKey = (
  params: ReviewControllerGetInfoByGeneralArticleParams
) => {
  return [`/api/review/getByArticleForPeriod`, ...(params ? [params] : [])] as const;
};

export const getReviewControllerGetInfoByGeneralArticleQueryOptions = <
  TData = Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetInfoByGeneralArticleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReviewControllerGetInfoByGeneralArticleQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>
  > = ({ signal }) => reviewControllerGetInfoByGeneralArticle(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ReviewControllerGetInfoByGeneralArticleQueryResult = NonNullable<
  Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>
>;
export type ReviewControllerGetInfoByGeneralArticleQueryError = ErrorType<unknown>;

export function useReviewControllerGetInfoByGeneralArticle<
  TData = Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetInfoByGeneralArticleParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>,
          TError,
          Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useReviewControllerGetInfoByGeneralArticle<
  TData = Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetInfoByGeneralArticleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>,
          TError,
          Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useReviewControllerGetInfoByGeneralArticle<
  TData = Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetInfoByGeneralArticleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Ревью за период по артиклю
 */

export function useReviewControllerGetInfoByGeneralArticle<
  TData = Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetInfoByGeneralArticleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reviewControllerGetInfoByGeneralArticle>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getReviewControllerGetInfoByGeneralArticleQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Анализ комментариев
 */
export const reviewControllerGetTFIDF = (
  params: ReviewControllerGetTFIDFParams,
  signal?: AbortSignal
) => {
  return createInstance<WordCloudRes>({ url: `/api/review/tfidf`, method: "GET", params, signal });
};

export const getReviewControllerGetTFIDFQueryKey = (params: ReviewControllerGetTFIDFParams) => {
  return [`/api/review/tfidf`, ...(params ? [params] : [])] as const;
};

export const getReviewControllerGetTFIDFQueryOptions = <
  TData = Awaited<ReturnType<typeof reviewControllerGetTFIDF>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetTFIDFParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reviewControllerGetTFIDF>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReviewControllerGetTFIDFQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reviewControllerGetTFIDF>>> = ({
    signal,
  }) => reviewControllerGetTFIDF(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reviewControllerGetTFIDF>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ReviewControllerGetTFIDFQueryResult = NonNullable<
  Awaited<ReturnType<typeof reviewControllerGetTFIDF>>
>;
export type ReviewControllerGetTFIDFQueryError = ErrorType<unknown>;

export function useReviewControllerGetTFIDF<
  TData = Awaited<ReturnType<typeof reviewControllerGetTFIDF>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetTFIDFParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reviewControllerGetTFIDF>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewControllerGetTFIDF>>,
          TError,
          Awaited<ReturnType<typeof reviewControllerGetTFIDF>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useReviewControllerGetTFIDF<
  TData = Awaited<ReturnType<typeof reviewControllerGetTFIDF>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetTFIDFParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reviewControllerGetTFIDF>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewControllerGetTFIDF>>,
          TError,
          Awaited<ReturnType<typeof reviewControllerGetTFIDF>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useReviewControllerGetTFIDF<
  TData = Awaited<ReturnType<typeof reviewControllerGetTFIDF>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetTFIDFParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reviewControllerGetTFIDF>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Анализ комментариев
 */

export function useReviewControllerGetTFIDF<
  TData = Awaited<ReturnType<typeof reviewControllerGetTFIDF>>,
  TError = ErrorType<unknown>,
>(
  params: ReviewControllerGetTFIDFParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reviewControllerGetTFIDF>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getReviewControllerGetTFIDFQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получение категорий и статистики по входящим в них товаров
 */
export const tableControllerGetProductsOverview = (
  params?: TableControllerGetProductsOverviewParams,
  signal?: AbortSignal
) => {
  return createInstance<GetProductsOverviewResponseDTO[]>({
    url: `/api/general-category/getAll`,
    method: "GET",
    params,
    signal,
  });
};

export const getTableControllerGetProductsOverviewQueryKey = (
  params?: TableControllerGetProductsOverviewParams
) => {
  return [`/api/general-category/getAll`, ...(params ? [params] : [])] as const;
};

export const getTableControllerGetProductsOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof tableControllerGetProductsOverview>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetProductsOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tableControllerGetProductsOverview>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTableControllerGetProductsOverviewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tableControllerGetProductsOverview>>> = ({
    signal,
  }) => tableControllerGetProductsOverview(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tableControllerGetProductsOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TableControllerGetProductsOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof tableControllerGetProductsOverview>>
>;
export type TableControllerGetProductsOverviewQueryError = ErrorType<unknown>;

export function useTableControllerGetProductsOverview<
  TData = Awaited<ReturnType<typeof tableControllerGetProductsOverview>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | TableControllerGetProductsOverviewParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tableControllerGetProductsOverview>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tableControllerGetProductsOverview>>,
          TError,
          Awaited<ReturnType<typeof tableControllerGetProductsOverview>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTableControllerGetProductsOverview<
  TData = Awaited<ReturnType<typeof tableControllerGetProductsOverview>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetProductsOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tableControllerGetProductsOverview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tableControllerGetProductsOverview>>,
          TError,
          Awaited<ReturnType<typeof tableControllerGetProductsOverview>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTableControllerGetProductsOverview<
  TData = Awaited<ReturnType<typeof tableControllerGetProductsOverview>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetProductsOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tableControllerGetProductsOverview>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение категорий и статистики по входящим в них товаров
 */

export function useTableControllerGetProductsOverview<
  TData = Awaited<ReturnType<typeof tableControllerGetProductsOverview>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetProductsOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tableControllerGetProductsOverview>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTableControllerGetProductsOverviewQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получение категорий и остатков по входящим в них товарам
 */
export const tableControllerGetRemainingProducts = (
  params?: TableControllerGetRemainingProductsParams,
  signal?: AbortSignal
) => {
  return createInstance<GetRemainingProductsResponseDTO[]>({
    url: `/api/general-category/getRemainingProducts`,
    method: "GET",
    params,
    signal,
  });
};

export const getTableControllerGetRemainingProductsQueryKey = (
  params?: TableControllerGetRemainingProductsParams
) => {
  return [`/api/general-category/getRemainingProducts`, ...(params ? [params] : [])] as const;
};

export const getTableControllerGetRemainingProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetRemainingProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTableControllerGetRemainingProductsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>> = ({
    signal,
  }) => tableControllerGetRemainingProducts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TableControllerGetRemainingProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>
>;
export type TableControllerGetRemainingProductsQueryError = ErrorType<unknown>;

export function useTableControllerGetRemainingProducts<
  TData = Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | TableControllerGetRemainingProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>,
          TError,
          Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTableControllerGetRemainingProducts<
  TData = Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetRemainingProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>,
          TError,
          Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTableControllerGetRemainingProducts<
  TData = Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetRemainingProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение категорий и остатков по входящим в них товарам
 */

export function useTableControllerGetRemainingProducts<
  TData = Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetRemainingProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tableControllerGetRemainingProducts>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTableControllerGetRemainingProductsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получение категорий и истории заказов входящих в них продуктов
 */
export const tableControllerGetProductsOrderHistory = (
  params?: TableControllerGetProductsOrderHistoryParams,
  signal?: AbortSignal
) => {
  return createInstance<GetProductOrderHistoryWithManagerResponseDTO[]>({
    url: `/api/general-category/getProductsOrderHistory`,
    method: "GET",
    params,
    signal,
  });
};

export const getTableControllerGetProductsOrderHistoryQueryKey = (
  params?: TableControllerGetProductsOrderHistoryParams
) => {
  return [`/api/general-category/getProductsOrderHistory`, ...(params ? [params] : [])] as const;
};

export const getTableControllerGetProductsOrderHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetProductsOrderHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTableControllerGetProductsOrderHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>
  > = ({ signal }) => tableControllerGetProductsOrderHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TableControllerGetProductsOrderHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>
>;
export type TableControllerGetProductsOrderHistoryQueryError = ErrorType<unknown>;

export function useTableControllerGetProductsOrderHistory<
  TData = Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | TableControllerGetProductsOrderHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>,
          TError,
          Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTableControllerGetProductsOrderHistory<
  TData = Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetProductsOrderHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>,
          TError,
          Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTableControllerGetProductsOrderHistory<
  TData = Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetProductsOrderHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение категорий и истории заказов входящих в них продуктов
 */

export function useTableControllerGetProductsOrderHistory<
  TData = Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetProductsOrderHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tableControllerGetProductsOrderHistory>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTableControllerGetProductsOrderHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Получение информации о выручке / прибыли за каждый товар. Товары разбиты по категориям
 */
export const tableControllerGetRevenue = (
  params?: TableControllerGetRevenueParams,
  signal?: AbortSignal
) => {
  return createInstance<GetRevenuesResponseDTO[]>({
    url: `/api/general-category/getRevenue`,
    method: "GET",
    params,
    signal,
  });
};

export const getTableControllerGetRevenueQueryKey = (params?: TableControllerGetRevenueParams) => {
  return [`/api/general-category/getRevenue`, ...(params ? [params] : [])] as const;
};

export const getTableControllerGetRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof tableControllerGetRevenue>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetRevenueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tableControllerGetRevenue>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTableControllerGetRevenueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tableControllerGetRevenue>>> = ({
    signal,
  }) => tableControllerGetRevenue(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tableControllerGetRevenue>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TableControllerGetRevenueQueryResult = NonNullable<
  Awaited<ReturnType<typeof tableControllerGetRevenue>>
>;
export type TableControllerGetRevenueQueryError = ErrorType<unknown>;

export function useTableControllerGetRevenue<
  TData = Awaited<ReturnType<typeof tableControllerGetRevenue>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | TableControllerGetRevenueParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tableControllerGetRevenue>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tableControllerGetRevenue>>,
          TError,
          Awaited<ReturnType<typeof tableControllerGetRevenue>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTableControllerGetRevenue<
  TData = Awaited<ReturnType<typeof tableControllerGetRevenue>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetRevenueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tableControllerGetRevenue>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tableControllerGetRevenue>>,
          TError,
          Awaited<ReturnType<typeof tableControllerGetRevenue>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTableControllerGetRevenue<
  TData = Awaited<ReturnType<typeof tableControllerGetRevenue>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetRevenueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tableControllerGetRevenue>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useTableControllerGetRevenue<
  TData = Awaited<ReturnType<typeof tableControllerGetRevenue>>,
  TError = ErrorType<unknown>,
>(
  params?: TableControllerGetRevenueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tableControllerGetRevenue>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTableControllerGetRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получение данных для выборки
 */
export const marketShareControllerGetOptions = (signal?: AbortSignal) => {
  return createInstance<Options>({ url: `/api/market-share/options`, method: "GET", signal });
};

export const getMarketShareControllerGetOptionsQueryKey = () => {
  return [`/api/market-share/options`] as const;
};

export const getMarketShareControllerGetOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof marketShareControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof marketShareControllerGetOptions>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMarketShareControllerGetOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof marketShareControllerGetOptions>>> = ({
    signal,
  }) => marketShareControllerGetOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof marketShareControllerGetOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MarketShareControllerGetOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof marketShareControllerGetOptions>>
>;
export type MarketShareControllerGetOptionsQueryError = ErrorType<unknown>;

export function useMarketShareControllerGetOptions<
  TData = Awaited<ReturnType<typeof marketShareControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof marketShareControllerGetOptions>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof marketShareControllerGetOptions>>,
        TError,
        Awaited<ReturnType<typeof marketShareControllerGetOptions>>
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetOptions<
  TData = Awaited<ReturnType<typeof marketShareControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof marketShareControllerGetOptions>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof marketShareControllerGetOptions>>,
        TError,
        Awaited<ReturnType<typeof marketShareControllerGetOptions>>
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetOptions<
  TData = Awaited<ReturnType<typeof marketShareControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof marketShareControllerGetOptions>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение данных для выборки
 */

export function useMarketShareControllerGetOptions<
  TData = Awaited<ReturnType<typeof marketShareControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof marketShareControllerGetOptions>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMarketShareControllerGetOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Возвращает общую статистики доли рынка по портфелям для выбранных маркетплейсов за период
 * @summary Получение общей статистики доли рынка по портфелям
 */
export const marketShareControllerGetBriefcaseShareStats = (
  params: MarketShareControllerGetBriefcaseShareStatsParams,
  signal?: AbortSignal
) => {
  return createInstance<MarketShareStatsByBriefcaseResponse>({
    url: `/api/market-share/briefcase`,
    method: "GET",
    params,
    signal,
  });
};

export const getMarketShareControllerGetBriefcaseShareStatsQueryKey = (
  params: MarketShareControllerGetBriefcaseShareStatsParams
) => {
  return [`/api/market-share/briefcase`, ...(params ? [params] : [])] as const;
};

export const getMarketShareControllerGetBriefcaseShareStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetBriefcaseShareStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMarketShareControllerGetBriefcaseShareStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>
  > = ({ signal }) => marketShareControllerGetBriefcaseShareStats(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MarketShareControllerGetBriefcaseShareStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>
>;
export type MarketShareControllerGetBriefcaseShareStatsQueryError = ErrorType<unknown>;

export function useMarketShareControllerGetBriefcaseShareStats<
  TData = Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetBriefcaseShareStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetBriefcaseShareStats<
  TData = Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetBriefcaseShareStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetBriefcaseShareStats<
  TData = Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetBriefcaseShareStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение общей статистики доли рынка по портфелям
 */

export function useMarketShareControllerGetBriefcaseShareStats<
  TData = Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetBriefcaseShareStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetBriefcaseShareStats>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMarketShareControllerGetBriefcaseShareStatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Возвращает список брендов по доле рынка по портфелям
 * @summary Список брендов по доле рынка по портфелям
 */
export const marketShareControllerGetBriefcaseBrandList = (
  params: MarketShareControllerGetBriefcaseBrandListParams,
  signal?: AbortSignal
) => {
  return createInstance<BrandListByBriefcaseResponse>({
    url: `/api/market-share/brand-briefcase`,
    method: "GET",
    params,
    signal,
  });
};

export const getMarketShareControllerGetBriefcaseBrandListQueryKey = (
  params: MarketShareControllerGetBriefcaseBrandListParams
) => {
  return [`/api/market-share/brand-briefcase`, ...(params ? [params] : [])] as const;
};

export const getMarketShareControllerGetBriefcaseBrandListQueryOptions = <
  TData = Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetBriefcaseBrandListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMarketShareControllerGetBriefcaseBrandListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>
  > = ({ signal }) => marketShareControllerGetBriefcaseBrandList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MarketShareControllerGetBriefcaseBrandListQueryResult = NonNullable<
  Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>
>;
export type MarketShareControllerGetBriefcaseBrandListQueryError = ErrorType<unknown>;

export function useMarketShareControllerGetBriefcaseBrandList<
  TData = Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetBriefcaseBrandListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetBriefcaseBrandList<
  TData = Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetBriefcaseBrandListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetBriefcaseBrandList<
  TData = Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetBriefcaseBrandListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Список брендов по доле рынка по портфелям
 */

export function useMarketShareControllerGetBriefcaseBrandList<
  TData = Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetBriefcaseBrandListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetBriefcaseBrandList>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMarketShareControllerGetBriefcaseBrandListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Возвращает списков брендов по доле рынка для конкретных категорий и маркетплейсов за текущий и прошлый период
 * @summary Получение списков брендов по доле рынка по категориям за текущий и прошлый период
 */
export const marketShareControllerGetCategoryBrandList = (
  params: MarketShareControllerGetCategoryBrandListParams,
  signal?: AbortSignal
) => {
  return createInstance<BrandListByCategoryResponse>({
    url: `/api/market-share/brand-category`,
    method: "GET",
    params,
    signal,
  });
};

export const getMarketShareControllerGetCategoryBrandListQueryKey = (
  params: MarketShareControllerGetCategoryBrandListParams
) => {
  return [`/api/market-share/brand-category`, ...(params ? [params] : [])] as const;
};

export const getMarketShareControllerGetCategoryBrandListQueryOptions = <
  TData = Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetCategoryBrandListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMarketShareControllerGetCategoryBrandListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>
  > = ({ signal }) => marketShareControllerGetCategoryBrandList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MarketShareControllerGetCategoryBrandListQueryResult = NonNullable<
  Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>
>;
export type MarketShareControllerGetCategoryBrandListQueryError = ErrorType<unknown>;

export function useMarketShareControllerGetCategoryBrandList<
  TData = Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetCategoryBrandListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetCategoryBrandList<
  TData = Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetCategoryBrandListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetCategoryBrandList<
  TData = Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetCategoryBrandListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение списков брендов по доле рынка по категориям за текущий и прошлый период
 */

export function useMarketShareControllerGetCategoryBrandList<
  TData = Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetCategoryBrandListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetCategoryBrandList>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMarketShareControllerGetCategoryBrandListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Возвращает статистику доли по категориям рынка для конкретных категорий и маркетплейсов
 * @summary Получение статистики доли рынка по категориям
 */
export const marketShareControllerGetCategoryShareStats = (
  params: MarketShareControllerGetCategoryShareStatsParams,
  signal?: AbortSignal
) => {
  return createInstance<MarketShareByCategoryStatsResponse>({
    url: `/api/market-share/category`,
    method: "GET",
    params,
    signal,
  });
};

export const getMarketShareControllerGetCategoryShareStatsQueryKey = (
  params: MarketShareControllerGetCategoryShareStatsParams
) => {
  return [`/api/market-share/category`, ...(params ? [params] : [])] as const;
};

export const getMarketShareControllerGetCategoryShareStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetCategoryShareStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMarketShareControllerGetCategoryShareStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>
  > = ({ signal }) => marketShareControllerGetCategoryShareStats(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MarketShareControllerGetCategoryShareStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>
>;
export type MarketShareControllerGetCategoryShareStatsQueryError = ErrorType<unknown>;

export function useMarketShareControllerGetCategoryShareStats<
  TData = Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetCategoryShareStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetCategoryShareStats<
  TData = Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetCategoryShareStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetCategoryShareStats<
  TData = Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetCategoryShareStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение статистики доли рынка по категориям
 */

export function useMarketShareControllerGetCategoryShareStats<
  TData = Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetCategoryShareStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetCategoryShareStats>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMarketShareControllerGetCategoryShareStatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Расчетные данные по выбранному полю за период по маркетплейсам
 */
export const marketShareControllerGetPeriodValue = (
  params: MarketShareControllerGetPeriodValueParams,
  signal?: AbortSignal
) => {
  return createInstance<PeriodValueResponse[]>({
    url: `/api/market-share/marketplace-period`,
    method: "GET",
    params,
    signal,
  });
};

export const getMarketShareControllerGetPeriodValueQueryKey = (
  params: MarketShareControllerGetPeriodValueParams
) => {
  return [`/api/market-share/marketplace-period`, ...(params ? [params] : [])] as const;
};

export const getMarketShareControllerGetPeriodValueQueryOptions = <
  TData = Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetPeriodValueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMarketShareControllerGetPeriodValueQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>> = ({
    signal,
  }) => marketShareControllerGetPeriodValue(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MarketShareControllerGetPeriodValueQueryResult = NonNullable<
  Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>
>;
export type MarketShareControllerGetPeriodValueQueryError = ErrorType<unknown>;

export function useMarketShareControllerGetPeriodValue<
  TData = Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetPeriodValueParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetPeriodValue<
  TData = Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetPeriodValueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetPeriodValue<
  TData = Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetPeriodValueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Расчетные данные по выбранному полю за период по маркетплейсам
 */

export function useMarketShareControllerGetPeriodValue<
  TData = Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetPeriodValueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetPeriodValue>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMarketShareControllerGetPeriodValueQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Данные по ценовым сегментам
 */
export const marketShareControllerGetSegment = (
  params: MarketShareControllerGetSegmentParams,
  signal?: AbortSignal
) => {
  return createInstance<SegmentResponseDTO[]>({
    url: `/api/market-share/segment`,
    method: "GET",
    params,
    signal,
  });
};

export const getMarketShareControllerGetSegmentQueryKey = (
  params: MarketShareControllerGetSegmentParams
) => {
  return [`/api/market-share/segment`, ...(params ? [params] : [])] as const;
};

export const getMarketShareControllerGetSegmentQueryOptions = <
  TData = Awaited<ReturnType<typeof marketShareControllerGetSegment>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetSegmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof marketShareControllerGetSegment>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMarketShareControllerGetSegmentQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof marketShareControllerGetSegment>>> = ({
    signal,
  }) => marketShareControllerGetSegment(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof marketShareControllerGetSegment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MarketShareControllerGetSegmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof marketShareControllerGetSegment>>
>;
export type MarketShareControllerGetSegmentQueryError = ErrorType<unknown>;

export function useMarketShareControllerGetSegment<
  TData = Awaited<ReturnType<typeof marketShareControllerGetSegment>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetSegmentParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof marketShareControllerGetSegment>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetSegment>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetSegment>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetSegment<
  TData = Awaited<ReturnType<typeof marketShareControllerGetSegment>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetSegmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof marketShareControllerGetSegment>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetSegment>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetSegment>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetSegment<
  TData = Awaited<ReturnType<typeof marketShareControllerGetSegment>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetSegmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof marketShareControllerGetSegment>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Данные по ценовым сегментам
 */

export function useMarketShareControllerGetSegment<
  TData = Awaited<ReturnType<typeof marketShareControllerGetSegment>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetSegmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof marketShareControllerGetSegment>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMarketShareControllerGetSegmentQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Данные по ценовым сегментам в периоде
 */
export const marketShareControllerGetPeriodSegment = (
  params: MarketShareControllerGetPeriodSegmentParams,
  signal?: AbortSignal
) => {
  return createInstance<SegmentPeriodResponseDTO[]>({
    url: `/api/market-share/period-segment`,
    method: "GET",
    params,
    signal,
  });
};

export const getMarketShareControllerGetPeriodSegmentQueryKey = (
  params: MarketShareControllerGetPeriodSegmentParams
) => {
  return [`/api/market-share/period-segment`, ...(params ? [params] : [])] as const;
};

export const getMarketShareControllerGetPeriodSegmentQueryOptions = <
  TData = Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetPeriodSegmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMarketShareControllerGetPeriodSegmentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>
  > = ({ signal }) => marketShareControllerGetPeriodSegment(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MarketShareControllerGetPeriodSegmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>
>;
export type MarketShareControllerGetPeriodSegmentQueryError = ErrorType<unknown>;

export function useMarketShareControllerGetPeriodSegment<
  TData = Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetPeriodSegmentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetPeriodSegment<
  TData = Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetPeriodSegmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>,
          TError,
          Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMarketShareControllerGetPeriodSegment<
  TData = Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetPeriodSegmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Данные по ценовым сегментам в периоде
 */

export function useMarketShareControllerGetPeriodSegment<
  TData = Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>,
  TError = ErrorType<unknown>,
>(
  params: MarketShareControllerGetPeriodSegmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof marketShareControllerGetPeriodSegment>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMarketShareControllerGetPeriodSegmentQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Импорт данных о чужих скю за месяц
 */
export const competitorControllerImportCompetitorStats = (
  createCompetitorStatsRequestDTO: BodyType<CreateCompetitorStatsRequestDTO>,
  signal?: AbortSignal
) => {
  return createInstance<StatusResponseDTO>({
    url: `/api/competitor`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createCompetitorStatsRequestDTO,
    signal,
  });
};

export const getCompetitorControllerImportCompetitorStatsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof competitorControllerImportCompetitorStats>>,
    TError,
    { data: BodyType<CreateCompetitorStatsRequestDTO> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof competitorControllerImportCompetitorStats>>,
  TError,
  { data: BodyType<CreateCompetitorStatsRequestDTO> },
  TContext
> => {
  const mutationKey = ["competitorControllerImportCompetitorStats"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof competitorControllerImportCompetitorStats>>,
    { data: BodyType<CreateCompetitorStatsRequestDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return competitorControllerImportCompetitorStats(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompetitorControllerImportCompetitorStatsMutationResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerImportCompetitorStats>>
>;
export type CompetitorControllerImportCompetitorStatsMutationBody =
  BodyType<CreateCompetitorStatsRequestDTO>;
export type CompetitorControllerImportCompetitorStatsMutationError = ErrorType<void>;

/**
 * @summary Импорт данных о чужих скю за месяц
 */
export const useCompetitorControllerImportCompetitorStats = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof competitorControllerImportCompetitorStats>>,
    TError,
    { data: BodyType<CreateCompetitorStatsRequestDTO> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof competitorControllerImportCompetitorStats>>,
  TError,
  { data: BodyType<CreateCompetitorStatsRequestDTO> },
  TContext
> => {
  const mutationOptions = getCompetitorControllerImportCompetitorStatsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Получить SKU без статистики за период
 */
export const competitorControllerGetSkusWithoutStats = (
  params: CompetitorControllerGetSkusWithoutStatsParams,
  signal?: AbortSignal
) => {
  return createInstance<EmptyStatsResponse[]>({
    url: `/api/competitor/relation/skus-without-stats`,
    method: "GET",
    params,
    signal,
  });
};

export const getCompetitorControllerGetSkusWithoutStatsQueryKey = (
  params: CompetitorControllerGetSkusWithoutStatsParams
) => {
  return [`/api/competitor/relation/skus-without-stats`, ...(params ? [params] : [])] as const;
};

export const getCompetitorControllerGetSkusWithoutStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetSkusWithoutStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCompetitorControllerGetSkusWithoutStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>
  > = ({ signal }) => competitorControllerGetSkusWithoutStats(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CompetitorControllerGetSkusWithoutStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>
>;
export type CompetitorControllerGetSkusWithoutStatsQueryError = ErrorType<unknown>;

export function useCompetitorControllerGetSkusWithoutStats<
  TData = Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetSkusWithoutStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetSkusWithoutStats<
  TData = Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetSkusWithoutStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetSkusWithoutStats<
  TData = Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetSkusWithoutStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получить SKU без статистики за период
 */

export function useCompetitorControllerGetSkusWithoutStats<
  TData = Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetSkusWithoutStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetSkusWithoutStats>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCompetitorControllerGetSkusWithoutStatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Отстутствующие скю за период
 */
export const competitorControllerGetLost = (
  params: CompetitorControllerGetLostParams,
  signal?: AbortSignal
) => {
  return createInstance<EmptyStatsResponse[]>({
    url: `/api/competitor/relation/lost-category`,
    method: "GET",
    params,
    signal,
  });
};

export const getCompetitorControllerGetLostQueryKey = (
  params: CompetitorControllerGetLostParams
) => {
  return [`/api/competitor/relation/lost-category`, ...(params ? [params] : [])] as const;
};

export const getCompetitorControllerGetLostQueryOptions = <
  TData = Awaited<ReturnType<typeof competitorControllerGetLost>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetLostParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerGetLost>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompetitorControllerGetLostQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof competitorControllerGetLost>>> = ({
    signal,
  }) => competitorControllerGetLost(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof competitorControllerGetLost>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CompetitorControllerGetLostQueryResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerGetLost>>
>;
export type CompetitorControllerGetLostQueryError = ErrorType<unknown>;

export function useCompetitorControllerGetLost<
  TData = Awaited<ReturnType<typeof competitorControllerGetLost>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetLostParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerGetLost>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetLost>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetLost>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetLost<
  TData = Awaited<ReturnType<typeof competitorControllerGetLost>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetLostParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerGetLost>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetLost>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetLost>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetLost<
  TData = Awaited<ReturnType<typeof competitorControllerGetLost>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetLostParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerGetLost>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Отстутствующие скю за период
 */

export function useCompetitorControllerGetLost<
  TData = Awaited<ReturnType<typeof competitorControllerGetLost>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetLostParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerGetLost>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCompetitorControllerGetLostQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Ручное создание конкуренции
 */
export const competitorControllerCreateManualCompetitor = (
  sku: number,
  createManualCompetitorRelationDTO: BodyType<CreateManualCompetitorRelationDTO>,
  signal?: AbortSignal
) => {
  return createInstance<ManualRelationResponse>({
    url: `/api/competitor/relation/manual/${sku}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createManualCompetitorRelationDTO,
    signal,
  });
};

export const getCompetitorControllerCreateManualCompetitorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof competitorControllerCreateManualCompetitor>>,
    TError,
    { sku: number; data: BodyType<CreateManualCompetitorRelationDTO> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof competitorControllerCreateManualCompetitor>>,
  TError,
  { sku: number; data: BodyType<CreateManualCompetitorRelationDTO> },
  TContext
> => {
  const mutationKey = ["competitorControllerCreateManualCompetitor"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof competitorControllerCreateManualCompetitor>>,
    { sku: number; data: BodyType<CreateManualCompetitorRelationDTO> }
  > = (props) => {
    const { sku, data } = props ?? {};

    return competitorControllerCreateManualCompetitor(sku, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompetitorControllerCreateManualCompetitorMutationResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerCreateManualCompetitor>>
>;
export type CompetitorControllerCreateManualCompetitorMutationBody =
  BodyType<CreateManualCompetitorRelationDTO>;
export type CompetitorControllerCreateManualCompetitorMutationError = ErrorType<unknown>;

/**
 * @summary Ручное создание конкуренции
 */
export const useCompetitorControllerCreateManualCompetitor = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof competitorControllerCreateManualCompetitor>>,
    TError,
    { sku: number; data: BodyType<CreateManualCompetitorRelationDTO> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof competitorControllerCreateManualCompetitor>>,
  TError,
  { sku: number; data: BodyType<CreateManualCompetitorRelationDTO> },
  TContext
> => {
  const mutationOptions = getCompetitorControllerCreateManualCompetitorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Пометка конкуренции
 */
export const competitorControllerMark = (
  sku: number,
  markRelationBodyDTO: BodyType<MarkRelationBodyDTO>,
  params: CompetitorControllerMarkParams
) => {
  return createInstance<MarkRelationResponseDTO>({
    url: `/api/competitor/relation/${sku}/mark`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: markRelationBodyDTO,
    params,
  });
};

export const getCompetitorControllerMarkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof competitorControllerMark>>,
    TError,
    { sku: number; data: BodyType<MarkRelationBodyDTO>; params: CompetitorControllerMarkParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof competitorControllerMark>>,
  TError,
  { sku: number; data: BodyType<MarkRelationBodyDTO>; params: CompetitorControllerMarkParams },
  TContext
> => {
  const mutationKey = ["competitorControllerMark"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof competitorControllerMark>>,
    { sku: number; data: BodyType<MarkRelationBodyDTO>; params: CompetitorControllerMarkParams }
  > = (props) => {
    const { sku, data, params } = props ?? {};

    return competitorControllerMark(sku, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompetitorControllerMarkMutationResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerMark>>
>;
export type CompetitorControllerMarkMutationBody = BodyType<MarkRelationBodyDTO>;
export type CompetitorControllerMarkMutationError = ErrorType<unknown>;

/**
 * @summary Пометка конкуренции
 */
export const useCompetitorControllerMark = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof competitorControllerMark>>,
    TError,
    { sku: number; data: BodyType<MarkRelationBodyDTO>; params: CompetitorControllerMarkParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof competitorControllerMark>>,
  TError,
  { sku: number; data: BodyType<MarkRelationBodyDTO>; params: CompetitorControllerMarkParams },
  TContext
> => {
  const mutationOptions = getCompetitorControllerMarkMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Поиск SKU конкурентов
 */
export const competitorControllerSearchSku = (
  params: CompetitorControllerSearchSkuParams,
  signal?: AbortSignal
) => {
  return createInstance<SearchCompetitorResponse[]>({
    url: `/api/competitor/sku/search`,
    method: "GET",
    params,
    signal,
  });
};

export const getCompetitorControllerSearchSkuQueryKey = (
  params: CompetitorControllerSearchSkuParams
) => {
  return [`/api/competitor/sku/search`, ...(params ? [params] : [])] as const;
};

export const getCompetitorControllerSearchSkuQueryOptions = <
  TData = Awaited<ReturnType<typeof competitorControllerSearchSku>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerSearchSkuParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerSearchSku>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompetitorControllerSearchSkuQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof competitorControllerSearchSku>>> = ({
    signal,
  }) => competitorControllerSearchSku(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof competitorControllerSearchSku>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CompetitorControllerSearchSkuQueryResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerSearchSku>>
>;
export type CompetitorControllerSearchSkuQueryError = ErrorType<unknown>;

export function useCompetitorControllerSearchSku<
  TData = Awaited<ReturnType<typeof competitorControllerSearchSku>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerSearchSkuParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerSearchSku>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerSearchSku>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerSearchSku>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerSearchSku<
  TData = Awaited<ReturnType<typeof competitorControllerSearchSku>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerSearchSkuParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerSearchSku>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerSearchSku>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerSearchSku>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerSearchSku<
  TData = Awaited<ReturnType<typeof competitorControllerSearchSku>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerSearchSkuParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerSearchSku>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Поиск SKU конкурентов
 */

export function useCompetitorControllerSearchSku<
  TData = Awaited<ReturnType<typeof competitorControllerSearchSku>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerSearchSkuParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerSearchSku>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCompetitorControllerSearchSkuQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Импорт данных связанных скю за неделю
 */
export const competitorControllerImportCompetitorRelation = (
  createCompetitorRelationDataDTO: BodyType<CreateCompetitorRelationDataDTO>,
  signal?: AbortSignal
) => {
  return createInstance<StatusResponseDTO>({
    url: `/api/competitor/relation`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createCompetitorRelationDataDTO,
    signal,
  });
};

export const getCompetitorControllerImportCompetitorRelationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof competitorControllerImportCompetitorRelation>>,
    TError,
    { data: BodyType<CreateCompetitorRelationDataDTO> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof competitorControllerImportCompetitorRelation>>,
  TError,
  { data: BodyType<CreateCompetitorRelationDataDTO> },
  TContext
> => {
  const mutationKey = ["competitorControllerImportCompetitorRelation"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof competitorControllerImportCompetitorRelation>>,
    { data: BodyType<CreateCompetitorRelationDataDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return competitorControllerImportCompetitorRelation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompetitorControllerImportCompetitorRelationMutationResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerImportCompetitorRelation>>
>;
export type CompetitorControllerImportCompetitorRelationMutationBody =
  BodyType<CreateCompetitorRelationDataDTO>;
export type CompetitorControllerImportCompetitorRelationMutationError = ErrorType<void>;

/**
 * @summary Импорт данных связанных скю за неделю
 */
export const useCompetitorControllerImportCompetitorRelation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof competitorControllerImportCompetitorRelation>>,
    TError,
    { data: BodyType<CreateCompetitorRelationDataDTO> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof competitorControllerImportCompetitorRelation>>,
  TError,
  { data: BodyType<CreateCompetitorRelationDataDTO> },
  TContext
> => {
  const mutationOptions = getCompetitorControllerImportCompetitorRelationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Получить статистику по категориям
 */
export const competitorControllerGetCategoryStat = (
  params: CompetitorControllerGetCategoryStatParams,
  signal?: AbortSignal
) => {
  return createInstance<CategoryStatsResponse[]>({
    url: `/api/competitor/relation/category-stats`,
    method: "GET",
    params,
    signal,
  });
};

export const getCompetitorControllerGetCategoryStatQueryKey = (
  params: CompetitorControllerGetCategoryStatParams
) => {
  return [`/api/competitor/relation/category-stats`, ...(params ? [params] : [])] as const;
};

export const getCompetitorControllerGetCategoryStatQueryOptions = <
  TData = Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetCategoryStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompetitorControllerGetCategoryStatQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>> = ({
    signal,
  }) => competitorControllerGetCategoryStat(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CompetitorControllerGetCategoryStatQueryResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>
>;
export type CompetitorControllerGetCategoryStatQueryError = ErrorType<unknown>;

export function useCompetitorControllerGetCategoryStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetCategoryStatParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetCategoryStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetCategoryStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetCategoryStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetCategoryStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получить статистику по категориям
 */

export function useCompetitorControllerGetCategoryStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetCategoryStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCategoryStat>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCompetitorControllerGetCategoryStatQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить общую статистику по портфелям
 */
export const competitorControllerGetBriefcaseStat = (
  params: CompetitorControllerGetBriefcaseStatParams,
  signal?: AbortSignal
) => {
  return createInstance<BriefcaseCompetitorRelationStatsResponse>({
    url: `/api/competitor/relation/briefcase-stats`,
    method: "GET",
    params,
    signal,
  });
};

export const getCompetitorControllerGetBriefcaseStatQueryKey = (
  params: CompetitorControllerGetBriefcaseStatParams
) => {
  return [`/api/competitor/relation/briefcase-stats`, ...(params ? [params] : [])] as const;
};

export const getCompetitorControllerGetBriefcaseStatQueryOptions = <
  TData = Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetBriefcaseStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCompetitorControllerGetBriefcaseStatQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>
  > = ({ signal }) => competitorControllerGetBriefcaseStat(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CompetitorControllerGetBriefcaseStatQueryResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>
>;
export type CompetitorControllerGetBriefcaseStatQueryError = ErrorType<unknown>;

export function useCompetitorControllerGetBriefcaseStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetBriefcaseStatParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetBriefcaseStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetBriefcaseStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetBriefcaseStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetBriefcaseStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получить общую статистику по портфелям
 */

export function useCompetitorControllerGetBriefcaseStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetBriefcaseStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetBriefcaseStat>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCompetitorControllerGetBriefcaseStatQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить помесячную статистику по категориям зв пол года
 */
export const competitorControllerGetMonthlyStats = (
  params: CompetitorControllerGetMonthlyStatsParams,
  signal?: AbortSignal
) => {
  return createInstance<MonthCompetitorStatsResponse[]>({
    url: `/api/competitor/relation/monthly-stats`,
    method: "GET",
    params,
    signal,
  });
};

export const getCompetitorControllerGetMonthlyStatsQueryKey = (
  params: CompetitorControllerGetMonthlyStatsParams
) => {
  return [`/api/competitor/relation/monthly-stats`, ...(params ? [params] : [])] as const;
};

export const getCompetitorControllerGetMonthlyStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetMonthlyStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompetitorControllerGetMonthlyStatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>> = ({
    signal,
  }) => competitorControllerGetMonthlyStats(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CompetitorControllerGetMonthlyStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>
>;
export type CompetitorControllerGetMonthlyStatsQueryError = ErrorType<unknown>;

export function useCompetitorControllerGetMonthlyStats<
  TData = Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetMonthlyStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetMonthlyStats<
  TData = Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetMonthlyStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetMonthlyStats<
  TData = Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetMonthlyStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получить помесячную статистику по категориям зв пол года
 */

export function useCompetitorControllerGetMonthlyStats<
  TData = Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>,
  TError = ErrorType<unknown>,
>(
  params: CompetitorControllerGetMonthlyStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetMonthlyStats>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCompetitorControllerGetMonthlyStatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить конкурентов по скю
 */
export const competitorControllerGetCompetitorList = (
  sku: number,
  params: CompetitorControllerGetCompetitorListParams,
  signal?: AbortSignal
) => {
  return createInstance<CompetitorRelationListResponse[]>({
    url: `/api/competitor/relation/${sku}/list`,
    method: "GET",
    params,
    signal,
  });
};

export const getCompetitorControllerGetCompetitorListQueryKey = (
  sku: number,
  params: CompetitorControllerGetCompetitorListParams
) => {
  return [`/api/competitor/relation/${sku}/list`, ...(params ? [params] : [])] as const;
};

export const getCompetitorControllerGetCompetitorListQueryOptions = <
  TData = Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  params: CompetitorControllerGetCompetitorListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCompetitorControllerGetCompetitorListQueryKey(sku, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>
  > = ({ signal }) => competitorControllerGetCompetitorList(sku, params, signal);

  return { queryKey, queryFn, enabled: !!sku, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CompetitorControllerGetCompetitorListQueryResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>
>;
export type CompetitorControllerGetCompetitorListQueryError = ErrorType<unknown>;

export function useCompetitorControllerGetCompetitorList<
  TData = Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  params: CompetitorControllerGetCompetitorListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetCompetitorList<
  TData = Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  params: CompetitorControllerGetCompetitorListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetCompetitorList<
  TData = Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  params: CompetitorControllerGetCompetitorListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получить конкурентов по скю
 */

export function useCompetitorControllerGetCompetitorList<
  TData = Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  params: CompetitorControllerGetCompetitorListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCompetitorList>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCompetitorControllerGetCompetitorListQueryOptions(sku, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить детальную статистику по связи с конкурентом
 */
export const competitorControllerGetCompetitorRelation = (
  sku: number,
  competitor: number,
  params: CompetitorControllerGetCompetitorRelationParams,
  signal?: AbortSignal
) => {
  return createInstance<CompetitorRelationDetailResponse>({
    url: `/api/competitor/relation/${sku}/competitor/${competitor}`,
    method: "GET",
    params,
    signal,
  });
};

export const getCompetitorControllerGetCompetitorRelationQueryKey = (
  sku: number,
  competitor: number,
  params: CompetitorControllerGetCompetitorRelationParams
) => {
  return [
    `/api/competitor/relation/${sku}/competitor/${competitor}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCompetitorControllerGetCompetitorRelationQueryOptions = <
  TData = Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  competitor: number,
  params: CompetitorControllerGetCompetitorRelationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCompetitorControllerGetCompetitorRelationQueryKey(sku, competitor, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>
  > = ({ signal }) => competitorControllerGetCompetitorRelation(sku, competitor, params, signal);

  return { queryKey, queryFn, enabled: !!(sku && competitor), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CompetitorControllerGetCompetitorRelationQueryResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>
>;
export type CompetitorControllerGetCompetitorRelationQueryError = ErrorType<unknown>;

export function useCompetitorControllerGetCompetitorRelation<
  TData = Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  competitor: number,
  params: CompetitorControllerGetCompetitorRelationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetCompetitorRelation<
  TData = Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  competitor: number,
  params: CompetitorControllerGetCompetitorRelationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetCompetitorRelation<
  TData = Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  competitor: number,
  params: CompetitorControllerGetCompetitorRelationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получить детальную статистику по связи с конкурентом
 */

export function useCompetitorControllerGetCompetitorRelation<
  TData = Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  competitor: number,
  params: CompetitorControllerGetCompetitorRelationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetCompetitorRelation>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCompetitorControllerGetCompetitorRelationQueryOptions(
    sku,
    competitor,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить статистику доли по артиклю за пол года
 */
export const competitorControllerGetArticleMonthlyStat = (sku: number, signal?: AbortSignal) => {
  return createInstance<SkuMonthlyCompetitorRelationStatsResponse[]>({
    url: `/api/competitor/relation/${sku}/monthly-stats`,
    method: "GET",
    signal,
  });
};

export const getCompetitorControllerGetArticleMonthlyStatQueryKey = (sku: number) => {
  return [`/api/competitor/relation/${sku}/monthly-stats`] as const;
};

export const getCompetitorControllerGetArticleMonthlyStatQueryOptions = <
  TData = Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCompetitorControllerGetArticleMonthlyStatQueryKey(sku);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>
  > = ({ signal }) => competitorControllerGetArticleMonthlyStat(sku, signal);

  return { queryKey, queryFn, enabled: !!sku, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CompetitorControllerGetArticleMonthlyStatQueryResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>
>;
export type CompetitorControllerGetArticleMonthlyStatQueryError = ErrorType<unknown>;

export function useCompetitorControllerGetArticleMonthlyStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetArticleMonthlyStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetArticleMonthlyStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получить статистику доли по артиклю за пол года
 */

export function useCompetitorControllerGetArticleMonthlyStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof competitorControllerGetArticleMonthlyStat>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCompetitorControllerGetArticleMonthlyStatQueryOptions(sku, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить статистику по sku
 */
export const competitorControllerGetSkuStat = (
  sku: number,
  params: CompetitorControllerGetSkuStatParams,
  signal?: AbortSignal
) => {
  return createInstance<SkuCompetitorRelationStatsResponse>({
    url: `/api/competitor/relation/${sku}`,
    method: "GET",
    params,
    signal,
  });
};

export const getCompetitorControllerGetSkuStatQueryKey = (
  sku: number,
  params: CompetitorControllerGetSkuStatParams
) => {
  return [`/api/competitor/relation/${sku}`, ...(params ? [params] : [])] as const;
};

export const getCompetitorControllerGetSkuStatQueryOptions = <
  TData = Awaited<ReturnType<typeof competitorControllerGetSkuStat>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  params: CompetitorControllerGetSkuStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerGetSkuStat>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompetitorControllerGetSkuStatQueryKey(sku, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof competitorControllerGetSkuStat>>> = ({
    signal,
  }) => competitorControllerGetSkuStat(sku, params, signal);

  return { queryKey, queryFn, enabled: !!sku, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof competitorControllerGetSkuStat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CompetitorControllerGetSkuStatQueryResult = NonNullable<
  Awaited<ReturnType<typeof competitorControllerGetSkuStat>>
>;
export type CompetitorControllerGetSkuStatQueryError = ErrorType<unknown>;

export function useCompetitorControllerGetSkuStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetSkuStat>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  params: CompetitorControllerGetSkuStatParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerGetSkuStat>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetSkuStat>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetSkuStat>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetSkuStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetSkuStat>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  params: CompetitorControllerGetSkuStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerGetSkuStat>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof competitorControllerGetSkuStat>>,
          TError,
          Awaited<ReturnType<typeof competitorControllerGetSkuStat>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCompetitorControllerGetSkuStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetSkuStat>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  params: CompetitorControllerGetSkuStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerGetSkuStat>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получить статистику по sku
 */

export function useCompetitorControllerGetSkuStat<
  TData = Awaited<ReturnType<typeof competitorControllerGetSkuStat>>,
  TError = ErrorType<unknown>,
>(
  sku: number,
  params: CompetitorControllerGetSkuStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof competitorControllerGetSkuStat>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCompetitorControllerGetSkuStatQueryOptions(sku, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Импорт дневного финреза
 */
export const finrezControllerImportFinrezDaily = (
  importFinrezDailyRequestDTO: BodyType<ImportFinrezDailyRequestDTO>,
  signal?: AbortSignal
) => {
  return createInstance<StatusResponseDTO>({
    url: `/api/finrez/daily`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: importFinrezDailyRequestDTO,
    signal,
  });
};

export const getFinrezControllerImportFinrezDailyMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finrezControllerImportFinrezDaily>>,
    TError,
    { data: BodyType<ImportFinrezDailyRequestDTO> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof finrezControllerImportFinrezDaily>>,
  TError,
  { data: BodyType<ImportFinrezDailyRequestDTO> },
  TContext
> => {
  const mutationKey = ["finrezControllerImportFinrezDaily"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof finrezControllerImportFinrezDaily>>,
    { data: BodyType<ImportFinrezDailyRequestDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return finrezControllerImportFinrezDaily(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FinrezControllerImportFinrezDailyMutationResult = NonNullable<
  Awaited<ReturnType<typeof finrezControllerImportFinrezDaily>>
>;
export type FinrezControllerImportFinrezDailyMutationBody = BodyType<ImportFinrezDailyRequestDTO>;
export type FinrezControllerImportFinrezDailyMutationError = ErrorType<void>;

/**
 * @summary Импорт дневного финреза
 */
export const useFinrezControllerImportFinrezDaily = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finrezControllerImportFinrezDaily>>,
    TError,
    { data: BodyType<ImportFinrezDailyRequestDTO> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof finrezControllerImportFinrezDaily>>,
  TError,
  { data: BodyType<ImportFinrezDailyRequestDTO> },
  TContext
> => {
  const mutationOptions = getFinrezControllerImportFinrezDailyMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Получение доступных периодов и маркетплейсов
 */
export const salesChannelControllerGetOptions = (signal?: AbortSignal) => {
  return createInstance<OptionResponseDto>({
    url: `/api/sales-channels/options`,
    method: "GET",
    signal,
  });
};

export const getSalesChannelControllerGetOptionsQueryKey = () => {
  return [`/api/sales-channels/options`] as const;
};

export const getSalesChannelControllerGetOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof salesChannelControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof salesChannelControllerGetOptions>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSalesChannelControllerGetOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof salesChannelControllerGetOptions>>> = ({
    signal,
  }) => salesChannelControllerGetOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof salesChannelControllerGetOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SalesChannelControllerGetOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof salesChannelControllerGetOptions>>
>;
export type SalesChannelControllerGetOptionsQueryError = ErrorType<unknown>;

export function useSalesChannelControllerGetOptions<
  TData = Awaited<ReturnType<typeof salesChannelControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof salesChannelControllerGetOptions>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof salesChannelControllerGetOptions>>,
        TError,
        Awaited<ReturnType<typeof salesChannelControllerGetOptions>>
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSalesChannelControllerGetOptions<
  TData = Awaited<ReturnType<typeof salesChannelControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof salesChannelControllerGetOptions>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof salesChannelControllerGetOptions>>,
        TError,
        Awaited<ReturnType<typeof salesChannelControllerGetOptions>>
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSalesChannelControllerGetOptions<
  TData = Awaited<ReturnType<typeof salesChannelControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof salesChannelControllerGetOptions>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Получение доступных периодов и маркетплейсов
 */

export function useSalesChannelControllerGetOptions<
  TData = Awaited<ReturnType<typeof salesChannelControllerGetOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof salesChannelControllerGetOptions>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSalesChannelControllerGetOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * series: 6 метрик × (TOTAL + каналы из данных) × 2 периода. При каналах WB и OZON — 36 серий.
 * @summary Главная страница аналитики по каналам продаж
 */
export const salesChannelControllerGetOverview = (
  params: SalesChannelControllerGetOverviewParams,
  signal?: AbortSignal
) => {
  return createInstance<OverviewResponseDto>({
    url: `/api/sales-channels/overview`,
    method: "GET",
    params,
    signal,
  });
};

export const getSalesChannelControllerGetOverviewQueryKey = (
  params: SalesChannelControllerGetOverviewParams
) => {
  return [`/api/sales-channels/overview`, ...(params ? [params] : [])] as const;
};

export const getSalesChannelControllerGetOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof salesChannelControllerGetOverview>>,
  TError = ErrorType<void>,
>(
  params: SalesChannelControllerGetOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof salesChannelControllerGetOverview>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSalesChannelControllerGetOverviewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof salesChannelControllerGetOverview>>> = ({
    signal,
  }) => salesChannelControllerGetOverview(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof salesChannelControllerGetOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SalesChannelControllerGetOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof salesChannelControllerGetOverview>>
>;
export type SalesChannelControllerGetOverviewQueryError = ErrorType<void>;

export function useSalesChannelControllerGetOverview<
  TData = Awaited<ReturnType<typeof salesChannelControllerGetOverview>>,
  TError = ErrorType<void>,
>(
  params: SalesChannelControllerGetOverviewParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof salesChannelControllerGetOverview>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesChannelControllerGetOverview>>,
          TError,
          Awaited<ReturnType<typeof salesChannelControllerGetOverview>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSalesChannelControllerGetOverview<
  TData = Awaited<ReturnType<typeof salesChannelControllerGetOverview>>,
  TError = ErrorType<void>,
>(
  params: SalesChannelControllerGetOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof salesChannelControllerGetOverview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesChannelControllerGetOverview>>,
          TError,
          Awaited<ReturnType<typeof salesChannelControllerGetOverview>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSalesChannelControllerGetOverview<
  TData = Awaited<ReturnType<typeof salesChannelControllerGetOverview>>,
  TError = ErrorType<void>,
>(
  params: SalesChannelControllerGetOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof salesChannelControllerGetOverview>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Главная страница аналитики по каналам продаж
 */

export function useSalesChannelControllerGetOverview<
  TData = Awaited<ReturnType<typeof salesChannelControllerGetOverview>>,
  TError = ErrorType<void>,
>(
  params: SalesChannelControllerGetOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof salesChannelControllerGetOverview>>, TError, TData>
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSalesChannelControllerGetOverviewQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Детальная страница по каналу продаж
 */
export const salesChannelControllerGetMarketplaceDetail = (
  marketplace: "OZON" | "WB" | "YM",
  params: SalesChannelControllerGetMarketplaceDetailParams,
  signal?: AbortSignal
) => {
  return createInstance<MarketplaceDetailResponseDto>({
    url: `/api/sales-channels/marketplace/${marketplace}`,
    method: "GET",
    params,
    signal,
  });
};

export const getSalesChannelControllerGetMarketplaceDetailQueryKey = (
  marketplace: "OZON" | "WB" | "YM",
  params: SalesChannelControllerGetMarketplaceDetailParams
) => {
  return [`/api/sales-channels/marketplace/${marketplace}`, ...(params ? [params] : [])] as const;
};

export const getSalesChannelControllerGetMarketplaceDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>,
  TError = ErrorType<void>,
>(
  marketplace: "OZON" | "WB" | "YM",
  params: SalesChannelControllerGetMarketplaceDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSalesChannelControllerGetMarketplaceDetailQueryKey(marketplace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>
  > = ({ signal }) => salesChannelControllerGetMarketplaceDetail(marketplace, params, signal);

  return { queryKey, queryFn, enabled: !!marketplace, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SalesChannelControllerGetMarketplaceDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>
>;
export type SalesChannelControllerGetMarketplaceDetailQueryError = ErrorType<void>;

export function useSalesChannelControllerGetMarketplaceDetail<
  TData = Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>,
  TError = ErrorType<void>,
>(
  marketplace: "OZON" | "WB" | "YM",
  params: SalesChannelControllerGetMarketplaceDetailParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>,
          TError,
          Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>
        >,
        "initialData"
      >;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSalesChannelControllerGetMarketplaceDetail<
  TData = Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>,
  TError = ErrorType<void>,
>(
  marketplace: "OZON" | "WB" | "YM",
  params: SalesChannelControllerGetMarketplaceDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>,
          TError,
          Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>
        >,
        "initialData"
      >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSalesChannelControllerGetMarketplaceDetail<
  TData = Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>,
  TError = ErrorType<void>,
>(
  marketplace: "OZON" | "WB" | "YM",
  params: SalesChannelControllerGetMarketplaceDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Детальная страница по каналу продаж
 */

export function useSalesChannelControllerGetMarketplaceDetail<
  TData = Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>,
  TError = ErrorType<void>,
>(
  marketplace: "OZON" | "WB" | "YM",
  params: SalesChannelControllerGetMarketplaceDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof salesChannelControllerGetMarketplaceDetail>>,
        TError,
        TData
      >
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSalesChannelControllerGetMarketplaceDetailQueryOptions(
    marketplace,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAdvertisementControllerGetAdvertisementHistoryResponseMock = (
  overrideResponse: Partial<GetAdvertisementHistoryByCampaignsResponseDTO> = {}
): GetAdvertisementHistoryByCampaignsResponseDTO => ({
  history: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      company: faker.helpers.arrayElement([
        "BANNER_BRAND",
        "BANNER_NOMENCLATURE",
        "CAROUSEL_BRAND",
        "CAROUSEL_NOMENCLATURE",
        "CATALOG",
        "CAROUSEL_BRAND_AUCTION",
        "SEARCH",
        "RECOMMENDATION",
        "AUTOMATIC",
        "SEARCH_CATALOG",
      ] as const),
      params: {
        acos: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
          () => ({
            value: faker.number.int({ min: undefined, max: undefined }),
            date: `${faker.date.past().toISOString().split(".")[0]}Z`,
          })
        ),
        budget: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
          () => ({
            value: faker.number.int({ min: undefined, max: undefined }),
            date: `${faker.date.past().toISOString().split(".")[0]}Z`,
          })
        ),
        balance: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
          () => ({
            value: faker.number.int({ min: undefined, max: undefined }),
            date: `${faker.date.past().toISOString().split(".")[0]}Z`,
          })
        ),
        clicks: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
          () => ({
            value: faker.number.int({ min: undefined, max: undefined }),
            date: `${faker.date.past().toISOString().split(".")[0]}Z`,
          })
        ),
        ctr: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
          () => ({
            value: faker.number.int({ min: undefined, max: undefined }),
            date: `${faker.date.past().toISOString().split(".")[0]}Z`,
          })
        ),
        ordersFromAds: Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1
        ).map(() => ({
          value: faker.number.int({ min: undefined, max: undefined }),
          date: `${faker.date.past().toISOString().split(".")[0]}Z`,
        })),
        revenue: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
          () => ({
            value: faker.number.int({ min: undefined, max: undefined }),
            date: `${faker.date.past().toISOString().split(".")[0]}Z`,
          })
        ),
        spent: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
          () => ({
            value: faker.number.int({ min: undefined, max: undefined }),
            date: `${faker.date.past().toISOString().split(".")[0]}Z`,
          })
        ),
        tacos: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
          () => ({
            value: faker.number.int({ min: undefined, max: undefined }),
            date: `${faker.date.past().toISOString().split(".")[0]}Z`,
          })
        ),
        views: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
          () => ({
            value: faker.number.int({ min: undefined, max: undefined }),
            date: `${faker.date.past().toISOString().split(".")[0]}Z`,
          })
        ),
      },
    })
  ),
  statistic: {
    acos: faker.number.int({ min: undefined, max: undefined }),
    tacos: faker.number.int({ min: undefined, max: undefined }),
    ctr: faker.number.int({ min: undefined, max: undefined }),
    spent: faker.number.int({ min: undefined, max: undefined }),
  },
  ...overrideResponse,
});

export const getAdvertisementControllerGetDailyInnerAdStatResponseMock = (
  overrideResponse: Partial<GetAdDailyCompanyStatsResponseDto> = {}
): GetAdDailyCompanyStatsResponseDto => ({
  stats: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    sku: faker.number.int({ min: undefined, max: undefined }),
    badKeywordCount: faker.number.int({ min: undefined, max: undefined }),
    recommendedKeywordCount: faker.number.int({ min: undefined, max: undefined }),
    spent: faker.number.int({ min: undefined, max: undefined }),
    balance: faker.number.int({ min: undefined, max: undefined }),
    orders: faker.number.int({ min: undefined, max: undefined }),
    productName: faker.string.alpha(20),
    clicks: faker.number.int({ min: undefined, max: undefined }),
    views: faker.number.int({ min: undefined, max: undefined }),
    revenue: faker.number.int({ min: undefined, max: undefined }),
    budget: faker.number.int({ min: undefined, max: undefined }),
  })),
  date: faker.string.alpha(20),
  ...overrideResponse,
});

export const getAdvertisementControllerGetAdKeywordResponseMock = (
  overrideResponse: Partial<GetAdDailyCompanyStatsBySkuResponse> = {}
): GetAdDailyCompanyStatsBySkuResponse => ({
  badKeywords: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => faker.string.alpha(20)
  ),
  goodKeywords: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => faker.string.alpha(20)
  ),
  recommendedKeywords: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    keyword: faker.string.alpha(20),
    monthly: faker.string.alpha(20),
    weekly: faker.string.alpha(20),
    weeklyTrend: faker.string.alpha(20),
  })),
  date: faker.string.alpha(20),
  sku: faker.number.int({ min: undefined, max: undefined }),
  productName: faker.string.alpha(20),
  ...overrideResponse,
});

export const getAuthControllerLoginResponseMock = (
  overrideResponse: Partial<AuthResponseDto> = {}
): AuthResponseDto => ({
  user: {
    id: faker.string.alpha(20),
    email: faker.string.alpha(20),
    name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
    surname: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
    department: faker.helpers.arrayElement(Object.values(Department)),
    role: faker.helpers.arrayElement(Object.values(Role)),
    gender: faker.helpers.arrayElement(Object.values(Gender)),
    isActivate: faker.datatype.boolean(),
  },
  access_token: faker.string.alpha(20),
  ...overrideResponse,
});

export const getAuthControllerLogoutResponseMock = (
  overrideResponse: Partial<LogoutResponseDto> = {}
): LogoutResponseDto => ({ userId: faker.string.alpha(20), ...overrideResponse });

export const getAuthControllerRegistrationResponseMock = (
  overrideResponse: Partial<AuthResponseDto> = {}
): AuthResponseDto => ({
  user: {
    id: faker.string.alpha(20),
    email: faker.string.alpha(20),
    name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
    surname: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
    department: faker.helpers.arrayElement(Object.values(Department)),
    role: faker.helpers.arrayElement(Object.values(Role)),
    gender: faker.helpers.arrayElement(Object.values(Gender)),
    isActivate: faker.datatype.boolean(),
  },
  access_token: faker.string.alpha(20),
  ...overrideResponse,
});

export const getAuthControllerResetPasswordResponseMock = (
  overrideResponse: Partial<StatusResponseDTO> = {}
): StatusResponseDTO => ({ status: faker.string.alpha(20), ...overrideResponse });

export const getAuthControllerRefreshResponseMock = (
  overrideResponse: Partial<AuthResponseDto> = {}
): AuthResponseDto => ({
  user: {
    id: faker.string.alpha(20),
    email: faker.string.alpha(20),
    name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
    surname: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
    department: faker.helpers.arrayElement(Object.values(Department)),
    role: faker.helpers.arrayElement(Object.values(Role)),
    gender: faker.helpers.arrayElement(Object.values(Gender)),
    isActivate: faker.datatype.boolean(),
  },
  access_token: faker.string.alpha(20),
  ...overrideResponse,
});

export const getUserControllerGetAllResponseMock = (): UserInfoDto[] =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    id: faker.string.alpha(20),
    email: faker.string.alpha(20),
    name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
    surname: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
    department: faker.helpers.arrayElement(Object.values(Department)),
    role: faker.helpers.arrayElement(Object.values(Role)),
    gender: faker.helpers.arrayElement(Object.values(Gender)),
    isActivate: faker.datatype.boolean(),
  }));

export const getUserControllerFindOneResponseMock = (
  overrideResponse: Partial<ReadUserResponse> = {}
): ReadUserResponse => ({
  id: faker.string.alpha(20),
  email: faker.string.alpha(20),
  name: faker.string.alpha(20),
  surname: faker.string.alpha(20),
  department: faker.helpers.arrayElement(Object.values(Department)),
  role: faker.helpers.arrayElement(Object.values(Role)),
  gender: faker.helpers.arrayElement(Object.values(Gender)),
  isActivate: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getUserControllerUpdateResponseMock = (
  overrideResponse: Partial<ReadUserResponse> = {}
): ReadUserResponse => ({
  id: faker.string.alpha(20),
  email: faker.string.alpha(20),
  name: faker.string.alpha(20),
  surname: faker.string.alpha(20),
  department: faker.helpers.arrayElement(Object.values(Department)),
  role: faker.helpers.arrayElement(Object.values(Role)),
  gender: faker.helpers.arrayElement(Object.values(Gender)),
  isActivate: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getUserControllerRemoveResponseMock = (
  overrideResponse: Partial<DeleteUserResponse> = {}
): DeleteUserResponse => ({
  id: faker.string.alpha(20),
  email: faker.string.alpha(20),
  name: faker.string.alpha(20),
  surname: faker.string.alpha(20),
  department: faker.helpers.arrayElement([
    "HR",
    "PRODUCT",
    "COMMERS",
    "MARKETING",
    "FINANCE",
    "LOGISTIC",
    "ANALYTIC",
    "FATHERS",
    "NOOB",
  ] as const),
  role: faker.helpers.arrayElement([
    "DREADNOUGHT",
    "CEO",
    "BOSS",
    "MANAGER",
    "EMPLOYEE",
    "NOOB",
    "DEVELOPER",
  ] as const),
  gender: faker.helpers.arrayElement(["MALE", "FEMALE"] as const),
  isActivate: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getUserControllerMakeSubordinateResponseMock = (
  overrideResponse: Partial<StatusResponseDTO> = {}
): StatusResponseDTO => ({ status: faker.string.alpha(20), ...overrideResponse });

export const getUserControllerUpdateSelfResponseMock = (
  overrideResponse: Partial<ReadUserResponse> = {}
): ReadUserResponse => ({
  id: faker.string.alpha(20),
  email: faker.string.alpha(20),
  name: faker.string.alpha(20),
  surname: faker.string.alpha(20),
  department: faker.helpers.arrayElement(Object.values(Department)),
  role: faker.helpers.arrayElement(Object.values(Role)),
  gender: faker.helpers.arrayElement(Object.values(Gender)),
  isActivate: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getAlertControllerSseResponseMock = (
  overrideResponse: Partial<AlertResponseDTO> = {}
): AlertResponseDTO => ({
  data: {
    productId: faker.number.int({ min: undefined, max: undefined }),
    sku: faker.number.int({ min: undefined, max: undefined }),
    marketplace: faker.helpers.arrayElement(["OZON", "WB", "YM"] as const),
    barcode: faker.string.alpha(20),
    alertKind: faker.helpers.arrayElement(Object.values(AlertKind)),
    alertCategory: faker.helpers.arrayElement([
      "AMOUNT_ALERT",
      "RATING_ALERT",
      "CONVERSION_ALERT",
      "ADS_ALERT",
      "PRICE_ALERT",
    ] as const),
    priority: faker.number.int({ min: undefined, max: undefined }),
    priorityInCategory: faker.number.int({ min: undefined, max: undefined }),
    payload: faker.helpers.arrayElement([{}, undefined]),
  },
  type: faker.helpers.arrayElement(Object.values(AlertKind)),
  id: faker.number.int({ min: undefined, max: undefined }),
  ...overrideResponse,
});

export const getBriefcaseControllerGetBriefcasesResponseMock = (): BriefcaseDto[] =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    id: faker.number.int({ min: undefined, max: undefined }),
    name: faker.string.alpha(20),
  }));

export const getProductControllerGetUnassignedProductsResponseMock =
  (): GetUnassignedProductsDTO[] =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      productId: faker.number.int({ min: undefined, max: undefined }),
      sku: faker.number.int({ min: undefined, max: undefined }),
      marketplace: faker.helpers.arrayElement(["OZON", "WB", "YM"] as const),
      barcode: faker.string.alpha(20),
      name: faker.string.alpha(20),
      company: faker.string.alpha(20),
      brand: faker.string.alpha(20),
      description: faker.string.alpha(20),
      url: faker.string.alpha(20),
      generalArticle: faker.number.int({ min: undefined, max: undefined }),
    }));

export const getCategoryControllerGetAllResponseMock = (): ArticleCategoryResponse[] =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    id: faker.number.int({ min: undefined, max: undefined }),
    name: faker.string.alpha(20),
  }));

export const getCategoryControllerGetOptionsResponseMock = (): OptionsCompetitorResponse[] =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    name: faker.string.alpha(20),
    id: faker.number.int({ min: undefined, max: undefined }),
  }));

export const getRatingControllerGetProductRatingHistoryResponseMock = (
  overrideResponse: Partial<GetProductRatingHistoryResponseDTO> = {}
): GetProductRatingHistoryResponseDTO => ({
  productCardRating: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    value: faker.number.int({ min: undefined, max: undefined }),
    date: `${faker.date.past().toISOString().split(".")[0]}Z`,
  })),
  productCardReviewsAmount: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    value: faker.number.int({ min: undefined, max: undefined }),
    date: `${faker.date.past().toISOString().split(".")[0]}Z`,
  })),
  skleikaRating: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      value: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })
  ),
  skleikaReviewsAmount: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    value: faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      undefined,
    ]),
    date: `${faker.date.past().toISOString().split(".")[0]}Z`,
  })),
  ...overrideResponse,
});

export const getManagerAppointmentControllerAppointManagerResponseMock = (
  overrideResponse: Partial<StatusResponseDTO> = {}
): StatusResponseDTO => ({ status: faker.string.alpha(20), ...overrideResponse });

export const getDashboardControllerGetDashboardResponseMock = (
  overrideResponse: Partial<DashboardResponseDTO> = {}
): DashboardResponseDTO => ({
  plannedNetProfit: faker.number.int({ min: undefined, max: undefined }),
  actualNetProfit: faker.number.int({ min: undefined, max: undefined }),
  plannedOrders: faker.number.int({ min: undefined, max: undefined }),
  actualOrders: faker.number.int({ min: undefined, max: undefined }),
  plannedRevenue: faker.number.int({ min: undefined, max: undefined }),
  actualRevenue: faker.number.int({ min: undefined, max: undefined }),
  tacosHistory: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })
  ),
  markup: faker.number.int({ min: undefined, max: undefined }),
  averageProfitability: faker.number.int({ min: undefined, max: undefined }),
  ...overrideResponse,
});

export const getOrderHistoryControllerGetOrderHistoryForProductResponseMock = (
  overrideResponse: Partial<GetOrderHistoryForProductResponseDTO> = {}
): GetOrderHistoryForProductResponseDTO => ({
  ordersAmount: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })
  ),
  ordersWithoutReturnsAmount: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    value: faker.number.int({ min: undefined, max: undefined }),
    date: `${faker.date.past().toISOString().split(".")[0]}Z`,
  })),
  returnAmount: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })
  ),
  selfPurchaseAmount: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    value: faker.number.int({ min: undefined, max: undefined }),
    date: `${faker.date.past().toISOString().split(".")[0]}Z`,
  })),
  name: faker.string.alpha(20),
  image: faker.helpers.arrayElement([faker.string.alpha(20), null]),
  url: faker.helpers.arrayElement([faker.string.alpha(20), null]),
  ...overrideResponse,
});

export const getProductReportControllerGetProductPriceHistoryResponseMock = (
  overrideResponse: Partial<GetProductPriceHistoryResponseDTO> = {}
): GetProductPriceHistoryResponseDTO => ({
  oldPrice: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })
  ),
  price: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    value: faker.number.int({ min: undefined, max: undefined }),
    date: `${faker.date.past().toISOString().split(".")[0]}Z`,
  })),
  priceWithCard: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      value: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })
  ),
  priceWithSpp: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })
  ),
  sppPercent: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })
  ),
  ...overrideResponse,
});

export const getProductReportControllerGetProductCardSummaryResponseMock = (
  overrideResponse: Partial<GetProductCardSummaryResponseDTO> = {}
): GetProductCardSummaryResponseDTO => ({
  generalArticle: faker.number.int({ min: undefined, max: undefined }),
  sku: faker.number.int({ min: undefined, max: undefined }),
  marketplace: faker.helpers.arrayElement(Object.values(MarketPlace)),
  name: faker.string.alpha(20),
  image: faker.string.alpha(20),
  additionalImages: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => faker.string.alpha(20)),
  articleStatus: faker.helpers.arrayElement(Object.values(ArticleStatus)),
  productCardStatus: faker.helpers.arrayElement(Object.values(ProductCardStatus)),
  category: faker.string.alpha(20),
  company: faker.string.alpha(20),
  actualOrdersAmount: faker.number.int({ min: undefined, max: undefined }),
  manager: faker.string.alpha(20),
  nearestDeliveries: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    value: faker.number.int({ min: undefined, max: undefined }),
  })),
  nearestDeliveriesToMarketplace: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    value: faker.number.int({ min: undefined, max: undefined }),
  })),
  nearestDeliveriesToMoscow: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    value: faker.number.int({ min: undefined, max: undefined }),
  })),
  orders: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      value: faker.number.int({ min: undefined, max: undefined }),
    })
  ),
  oldPrice: faker.number.int({ min: undefined, max: undefined }),
  plannedNetProfitAmount: faker.number.int({ min: undefined, max: undefined }),
  plannedOrdersAmount: faker.number.int({ min: undefined, max: undefined }),
  plannedRevenueAmount: faker.number.int({ min: undefined, max: undefined }),
  price: faker.number.int({ min: undefined, max: undefined }),
  priceWithCard: faker.number.int({ min: undefined, max: undefined }),
  priceWithSpp: faker.number.int({ min: undefined, max: undefined }),
  costPrice: faker.number.int({ min: undefined, max: undefined }),
  productCardRating: faker.number.int({ min: undefined, max: undefined }),
  productCardReviewsAmount: faker.number.int({ min: undefined, max: undefined }),
  skleikaRating: faker.number.int({ min: undefined, max: undefined }),
  skleikaReviewsAmount: faker.number.int({ min: undefined, max: undefined }),
  quantityLeftOnMarketplace: faker.number.int({ min: undefined, max: undefined }),
  quantityLeftOnMoscowWarehouse: faker.number.int({ min: undefined, max: undefined }),
  actualNetProfitAmount: faker.number.int({ min: undefined, max: undefined }),
  actualRevenueAmount: faker.number.int({ min: undefined, max: undefined }),
  enoughForDays: faker.number.int({ min: undefined, max: undefined }),
  reservedOnMarketplace: faker.number.int({ min: undefined, max: undefined }),
  wayToMarketplace: faker.number.int({ min: undefined, max: undefined }),
  marketingCampaigns: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => faker.string.alpha(20)),
  ...overrideResponse,
});

export const getProductReportControllerGetProductCardReportResponseMock = (
  overrideResponse: Partial<GetProductCardReportResponseDTO> = {}
): GetProductCardReportResponseDTO => ({
  productInfo: {
    priceWithSpp: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    priceBeforeSpp: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    stock: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
  },
  advertisingInfo: {
    acos: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    budget: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    balance: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    clicks: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    ctr: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    ordersFromAds: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    revenue: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    spent: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    tacos: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    views: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
  },
  purchaseFunnelInfo: {
    cr: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    showLook: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    showCard: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    showCardPercent: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    basketOrder: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    basketOrderPercent: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    cardBasket: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    cardBasketPercent: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    tacos: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
  },
  profitInfo: {
    revenue: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    netProfit: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    netProfitPercent: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    ordersWithoutReturnsAmount: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
  },
  ratingInfo: {
    productCardRating: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    skleikaRating: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    productCardReviewsAmount: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    skleikaReviewsAmount: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
  },
  ...overrideResponse,
});

export const getProductReportControllerGetProductCardEconomyResponseMock = (
  overrideResponse: Partial<GetProductCardEconomyResponseDTO> = {}
): GetProductCardEconomyResponseDTO => ({
  markup: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })
  ),
  revenue: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })
  ),
  revenuePercent: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    value: faker.number.int({ min: undefined, max: undefined }),
    date: `${faker.date.past().toISOString().split(".")[0]}Z`,
  })),
  netProfit: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })
  ),
  netProfitPercent: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    value: faker.number.int({ min: undefined, max: undefined }),
    date: `${faker.date.past().toISOString().split(".")[0]}Z`,
  })),
  ...overrideResponse,
});

export const getProductReportControllerGetPurchaseFunnelResponseMock = (
  overrideResponse: Partial<GetPurchaseFunnelResponseDTO> = {}
): GetPurchaseFunnelResponseDTO => ({
  history: {
    cr: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    showLook: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    showCard: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    showCardPercent: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    basketOrder: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    basketOrderPercent: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    cardBasket: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
    cardBasketPercent: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      value: faker.number.int({ min: undefined, max: undefined }),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })),
    tacos: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        value: faker.number.int({ min: undefined, max: undefined }),
        date: `${faker.date.past().toISOString().split(".")[0]}Z`,
      })
    ),
  },
  stat: {
    showLook: faker.number.int({ min: undefined, max: undefined }),
    showCard: faker.number.int({ min: undefined, max: undefined }),
    showCardPercent: faker.number.int({ min: undefined, max: undefined }),
    basketOrder: faker.number.int({ min: undefined, max: undefined }),
    basketOrderPercent: faker.number.int({ min: undefined, max: undefined }),
    cardBasket: faker.number.int({ min: undefined, max: undefined }),
    cardBasketPercent: faker.number.int({ min: undefined, max: undefined }),
  },
  ...overrideResponse,
});

export const getRequestLoggerControllerGetResponseMock = (
  overrideResponse: Partial<LogPaginatedResponse> = {}
): LogPaginatedResponse => ({
  data: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    id: faker.number.int({ min: undefined, max: undefined }),
    url: faker.string.alpha(20),
    method: faker.helpers.arrayElement(["GET", "POST", "PUT", "PATCH", "DELETE"] as const),
    createdAt: `${faker.date.past().toISOString().split(".")[0]}Z`,
    user: {},
  })),
  meta: {
    ...{
      page: faker.number.int({ min: undefined, max: undefined }),
      limit: faker.number.int({ min: undefined, max: undefined }),
      total: faker.number.int({ min: undefined, max: undefined }),
      totalPages: faker.number.int({ min: undefined, max: undefined }),
    },
  },
  ...overrideResponse,
});

export const getReviewControllerGetInfoByBriefcaseForPeriodResponseMock =
  (): ReviewsByBriefcaseResponseDto[] =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      id: faker.number.int({ min: undefined, max: undefined }),
      name: faker.string.alpha(20),
      marketplaces: Array.from(
        { length: faker.number.int({ min: 1, max: 10 }) },
        (_, i) => i + 1
      ).map(() => ({
        marketplace: faker.helpers.arrayElement(Object.values(MarketPlace)),
        articles: Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1
        ).map(() => ({
          id: faker.number.int({ min: undefined, max: undefined }),
          name: faker.string.alpha(20),
          generalArticle: faker.number.int({ min: undefined, max: undefined }),
          briefcaseName: faker.string.alpha(20),
          articleSubcategoryName: faker.string.alpha(20),
          articleSubcategoryId: faker.number.int({ min: undefined, max: undefined }),
          reviewStats: {
            reviewCount: {
              ...{
                periodValue: faker.number.int({ min: undefined, max: undefined }),
                previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
                fromPeriod: Array.from(
                  { length: faker.number.int({ min: 1, max: 10 }) },
                  (_, i) => i + 1
                ).map(() => ({
                  date: faker.date.past().toISOString().split("T")[0],
                  value: faker.number.int({ min: undefined, max: undefined }),
                })),
              },
            },
            conversionInReviewCount: {
              ...{
                periodValue: faker.number.int({ min: undefined, max: undefined }),
                previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
                fromPeriod: Array.from(
                  { length: faker.number.int({ min: 1, max: 10 }) },
                  (_, i) => i + 1
                ).map(() => ({
                  date: faker.date.past().toISOString().split("T")[0],
                  value: faker.number.int({ min: undefined, max: undefined }),
                })),
              },
            },
            ordersCount: {
              ...{
                periodValue: faker.number.int({ min: undefined, max: undefined }),
                previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
                fromPeriod: Array.from(
                  { length: faker.number.int({ min: 1, max: 10 }) },
                  (_, i) => i + 1
                ).map(() => ({
                  date: faker.date.past().toISOString().split("T")[0],
                  value: faker.number.int({ min: undefined, max: undefined }),
                })),
              },
            },
            positiveReviewCount: {
              ...{
                periodValue: faker.number.int({ min: undefined, max: undefined }),
                previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
                fromPeriod: Array.from(
                  { length: faker.number.int({ min: 1, max: 10 }) },
                  (_, i) => i + 1
                ).map(() => ({
                  date: faker.date.past().toISOString().split("T")[0],
                  value: faker.number.int({ min: undefined, max: undefined }),
                })),
              },
            },
            negativeReviewCount: {
              ...{
                periodValue: faker.number.int({ min: undefined, max: undefined }),
                previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
                fromPeriod: Array.from(
                  { length: faker.number.int({ min: 1, max: 10 }) },
                  (_, i) => i + 1
                ).map(() => ({
                  date: faker.date.past().toISOString().split("T")[0],
                  value: faker.number.int({ min: undefined, max: undefined }),
                })),
              },
            },
            defectReviewCount: {
              ...{
                periodValue: faker.number.int({ min: undefined, max: undefined }),
                previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
                fromPeriod: Array.from(
                  { length: faker.number.int({ min: 1, max: 10 }) },
                  (_, i) => i + 1
                ).map(() => ({
                  date: faker.date.past().toISOString().split("T")[0],
                  value: faker.number.int({ min: undefined, max: undefined }),
                })),
              },
            },
            marketplaceProblemCount: {
              ...{
                periodValue: faker.number.int({ min: undefined, max: undefined }),
                previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
                fromPeriod: Array.from(
                  { length: faker.number.int({ min: 1, max: 10 }) },
                  (_, i) => i + 1
                ).map(() => ({
                  date: faker.date.past().toISOString().split("T")[0],
                  value: faker.number.int({ min: undefined, max: undefined }),
                })),
              },
            },
            failureToMeetExpectationsCount: {
              ...{
                periodValue: faker.number.int({ min: undefined, max: undefined }),
                previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
                fromPeriod: Array.from(
                  { length: faker.number.int({ min: 1, max: 10 }) },
                  (_, i) => i + 1
                ).map(() => ({
                  date: faker.date.past().toISOString().split("T")[0],
                  value: faker.number.int({ min: undefined, max: undefined }),
                })),
              },
            },
            othersProblemCount: {
              ...{
                periodValue: faker.number.int({ min: undefined, max: undefined }),
                previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
                fromPeriod: Array.from(
                  { length: faker.number.int({ min: 1, max: 10 }) },
                  (_, i) => i + 1
                ).map(() => ({
                  date: faker.date.past().toISOString().split("T")[0],
                  value: faker.number.int({ min: undefined, max: undefined }),
                })),
              },
            },
            rating: {
              ...{
                periodValue: faker.number.int({ min: undefined, max: undefined }),
                previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
                fromPeriod: Array.from(
                  { length: faker.number.int({ min: 1, max: 10 }) },
                  (_, i) => i + 1
                ).map(() => ({
                  date: faker.date.past().toISOString().split("T")[0],
                  value: faker.number.int({ min: undefined, max: undefined }),
                })),
              },
            },
            reviewWithTextCount: {
              ...{ periodValue: faker.number.int({ min: undefined, max: undefined }) },
            },
          },
          status: faker.string.alpha(20),
        })),
      })),
    }));

export const getReviewControllerGetInfoByGeneralArticleResponseMock = (
  overrideResponse: Partial<ReviewByArticleResponse> = {}
): ReviewByArticleResponse => ({
  id: faker.number.int({ min: undefined, max: undefined }),
  name: faker.string.alpha(20),
  generalArticle: faker.number.int({ min: undefined, max: undefined }),
  classification: faker.helpers.arrayElements(Object.values(ReviewClassification)),
  info: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    marketplace: faker.helpers.arrayElement(Object.values(MarketPlace)),
    firstReviewDate: faker.helpers.arrayElement([
      faker.date.past().toISOString().split("T")[0],
      null,
    ]),
    aggregatedStats: {
      ...{
        reviewCount: {
          ...{
            periodValue: faker.number.int({ min: undefined, max: undefined }),
            previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
            fromPeriod: Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1
            ).map(() => ({
              date: faker.date.past().toISOString().split("T")[0],
              value: faker.number.int({ min: undefined, max: undefined }),
            })),
          },
        },
        conversionInReviewCount: {
          ...{
            periodValue: faker.number.int({ min: undefined, max: undefined }),
            previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
            fromPeriod: Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1
            ).map(() => ({
              date: faker.date.past().toISOString().split("T")[0],
              value: faker.number.int({ min: undefined, max: undefined }),
            })),
          },
        },
        ordersCount: {
          ...{
            periodValue: faker.number.int({ min: undefined, max: undefined }),
            previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
            fromPeriod: Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1
            ).map(() => ({
              date: faker.date.past().toISOString().split("T")[0],
              value: faker.number.int({ min: undefined, max: undefined }),
            })),
          },
        },
        positiveReviewCount: {
          ...{
            periodValue: faker.number.int({ min: undefined, max: undefined }),
            previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
            fromPeriod: Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1
            ).map(() => ({
              date: faker.date.past().toISOString().split("T")[0],
              value: faker.number.int({ min: undefined, max: undefined }),
            })),
          },
        },
        negativeReviewCount: {
          ...{
            periodValue: faker.number.int({ min: undefined, max: undefined }),
            previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
            fromPeriod: Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1
            ).map(() => ({
              date: faker.date.past().toISOString().split("T")[0],
              value: faker.number.int({ min: undefined, max: undefined }),
            })),
          },
        },
        defectReviewCount: {
          ...{
            periodValue: faker.number.int({ min: undefined, max: undefined }),
            previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
            fromPeriod: Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1
            ).map(() => ({
              date: faker.date.past().toISOString().split("T")[0],
              value: faker.number.int({ min: undefined, max: undefined }),
            })),
          },
        },
        marketplaceProblemCount: {
          ...{
            periodValue: faker.number.int({ min: undefined, max: undefined }),
            previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
            fromPeriod: Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1
            ).map(() => ({
              date: faker.date.past().toISOString().split("T")[0],
              value: faker.number.int({ min: undefined, max: undefined }),
            })),
          },
        },
        failureToMeetExpectationsCount: {
          ...{
            periodValue: faker.number.int({ min: undefined, max: undefined }),
            previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
            fromPeriod: Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1
            ).map(() => ({
              date: faker.date.past().toISOString().split("T")[0],
              value: faker.number.int({ min: undefined, max: undefined }),
            })),
          },
        },
        othersProblemCount: {
          ...{
            periodValue: faker.number.int({ min: undefined, max: undefined }),
            previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
            fromPeriod: Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1
            ).map(() => ({
              date: faker.date.past().toISOString().split("T")[0],
              value: faker.number.int({ min: undefined, max: undefined }),
            })),
          },
        },
        rating: {
          ...{
            periodValue: faker.number.int({ min: undefined, max: undefined }),
            previousPeriodValue: faker.number.int({ min: undefined, max: undefined }),
            fromPeriod: Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1
            ).map(() => ({
              date: faker.date.past().toISOString().split("T")[0],
              value: faker.number.int({ min: undefined, max: undefined }),
            })),
          },
        },
        reviewWithTextCount: {
          ...{ periodValue: faker.number.int({ min: undefined, max: undefined }) },
        },
      },
    },
  })),
  ...overrideResponse,
});

export const getReviewControllerGetTFIDFResponseMock = (
  overrideResponse: Partial<WordCloudRes> = {}
): WordCloudRes => ({
  tfidf: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    problem: faker.string.alpha(20),
    value: faker.number.int({ min: undefined, max: undefined }),
  })),
  total_processed: faker.number.int({ min: undefined, max: undefined }),
  commentData: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      rating: faker.number.int({ min: undefined, max: undefined }),
      text: faker.string.alpha(20),
      marketplace: faker.string.alpha(20),
      summarization: faker.string.alpha(20),
      date: `${faker.date.past().toISOString().split(".")[0]}Z`,
    })
  ),
  ...overrideResponse,
});

export const getTableControllerGetProductsOverviewResponseMock =
  (): GetProductsOverviewResponseDTO[] =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      category: faker.string.alpha(20),
      products: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
        () => ({
          generalArticle: faker.number.int({ min: undefined, max: undefined }),
          id: faker.number.int({ min: undefined, max: undefined }),
          sku: faker.number.int({ min: undefined, max: undefined }),
          marketplace: faker.helpers.arrayElement(Object.values(MarketPlace)),
          category: faker.string.alpha(20),
          name: faker.string.alpha(20),
          image: faker.string.alpha(20),
          url: faker.string.alpha(20),
          mpStatUrl: faker.string.alpha(20),
          articleStatus: faker.helpers.arrayElement(Object.values(ArticleStatus)),
          productCardStatus: faker.helpers.arrayElement(Object.values(ProductCardStatus)),
          companyName: faker.string.alpha(20),
          brand: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
          manager: {
            email: faker.string.alpha(20),
            managerId: faker.string.alpha(20),
            name: faker.string.alpha(20),
            surname: faker.string.alpha(20),
          },
          isFavorite: faker.datatype.boolean(),
          price: faker.number.int({ min: undefined, max: undefined }),
          plannedPrice: faker.number.int({ min: undefined, max: undefined }),
          priceWithSpp: faker.number.int({ min: undefined, max: undefined }),
          averageOrdersIn4Days: faker.number.int({ min: undefined, max: undefined }),
          dailyActualOrderAmount: faker.number.int({ min: undefined, max: undefined }),
          dailyPlannedOrderAmount: faker.number.int({ min: undefined, max: undefined }),
          newDailyPlan: faker.number.int({ min: undefined, max: undefined }),
          quantityLeftOnMarketplace: faker.number.int({ min: undefined, max: undefined }),
          enoughForDays: faker.number.int({ min: undefined, max: undefined }),
          netProfitOnMarketplace: faker.number.int({ min: undefined, max: undefined }),
          plannedProfitPercent: faker.number.int({ min: undefined, max: undefined }),
        })
      ),
    }));

export const getTableControllerGetRemainingProductsResponseMock =
  (): GetRemainingProductsResponseDTO[] =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      category: faker.string.alpha(20),
      products: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
        () => ({
          generalArticle: faker.number.int({ min: undefined, max: undefined }),
          id: faker.number.int({ min: undefined, max: undefined }),
          sku: faker.number.int({ min: undefined, max: undefined }),
          marketplace: faker.helpers.arrayElement(Object.values(MarketPlace)),
          category: faker.string.alpha(20),
          name: faker.string.alpha(20),
          image: faker.string.alpha(20),
          url: faker.string.alpha(20),
          mpStatUrl: faker.string.alpha(20),
          articleStatus: faker.helpers.arrayElement(Object.values(ArticleStatus)),
          productCardStatus: faker.helpers.arrayElement(Object.values(ProductCardStatus)),
          companyName: faker.string.alpha(20),
          brand: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
          isFavorite: faker.datatype.boolean(),
          quantityLeftOnMarketplace: faker.number.int({ min: undefined, max: undefined }),
          enoughForDays: faker.number.int({ min: undefined, max: undefined }),
          wayToMarketplace: faker.number.int({ min: undefined, max: undefined }),
          reservedOnMarketplace: faker.number.int({ min: undefined, max: undefined }),
          warehouseInMoscow: faker.number.int({ min: undefined, max: undefined }),
          nearestDeliveryAmount: faker.number.int({ min: undefined, max: undefined }),
          nearestDeliveryDate: `${faker.date.past().toISOString().split(".")[0]}Z`,
          futureDeliveries: Array.from(
            { length: faker.number.int({ min: 1, max: 10 }) },
            (_, i) => i + 1
          ).map(() => ({
            amount: faker.number.int({ min: undefined, max: undefined }),
            arrivalDate: `${faker.date.past().toISOString().split(".")[0]}Z`,
          })),
          manager: {
            email: faker.string.alpha(20),
            managerId: faker.string.alpha(20),
            name: faker.string.alpha(20),
            surname: faker.string.alpha(20),
          },
        })
      ),
    }));

export const getTableControllerGetProductsOrderHistoryResponseMock =
  (): GetProductOrderHistoryWithManagerResponseDTO[] =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      category: faker.string.alpha(20),
      products: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
        () => ({
          generalArticle: faker.number.int({ min: undefined, max: undefined }),
          id: faker.number.int({ min: undefined, max: undefined }),
          sku: faker.number.int({ min: undefined, max: undefined }),
          marketplace: faker.helpers.arrayElement(Object.values(MarketPlace)),
          category: faker.string.alpha(20),
          name: faker.string.alpha(20),
          image: faker.string.alpha(20),
          url: faker.string.alpha(20),
          mpStatUrl: faker.string.alpha(20),
          articleStatus: faker.helpers.arrayElement(Object.values(ArticleStatus)),
          productCardStatus: faker.helpers.arrayElement(Object.values(ProductCardStatus)),
          companyName: faker.string.alpha(20),
          brand: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
          isFavorite: faker.datatype.boolean(),
          orders: Array.from(
            { length: faker.number.int({ min: 1, max: 10 }) },
            (_, i) => i + 1
          ).map(() => ({
            date: faker.string.alpha(20),
            ordersAmount: faker.number.int({ min: undefined, max: undefined }),
          })),
          manager: {
            email: faker.string.alpha(20),
            managerId: faker.string.alpha(20),
            name: faker.string.alpha(20),
            surname: faker.string.alpha(20),
          },
        })
      ),
    }));

export const getTableControllerGetRevenueResponseMock = (): GetRevenuesResponseDTO[] =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    category: faker.string.alpha(20),
    products: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        generalArticle: faker.number.int({ min: undefined, max: undefined }),
        id: faker.number.int({ min: undefined, max: undefined }),
        sku: faker.number.int({ min: undefined, max: undefined }),
        marketplace: faker.helpers.arrayElement(Object.values(MarketPlace)),
        category: faker.string.alpha(20),
        name: faker.string.alpha(20),
        image: faker.string.alpha(20),
        url: faker.string.alpha(20),
        mpStatUrl: faker.string.alpha(20),
        articleStatus: faker.helpers.arrayElement(Object.values(ArticleStatus)),
        productCardStatus: faker.helpers.arrayElement(Object.values(ProductCardStatus)),
        companyName: faker.string.alpha(20),
        brand: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
        isFavorite: faker.datatype.boolean(),
        plannedPrice: faker.number.int({ min: undefined, max: undefined }),
        averagePrice: faker.number.int({ min: undefined, max: undefined }),
        plannedRevenue: faker.number.int({ min: undefined, max: undefined }),
        actualRevenue: faker.number.int({ min: undefined, max: undefined }),
        newDailyRevenuePlan: faker.number.int({ min: undefined, max: undefined }),
        plannedNetProfit: faker.number.int({ min: undefined, max: undefined }),
        actualNetProfit: faker.number.int({ min: undefined, max: undefined }),
        newDailyNetProfitPlan: faker.number.int({ min: undefined, max: undefined }),
        manager: {
          email: faker.string.alpha(20),
          managerId: faker.string.alpha(20),
          name: faker.string.alpha(20),
          surname: faker.string.alpha(20),
        },
      })
    ),
  }));

export const getMarketShareControllerGetOptionsResponseMock = (
  overrideResponse: Partial<Options> = {}
): Options => ({
  marketplaces: faker.helpers.arrayElements(Object.values(MarketPlace)),
  categories: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => faker.string.alpha(20)
  ),
  orderOptions: faker.helpers.arrayElements(Object.values(BrandOrder)),
  ...overrideResponse,
});

export const getMarketShareControllerGetBriefcaseShareStatsResponseMock = (
  overrideResponse: Partial<MarketShareStatsByBriefcaseResponse> = {}
): MarketShareStatsByBriefcaseResponse => ({
  shareStat: faker.number.int({ min: undefined, max: undefined }),
  ourStat: faker.number.int({ min: undefined, max: undefined }),
  briefcaseMarketShareStats: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    briefcaseName: faker.string.alpha(20),
    shareStat: faker.number.int({ min: undefined, max: undefined }),
    ourStat: faker.number.int({ min: undefined, max: undefined }),
    categoriesMarketShareStats: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      categoryName: faker.string.alpha(20),
      shareStat: faker.number.int({ min: undefined, max: undefined }),
      ourStat: faker.number.int({ min: undefined, max: undefined }),
    })),
  })),
  ...overrideResponse,
});

export const getMarketShareControllerGetBriefcaseBrandListResponseMock = (
  overrideResponse: Partial<BrandListByBriefcaseResponse> = {}
): BrandListByBriefcaseResponse => ({
  competitorBrand: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    statistic: faker.number.int({ min: undefined, max: undefined }),
    position: faker.number.int({ min: undefined, max: undefined }),
    brandName: faker.string.alpha(20),
  })),
  ...overrideResponse,
});

export const getMarketShareControllerGetCategoryBrandListResponseMock = (
  overrideResponse: Partial<BrandListByCategoryResponse> = {}
): BrandListByCategoryResponse => ({
  brandList: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      statistic: faker.number.int({ min: undefined, max: undefined }),
      previous: faker.number.int({ min: undefined, max: undefined }),
      position: faker.number.int({ min: undefined, max: undefined }),
      brandName: faker.string.alpha(20),
    })
  ),
  ...overrideResponse,
});

export const getMarketShareControllerGetCategoryShareStatsResponseMock = (
  overrideResponse: Partial<MarketShareByCategoryStatsResponse> = {}
): MarketShareByCategoryStatsResponse => ({
  categories: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      categoryName: faker.string.alpha(20),
      shareStat: faker.number.int({ min: undefined, max: undefined }),
      ourStat: faker.number.int({ min: undefined, max: undefined }),
    })
  ),
  ...overrideResponse,
});

export const getMarketShareControllerGetPeriodValueResponseMock = (): PeriodValueResponse[] =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    date: faker.string.alpha(20),
    marketplacePeriodData: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      marketplace: faker.helpers.arrayElement(Object.values(MarketPlace)),
      ourValue: faker.number.int({ min: undefined, max: undefined }),
      commonValue: faker.number.int({ min: undefined, max: undefined }),
    })),
  }));

export const getMarketShareControllerGetSegmentResponseMock = (): SegmentResponseDTO[] =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    priceFrom: faker.number.int({ min: undefined, max: undefined }),
    priceTo: faker.number.int({ min: undefined, max: undefined }),
    value: faker.number.int({ min: undefined, max: undefined }),
    competitorValue: faker.number.int({ min: undefined, max: undefined }),
  }));

export const getMarketShareControllerGetPeriodSegmentResponseMock =
  (): SegmentPeriodResponseDTO[] =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      date: faker.string.alpha(20),
      segments: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
        () => ({
          priceFrom: faker.number.int({ min: undefined, max: undefined }),
          priceTo: faker.number.int({ min: undefined, max: undefined }),
          value: faker.number.int({ min: undefined, max: undefined }),
          competitorValue: faker.number.int({ min: undefined, max: undefined }),
        })
      ),
    }));

export const getCompetitorControllerImportCompetitorStatsResponseMock = (
  overrideResponse: Partial<StatusResponseDTO> = {}
): StatusResponseDTO => ({ status: faker.string.alpha(20), ...overrideResponse });

export const getCompetitorControllerGetSkusWithoutStatsResponseMock = (): EmptyStatsResponse[] =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    competitor_sku: faker.number.int({ min: undefined, max: undefined }),
    subcategoryName: faker.string.alpha(20),
    productGroupName: faker.string.alpha(20),
    parentCategoryName: faker.string.alpha(20),
    category_id: faker.number.int({ min: undefined, max: undefined }),
  }));

export const getCompetitorControllerGetLostResponseMock = (): EmptyStatsResponse[] =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    competitor_sku: faker.number.int({ min: undefined, max: undefined }),
    subcategoryName: faker.string.alpha(20),
    productGroupName: faker.string.alpha(20),
    parentCategoryName: faker.string.alpha(20),
    category_id: faker.number.int({ min: undefined, max: undefined }),
  }));

export const getCompetitorControllerCreateManualCompetitorResponseMock = (
  overrideResponse: Partial<ManualRelationResponse> = {}
): ManualRelationResponse => ({
  sku: faker.number.int({ min: undefined, max: undefined }),
  competitorSku: faker.number.int({ min: undefined, max: undefined }),
  isMarked: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getCompetitorControllerMarkResponseMock = (
  overrideResponse: Partial<MarkRelationResponseDTO> = {}
): MarkRelationResponseDTO => ({
  sku: faker.number.int({ min: undefined, max: undefined }),
  competitorSku: faker.number.int({ min: undefined, max: undefined }),
  isMarked: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getCompetitorControllerSearchSkuResponseMock = (): SearchCompetitorResponse[] =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    competitorSku: faker.number.int({ min: undefined, max: undefined }),
    name: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
    brand: faker.string.alpha(20),
  }));

export const getCompetitorControllerImportCompetitorRelationResponseMock = (
  overrideResponse: Partial<StatusResponseDTO> = {}
): StatusResponseDTO => ({ status: faker.string.alpha(20), ...overrideResponse });

export const getCompetitorControllerGetCategoryStatResponseMock = (): CategoryStatsResponse[] =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    categoryId: faker.number.int({ min: undefined, max: undefined }),
    categoryName: faker.string.alpha(20),
    articles: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        sku: faker.number.int({ min: undefined, max: undefined }),
        articleName: faker.string.alpha(20),
        article: faker.number.int({ min: undefined, max: undefined }),
        imageLink: faker.string.alpha(20),
        briefcase: faker.string.alpha(20),
        mpStatLink: faker.string.alpha(20),
        marketplaceLink: faker.string.alpha(20),
        competitorCount: faker.number.int({ min: undefined, max: undefined }),
        competitorRevenue: faker.number.int({ min: undefined, max: undefined }),
        competitorOrdersCount: faker.number.int({ min: undefined, max: undefined }),
        competitorAvgPrice: faker.number.int({ min: undefined, max: undefined }),
        competitorAvgRating: faker.number.int({ min: undefined, max: undefined }),
        competitorReviewCount: faker.number.int({ min: undefined, max: undefined }),
        revenue: faker.number.int({ min: undefined, max: undefined }),
        ordersCount: faker.number.int({ min: undefined, max: undefined }),
      })
    ),
  }));

export const getCompetitorControllerGetBriefcaseStatResponseMock = (
  overrideResponse: Partial<BriefcaseCompetitorRelationStatsResponse> = {}
): BriefcaseCompetitorRelationStatsResponse => ({
  competitorCount: faker.number.int({ min: undefined, max: undefined }),
  competitorAvgRating: faker.number.int({ min: undefined, max: undefined }),
  brandCount: faker.number.int({ min: undefined, max: undefined }),
  ...overrideResponse,
});

export const getCompetitorControllerGetMonthlyStatsResponseMock =
  (): MonthCompetitorStatsResponse[] =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      month: faker.string.alpha(20),
      revenue: faker.number.int({ min: undefined, max: undefined }),
      orderCount: faker.number.int({ min: undefined, max: undefined }),
      competitorRevenue: faker.number.int({ min: undefined, max: undefined }),
      competitorOrderCount: faker.number.int({ min: undefined, max: undefined }),
    }));

export const getCompetitorControllerGetCompetitorListResponseMock =
  (): CompetitorRelationListResponse[] =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      sku: faker.number.int({ min: undefined, max: undefined }),
      productName: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
      url: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
      brand: faker.string.alpha(20),
      MPLink: faker.string.alpha(20),
      legalName: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
      revenue: faker.number.int({ min: undefined, max: undefined }),
      categoryPercent: faker.number.int({ min: undefined, max: undefined }),
      orderCount: faker.number.int({ min: undefined, max: undefined }),
      avgPrice: faker.number.int({ min: undefined, max: undefined }),
      rating: faker.number.int({ min: undefined, max: undefined }),
      reviewCount: faker.number.int({ min: undefined, max: undefined }),
      daysInStock: faker.number.int({ min: undefined, max: undefined }),
      categoryPosition: faker.number.int({ min: undefined, max: undefined }),
      avgAdPosition: faker.number.int({ min: undefined, max: undefined }),
      avgOrganicPosition: faker.number.int({ min: undefined, max: undefined }),
      isMarked: faker.datatype.boolean(),
    }));

export const getCompetitorControllerGetCompetitorRelationResponseMock = (
  overrideResponse: Partial<CompetitorRelationDetailResponse> = {}
): CompetitorRelationDetailResponse => ({
  explanation: faker.string.alpha(20),
  greatFeatures: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.string.alpha(20), null]),
    undefined,
  ]),
  isMarked: faker.datatype.boolean(),
  color: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.string.alpha(20), null]),
    undefined,
  ]),
  balance: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  comments: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  rating: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  final_price: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  final_price_average: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  final_price_median: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  basic_sale: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  basic_price: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  promo_sale: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  client_sale: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  client_price: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  start_price: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  wallet_price: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  sales_per_day_average: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  revenue_potential: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  revenue_average: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  lost_profit: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  lost_profit_percent: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  days_with_sales: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  average_if_in_stock: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  subject: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.string.alpha(20), null]),
    undefined,
  ]),
  sku_first_date: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.string.alpha(20), null]),
    undefined,
  ]),
  firstcommentdate: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.string.alpha(20), null]),
    undefined,
  ]),
  category: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.string.alpha(20), null]),
    undefined,
  ]),
  turnover_days: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  frozen_stocks: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  frozen_stocks_cost: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  frozen_stocks_percent: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  related_products_count: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  related_products_in_stock_count: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  search_cpm_avg: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  search_ad_position_avg: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  search_organic_position_avg: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  package_length: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  package_width: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  package_height: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  competitorSku: faker.number.int({ min: undefined, max: undefined }),
  name: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.string.alpha(20), null]),
    undefined,
  ]),
  brand: faker.string.alpha(20),
  url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.string.alpha(20), null]),
    undefined,
  ]),
  seller: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.string.alpha(20), null]),
    undefined,
  ]),
  category_position: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
    undefined,
  ]),
  revenue: faker.number.int({ min: undefined, max: undefined }),
  orders: faker.number.int({ min: undefined, max: undefined }),
  revenue_share: faker.number.int({ min: undefined, max: undefined }),
  avg_price: faker.number.int({ min: undefined, max: undefined }),
  ...overrideResponse,
});

export const getCompetitorControllerGetArticleMonthlyStatResponseMock =
  (): SkuMonthlyCompetitorRelationStatsResponse[] =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      month: faker.string.alpha(20),
      revenuePercent: faker.number.int({ min: undefined, max: undefined }),
      orderCountPercent: faker.number.int({ min: undefined, max: undefined }),
      competitorAvgPrice: faker.number.int({ min: undefined, max: undefined }),
      avgPrice: faker.number.int({ min: undefined, max: undefined }),
    }));

export const getCompetitorControllerGetSkuStatResponseMock = (
  overrideResponse: Partial<SkuCompetitorRelationStatsResponse> = {}
): SkuCompetitorRelationStatsResponse => ({
  sku: faker.number.int({ min: undefined, max: undefined }),
  articleName: faker.string.alpha(20),
  description: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
  imageLink: faker.string.alpha(20),
  mpStatLink: faker.string.alpha(20),
  marketplaceLink: faker.string.alpha(20),
  competitorCount: faker.number.int({ min: undefined, max: undefined }),
  competitorBrandsCount: faker.number.int({ min: undefined, max: undefined }),
  competitorAvgRating: faker.number.int({ min: undefined, max: undefined }),
  revenue: faker.number.int({ min: undefined, max: undefined }),
  revenueShare: faker.number.int({ min: undefined, max: undefined }),
  orderCount: faker.number.int({ min: undefined, max: undefined }),
  orderShare: faker.number.int({ min: undefined, max: undefined }),
  ...overrideResponse,
});

export const getFinrezControllerImportFinrezDailyResponseMock = (
  overrideResponse: Partial<StatusResponseDTO> = {}
): StatusResponseDTO => ({ status: faker.string.alpha(20), ...overrideResponse });

export const getSalesChannelControllerGetOptionsResponseMock = (
  overrideResponse: Partial<OptionResponseDto> = {}
): OptionResponseDto => ({
  periods: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      type: faker.helpers.arrayElement(Object.values(PeriodType)),
      title: faker.string.alpha(20),
      isDefault: faker.datatype.boolean(),
      isAvailable: faker.datatype.boolean(),
      period: {
        type: faker.helpers.arrayElement(Object.values(PeriodType)),
        from: faker.date.past().toISOString().split("T")[0],
        to: faker.date.past().toISOString().split("T")[0],
        previousFrom: faker.date.past().toISOString().split("T")[0],
        previousTo: faker.date.past().toISOString().split("T")[0],
        daysCount: faker.number.int({ min: undefined, max: undefined }),
      },
    })
  ),
  marketplaces: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      marketplace: faker.helpers.arrayElement(Object.values(MarketPlace)),
      title: faker.string.alpha(20),
      order: faker.number.int({ min: undefined, max: undefined }),
    })
  ),
  dataFrom: faker.helpers.arrayElement([faker.date.past().toISOString().split("T")[0], null]),
  dataTo: faker.helpers.arrayElement([faker.date.past().toISOString().split("T")[0], null]),
  ...overrideResponse,
});

export const getSalesChannelControllerGetOverviewResponseMock = (
  overrideResponse: Partial<OverviewResponseDto> = {}
): OverviewResponseDto => ({
  period: {
    type: faker.helpers.arrayElement(Object.values(PeriodType)),
    from: faker.date.past().toISOString().split("T")[0],
    to: faker.date.past().toISOString().split("T")[0],
    previousFrom: faker.date.past().toISOString().split("T")[0],
    previousTo: faker.date.past().toISOString().split("T")[0],
    daysCount: faker.number.int({ min: undefined, max: undefined }),
  },
  total: {
    sales: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
    cm: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
    cmPercent: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
    avgCheck: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
    drr: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
    qty: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
    advert: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
  },
  channels: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      marketplace: faker.helpers.arrayElement(Object.values(MarketPlace)),
      title: faker.string.alpha(20),
      metrics: {
        sales: {
          key: faker.helpers.arrayElement(Object.values(MetricKey)),
          unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
          value: faker.number.int({ min: undefined, max: undefined }),
          previousValue: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          delta: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
          deltaRelative: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          trend: faker.helpers.arrayElement(Object.values(Trend)),
          severity: faker.helpers.arrayElement(Object.values(Severity)),
        },
        cm: {
          key: faker.helpers.arrayElement(Object.values(MetricKey)),
          unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
          value: faker.number.int({ min: undefined, max: undefined }),
          previousValue: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          delta: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
          deltaRelative: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          trend: faker.helpers.arrayElement(Object.values(Trend)),
          severity: faker.helpers.arrayElement(Object.values(Severity)),
        },
        cmPercent: {
          key: faker.helpers.arrayElement(Object.values(MetricKey)),
          unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
          value: faker.number.int({ min: undefined, max: undefined }),
          previousValue: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          delta: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
          deltaRelative: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          trend: faker.helpers.arrayElement(Object.values(Trend)),
          severity: faker.helpers.arrayElement(Object.values(Severity)),
        },
        avgCheck: {
          key: faker.helpers.arrayElement(Object.values(MetricKey)),
          unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
          value: faker.number.int({ min: undefined, max: undefined }),
          previousValue: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          delta: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
          deltaRelative: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          trend: faker.helpers.arrayElement(Object.values(Trend)),
          severity: faker.helpers.arrayElement(Object.values(Severity)),
        },
        drr: {
          key: faker.helpers.arrayElement(Object.values(MetricKey)),
          unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
          value: faker.number.int({ min: undefined, max: undefined }),
          previousValue: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          delta: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
          deltaRelative: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          trend: faker.helpers.arrayElement(Object.values(Trend)),
          severity: faker.helpers.arrayElement(Object.values(Severity)),
        },
        qty: {
          key: faker.helpers.arrayElement(Object.values(MetricKey)),
          unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
          value: faker.number.int({ min: undefined, max: undefined }),
          previousValue: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          delta: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
          deltaRelative: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          trend: faker.helpers.arrayElement(Object.values(Trend)),
          severity: faker.helpers.arrayElement(Object.values(Severity)),
        },
        advert: {
          key: faker.helpers.arrayElement(Object.values(MetricKey)),
          unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
          value: faker.number.int({ min: undefined, max: undefined }),
          previousValue: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          delta: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
          deltaRelative: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          trend: faker.helpers.arrayElement(Object.values(Trend)),
          severity: faker.helpers.arrayElement(Object.values(Severity)),
        },
      },
      salesShare: faker.number.int({ min: undefined, max: undefined }),
      status: faker.helpers.arrayElement(Object.values(Severity)),
      deviationsCount: faker.number.int({ min: undefined, max: undefined }),
      economics: {
        sales: faker.number.int({ min: undefined, max: undefined }),
        items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
          () => ({
            key: faker.helpers.arrayElement(Object.values(ExpenseKey)),
            title: faker.string.alpha(20),
            amount: faker.number.int({ min: undefined, max: undefined }),
            shareOfSales: faker.number.int({ min: undefined, max: undefined }),
            previousShareOfSales: faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            deltaPoint: faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            severity: faker.helpers.arrayElement(Object.values(Severity)),
          })
        ),
        cm: faker.number.int({ min: undefined, max: undefined }),
        cmPercent: faker.number.int({ min: undefined, max: undefined }),
        previousCmPercent: faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
      },
      deviations: Array.from(
        { length: faker.number.int({ min: 1, max: 10 }) },
        (_, i) => i + 1
      ).map(() => ({
        priority: faker.number.int({ min: undefined, max: undefined }),
        metric: faker.helpers.arrayElement(Object.values(MetricKey)),
        title: faker.string.alpha(20),
        unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
        value: faker.number.int({ min: undefined, max: undefined }),
        previousValue: faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        delta: faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
        severity: faker.helpers.arrayElement(Object.values(Severity)),
        ruleCode: faker.helpers.arrayElement([faker.string.alpha(20), null]),
      })),
    })
  ),
  series: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      metric: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      channel: faker.helpers.arrayElement(Object.values(ChannelKey)),
      isPrevious: faker.datatype.boolean(),
      min: faker.number.int({ min: undefined, max: undefined }),
      max: faker.number.int({ min: undefined, max: undefined }),
      points: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
        () => ({
          date: faker.date.past().toISOString().split("T")[0],
          value: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
        })
      ),
    })
  ),
  table: {
    total: {
      sales: faker.number.int({ min: undefined, max: undefined }),
      cm: faker.number.int({ min: undefined, max: undefined }),
      cmPercent: faker.number.int({ min: undefined, max: undefined }),
      avgCheck: faker.number.int({ min: undefined, max: undefined }),
      drr: faker.number.int({ min: undefined, max: undefined }),
      qty: faker.number.int({ min: undefined, max: undefined }),
      advert: faker.number.int({ min: undefined, max: undefined }),
      severity: {
        sales: faker.helpers.arrayElement(Object.values(Severity)),
        cm: faker.helpers.arrayElement(Object.values(Severity)),
        cmPercent: faker.helpers.arrayElement(Object.values(Severity)),
        avgCheck: faker.helpers.arrayElement(Object.values(Severity)),
        drr: faker.helpers.arrayElement(Object.values(Severity)),
        qty: faker.helpers.arrayElement(Object.values(Severity)),
        advert: faker.helpers.arrayElement(Object.values(Severity)),
      },
    },
    rows: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        marketplace: faker.helpers.arrayElement(Object.values(MarketPlace)),
        title: faker.string.alpha(20),
        current: {
          sales: faker.number.int({ min: undefined, max: undefined }),
          cm: faker.number.int({ min: undefined, max: undefined }),
          cmPercent: faker.number.int({ min: undefined, max: undefined }),
          avgCheck: faker.number.int({ min: undefined, max: undefined }),
          drr: faker.number.int({ min: undefined, max: undefined }),
          qty: faker.number.int({ min: undefined, max: undefined }),
          advert: faker.number.int({ min: undefined, max: undefined }),
          severity: {
            sales: faker.helpers.arrayElement(Object.values(Severity)),
            cm: faker.helpers.arrayElement(Object.values(Severity)),
            cmPercent: faker.helpers.arrayElement(Object.values(Severity)),
            avgCheck: faker.helpers.arrayElement(Object.values(Severity)),
            drr: faker.helpers.arrayElement(Object.values(Severity)),
            qty: faker.helpers.arrayElement(Object.values(Severity)),
            advert: faker.helpers.arrayElement(Object.values(Severity)),
          },
        },
        previous: {
          ...{
            sales: faker.number.int({ min: undefined, max: undefined }),
            cm: faker.number.int({ min: undefined, max: undefined }),
            cmPercent: faker.number.int({ min: undefined, max: undefined }),
            avgCheck: faker.number.int({ min: undefined, max: undefined }),
            drr: faker.number.int({ min: undefined, max: undefined }),
            qty: faker.number.int({ min: undefined, max: undefined }),
            advert: faker.number.int({ min: undefined, max: undefined }),
            severity: {
              sales: faker.helpers.arrayElement(Object.values(Severity)),
              cm: faker.helpers.arrayElement(Object.values(Severity)),
              cmPercent: faker.helpers.arrayElement(Object.values(Severity)),
              avgCheck: faker.helpers.arrayElement(Object.values(Severity)),
              drr: faker.helpers.arrayElement(Object.values(Severity)),
              qty: faker.helpers.arrayElement(Object.values(Severity)),
              advert: faker.helpers.arrayElement(Object.values(Severity)),
            },
          },
        },
        days: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
          () => ({
            sales: faker.number.int({ min: undefined, max: undefined }),
            cm: faker.number.int({ min: undefined, max: undefined }),
            cmPercent: faker.number.int({ min: undefined, max: undefined }),
            avgCheck: faker.number.int({ min: undefined, max: undefined }),
            drr: faker.number.int({ min: undefined, max: undefined }),
            qty: faker.number.int({ min: undefined, max: undefined }),
            advert: faker.number.int({ min: undefined, max: undefined }),
            severity: {
              sales: faker.helpers.arrayElement(Object.values(Severity)),
              cm: faker.helpers.arrayElement(Object.values(Severity)),
              cmPercent: faker.helpers.arrayElement(Object.values(Severity)),
              avgCheck: faker.helpers.arrayElement(Object.values(Severity)),
              drr: faker.helpers.arrayElement(Object.values(Severity)),
              qty: faker.helpers.arrayElement(Object.values(Severity)),
              advert: faker.helpers.arrayElement(Object.values(Severity)),
            },
            date: faker.date.past().toISOString().split("T")[0],
          })
        ),
      })
    ),
  },
  targets: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      scope: faker.helpers.arrayElement(Object.values(ChannelKey)),
      value: faker.number.int({ min: undefined, max: undefined }),
    })
  ),
  ...overrideResponse,
});

export const getSalesChannelControllerGetMarketplaceDetailResponseMock = (
  overrideResponse: Partial<MarketplaceDetailResponseDto> = {}
): MarketplaceDetailResponseDto => ({
  period: {
    type: faker.helpers.arrayElement(Object.values(PeriodType)),
    from: faker.date.past().toISOString().split("T")[0],
    to: faker.date.past().toISOString().split("T")[0],
    previousFrom: faker.date.past().toISOString().split("T")[0],
    previousTo: faker.date.past().toISOString().split("T")[0],
    daysCount: faker.number.int({ min: undefined, max: undefined }),
  },
  marketplace: faker.helpers.arrayElement(Object.values(MarketPlace)),
  title: faker.string.alpha(20),
  metrics: {
    sales: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
    cm: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
    cmPercent: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
    avgCheck: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
    drr: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
    qty: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
    advert: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
  },
  series: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      metric: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      channel: faker.helpers.arrayElement(Object.values(ChannelKey)),
      isPrevious: faker.datatype.boolean(),
      min: faker.number.int({ min: undefined, max: undefined }),
      max: faker.number.int({ min: undefined, max: undefined }),
      points: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
        () => ({
          date: faker.date.past().toISOString().split("T")[0],
          value: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
        })
      ),
    })
  ),
  cmSeries: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      metric: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      channel: faker.helpers.arrayElement(Object.values(ChannelKey)),
      isPrevious: faker.datatype.boolean(),
      min: faker.number.int({ min: undefined, max: undefined }),
      max: faker.number.int({ min: undefined, max: undefined }),
      points: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
        () => ({
          date: faker.date.past().toISOString().split("T")[0],
          value: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
        })
      ),
    })
  ),
  economics: {
    sales: faker.number.int({ min: undefined, max: undefined }),
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        key: faker.helpers.arrayElement(Object.values(ExpenseKey)),
        title: faker.string.alpha(20),
        amount: faker.number.int({ min: undefined, max: undefined }),
        shareOfSales: faker.number.int({ min: undefined, max: undefined }),
        previousShareOfSales: faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        deltaPoint: faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        severity: faker.helpers.arrayElement(Object.values(Severity)),
      })
    ),
    cm: faker.number.int({ min: undefined, max: undefined }),
    cmPercent: faker.number.int({ min: undefined, max: undefined }),
    previousCmPercent: faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
  },
  spp: {
    average: {
      key: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      value: faker.number.int({ min: undefined, max: undefined }),
      previousValue: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      delta: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      deltaUnit: faker.helpers.arrayElement(Object.values(DeltaUnit)),
      deltaRelative: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      trend: faker.helpers.arrayElement(Object.values(Trend)),
      severity: faker.helpers.arrayElement(Object.values(Severity)),
    },
    series: {
      metric: faker.helpers.arrayElement(Object.values(MetricKey)),
      unit: faker.helpers.arrayElement(Object.values(MetricUnit)),
      channel: faker.helpers.arrayElement(Object.values(ChannelKey)),
      isPrevious: faker.datatype.boolean(),
      min: faker.number.int({ min: undefined, max: undefined }),
      max: faker.number.int({ min: undefined, max: undefined }),
      points: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
        () => ({
          date: faker.date.past().toISOString().split("T")[0],
          value: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
        })
      ),
    },
  },
  days: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    date: faker.helpers.arrayElement([faker.date.past().toISOString().split("T")[0], null]),
    sales: faker.number.int({ min: undefined, max: undefined }),
    qty: faker.number.int({ min: undefined, max: undefined }),
    avgCheck: faker.number.int({ min: undefined, max: undefined }),
    advert: faker.number.int({ min: undefined, max: undefined }),
    drr: faker.number.int({ min: undefined, max: undefined }),
    cm: faker.number.int({ min: undefined, max: undefined }),
    cmPercent: faker.number.int({ min: undefined, max: undefined }),
    spp: faker.number.int({ min: undefined, max: undefined }),
    severity: {
      sales: faker.helpers.arrayElement(Object.values(Severity)),
      qty: faker.helpers.arrayElement(Object.values(Severity)),
      avgCheck: faker.helpers.arrayElement(Object.values(Severity)),
      advert: faker.helpers.arrayElement(Object.values(Severity)),
      drr: faker.helpers.arrayElement(Object.values(Severity)),
      cm: faker.helpers.arrayElement(Object.values(Severity)),
      cmPercent: faker.helpers.arrayElement(Object.values(Severity)),
      spp: faker.helpers.arrayElement(Object.values(Severity)),
    },
  })),
  total: {
    date: faker.helpers.arrayElement([faker.date.past().toISOString().split("T")[0], null]),
    sales: faker.number.int({ min: undefined, max: undefined }),
    qty: faker.number.int({ min: undefined, max: undefined }),
    avgCheck: faker.number.int({ min: undefined, max: undefined }),
    advert: faker.number.int({ min: undefined, max: undefined }),
    drr: faker.number.int({ min: undefined, max: undefined }),
    cm: faker.number.int({ min: undefined, max: undefined }),
    cmPercent: faker.number.int({ min: undefined, max: undefined }),
    spp: faker.number.int({ min: undefined, max: undefined }),
    severity: {
      sales: faker.helpers.arrayElement(Object.values(Severity)),
      qty: faker.helpers.arrayElement(Object.values(Severity)),
      avgCheck: faker.helpers.arrayElement(Object.values(Severity)),
      advert: faker.helpers.arrayElement(Object.values(Severity)),
      drr: faker.helpers.arrayElement(Object.values(Severity)),
      cm: faker.helpers.arrayElement(Object.values(Severity)),
      cmPercent: faker.helpers.arrayElement(Object.values(Severity)),
      spp: faker.helpers.arrayElement(Object.values(Severity)),
    },
  },
  previousTotal: {
    ...{
      date: faker.helpers.arrayElement([faker.date.past().toISOString().split("T")[0], null]),
      sales: faker.number.int({ min: undefined, max: undefined }),
      qty: faker.number.int({ min: undefined, max: undefined }),
      avgCheck: faker.number.int({ min: undefined, max: undefined }),
      advert: faker.number.int({ min: undefined, max: undefined }),
      drr: faker.number.int({ min: undefined, max: undefined }),
      cm: faker.number.int({ min: undefined, max: undefined }),
      cmPercent: faker.number.int({ min: undefined, max: undefined }),
      spp: faker.number.int({ min: undefined, max: undefined }),
      severity: {
        sales: faker.helpers.arrayElement(Object.values(Severity)),
        qty: faker.helpers.arrayElement(Object.values(Severity)),
        avgCheck: faker.helpers.arrayElement(Object.values(Severity)),
        advert: faker.helpers.arrayElement(Object.values(Severity)),
        drr: faker.helpers.arrayElement(Object.values(Severity)),
        cm: faker.helpers.arrayElement(Object.values(Severity)),
        cmPercent: faker.helpers.arrayElement(Object.values(Severity)),
        spp: faker.helpers.arrayElement(Object.values(Severity)),
      },
    },
  },
  ...overrideResponse,
});

export const getAdvertisementControllerGetAdvertisementHistoryMockHandler = (
  overrideResponse?:
    | GetAdvertisementHistoryByCampaignsResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) =>
        | Promise<GetAdvertisementHistoryByCampaignsResponseDTO>
        | GetAdvertisementHistoryByCampaignsResponseDTO)
) => {
  return http.get("*/api/advertisement/getAdvertisementHistory/:productId", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getAdvertisementControllerGetAdvertisementHistoryResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getAdvertisementControllerGetDailyInnerAdStatMockHandler = (
  overrideResponse?:
    | GetAdDailyCompanyStatsResponseDto
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetAdDailyCompanyStatsResponseDto> | GetAdDailyCompanyStatsResponseDto)
) => {
  return http.get("*/api/advertisement/daily", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getAdvertisementControllerGetDailyInnerAdStatResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getAdvertisementControllerGetAdKeywordMockHandler = (
  overrideResponse?:
    | GetAdDailyCompanyStatsBySkuResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetAdDailyCompanyStatsBySkuResponse> | GetAdDailyCompanyStatsBySkuResponse)
) => {
  return http.get("*/api/advertisement/keywords/:sku", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getAdvertisementControllerGetAdKeywordResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getAuthControllerLoginMockHandler = (
  overrideResponse?:
    | AuthResponseDto
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<AuthResponseDto> | AuthResponseDto)
) => {
  return http.post("*/api/auth/login", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getAuthControllerLoginResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getAuthControllerLogoutMockHandler = (
  overrideResponse?:
    | LogoutResponseDto
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<LogoutResponseDto> | LogoutResponseDto)
) => {
  return http.post("*/api/auth/logout", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getAuthControllerLogoutResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getAuthControllerRegistrationMockHandler = (
  overrideResponse?:
    | AuthResponseDto
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<AuthResponseDto> | AuthResponseDto)
) => {
  return http.post("*/api/auth/registration", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getAuthControllerRegistrationResponseMock()
      ),
      { status: 201, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getAuthControllerActivateAccountMockHandler = (
  overrideResponse?:
    | void
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<void> | void)
) => {
  return http.get("*/api/auth/activation/:link", async (info) => {
    await delay(1000);
    if (typeof overrideResponse === "function") {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 200 });
  });
};

export const getAuthControllerSendNewActivateLinkMockHandler = (
  overrideResponse?:
    | void
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<void> | void)
) => {
  return http.get("*/api/auth/link", async (info) => {
    await delay(1000);
    if (typeof overrideResponse === "function") {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 200 });
  });
};

export const getAuthControllerSendResetPasswordLinkMockHandler = (
  overrideResponse?:
    | void
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)
) => {
  return http.post("*/api/auth/sendResetPasswordLink", async (info) => {
    await delay(1000);
    if (typeof overrideResponse === "function") {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 201 });
  });
};

export const getAuthControllerResetPasswordMockHandler = (
  overrideResponse?:
    | StatusResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<StatusResponseDTO> | StatusResponseDTO)
) => {
  return http.post("*/api/auth/resetPassword/:link", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getAuthControllerResetPasswordResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getAuthControllerRefreshMockHandler = (
  overrideResponse?:
    | AuthResponseDto
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<AuthResponseDto> | AuthResponseDto)
) => {
  return http.get("*/api/auth/refresh", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getAuthControllerRefreshResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getUserControllerGetAllMockHandler = (
  overrideResponse?:
    | UserInfoDto[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<UserInfoDto[]> | UserInfoDto[])
) => {
  return http.get("*/api/user/all", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getUserControllerGetAllResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getUserControllerFindOneMockHandler = (
  overrideResponse?:
    | ReadUserResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ReadUserResponse> | ReadUserResponse)
) => {
  return http.get("*/api/user/:id", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getUserControllerFindOneResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getUserControllerUpdateMockHandler = (
  overrideResponse?:
    | ReadUserResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0]
      ) => Promise<ReadUserResponse> | ReadUserResponse)
) => {
  return http.patch("*/api/user/:id", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getUserControllerUpdateResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getUserControllerRemoveMockHandler = (
  overrideResponse?:
    | DeleteUserResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0]
      ) => Promise<DeleteUserResponse> | DeleteUserResponse)
) => {
  return http.delete("*/api/user/:id", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getUserControllerRemoveResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getUserControllerMakeSubordinateMockHandler = (
  overrideResponse?:
    | StatusResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<StatusResponseDTO> | StatusResponseDTO)
) => {
  return http.post("*/api/user/makeSubordinate/:userId", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getUserControllerMakeSubordinateResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getUserControllerUpdateSelfMockHandler = (
  overrideResponse?:
    | ReadUserResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0]
      ) => Promise<ReadUserResponse> | ReadUserResponse)
) => {
  return http.patch("*/api/user", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getUserControllerUpdateSelfResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getAlertControllerSseMockHandler = (
  overrideResponse?:
    | AlertResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<AlertResponseDTO> | AlertResponseDTO)
) => {
  return http.get("*/api/alert/sse", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getAlertControllerSseResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getLogisticControllerUpdateDeliveryDataMockHandler = (
  overrideResponse?:
    | StatusResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<StatusResponseDTO> | StatusResponseDTO)
) => {
  return http.post("*/api/logistic/updateDeliveryData", async (info) => {
    await delay(1000);
    if (typeof overrideResponse === "function") {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 200 });
  });
};

export const getBriefcaseControllerGetBriefcasesMockHandler = (
  overrideResponse?:
    | BriefcaseDto[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<BriefcaseDto[]> | BriefcaseDto[])
) => {
  return http.get("*/api/briefcase", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getBriefcaseControllerGetBriefcasesResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getProductControllerRemoveMockHandler = (
  overrideResponse?:
    | void
    | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void)
) => {
  return http.delete("*/api/product/:id", async (info) => {
    await delay(1000);
    if (typeof overrideResponse === "function") {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 200 });
  });
};

export const getProductControllerSearchProductMockHandler = (
  overrideResponse?:
    | SearchProductResponseDTO[]
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<SearchProductResponseDTO[]> | SearchProductResponseDTO[])
) => {
  return http.post("*/api/product/searchProduct", async (info) => {
    await delay(1000);
    if (typeof overrideResponse === "function") {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 200 });
  });
};

export const getProductControllerSaveNewProductsMockHandler = (
  overrideResponse?:
    | void
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)
) => {
  return http.post("*/api/product/saveNewProducts", async (info) => {
    await delay(1000);
    if (typeof overrideResponse === "function") {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 201 });
  });
};

export const getProductControllerGetUnassignedProductsMockHandler = (
  overrideResponse?:
    | GetUnassignedProductsDTO[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetUnassignedProductsDTO[]> | GetUnassignedProductsDTO[])
) => {
  return http.get("*/api/product/getUnassignedProducts", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getProductControllerGetUnassignedProductsResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCategoryControllerGetAllMockHandler = (
  overrideResponse?:
    | ArticleCategoryResponse[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ArticleCategoryResponse[]> | ArticleCategoryResponse[])
) => {
  return http.get("*/api/category", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCategoryControllerGetAllResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCategoryControllerGetOptionsMockHandler = (
  overrideResponse?:
    | OptionsCompetitorResponse[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<OptionsCompetitorResponse[]> | OptionsCompetitorResponse[])
) => {
  return http.get("*/api/category/by-briefcase", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCategoryControllerGetOptionsResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getRatingControllerGetProductRatingHistoryMockHandler = (
  overrideResponse?:
    | GetProductRatingHistoryResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetProductRatingHistoryResponseDTO> | GetProductRatingHistoryResponseDTO)
) => {
  return http.get("*/api/rating/getProductRatingHistory/:productId", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getRatingControllerGetProductRatingHistoryResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getManagerAppointmentControllerAppointManagerMockHandler = (
  overrideResponse?:
    | StatusResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<StatusResponseDTO> | StatusResponseDTO)
) => {
  return http.post("*/api/products/appointManager", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getManagerAppointmentControllerAppointManagerResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getManagerAppointmentControllerUpdateFavoriteMockHandler = (
  overrideResponse?:
    | UpdateFavoriteResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<UpdateFavoriteResponseDTO> | UpdateFavoriteResponseDTO)
) => {
  return http.post("*/api/products/updateFavorite/:productId", async (info) => {
    await delay(1000);
    if (typeof overrideResponse === "function") {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 200 });
  });
};

export const getCommentControllerCreateCommentMockHandler = (
  overrideResponse?:
    | StatusResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<StatusResponseDTO> | StatusResponseDTO)
) => {
  return http.post("*/api/comment/create", async (info) => {
    await delay(1000);
    if (typeof overrideResponse === "function") {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 200 });
  });
};

export const getCommentControllerGetCommentsForProductMockHandler = (
  overrideResponse?:
    | GetCommentResponseDTO[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetCommentResponseDTO[]> | GetCommentResponseDTO[])
) => {
  return http.get("*/api/comment/:productId", async (info) => {
    await delay(1000);
    if (typeof overrideResponse === "function") {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 200 });
  });
};

export const getDagControllerNotifyDagFinishedMockHandler = (
  overrideResponse?:
    | void
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)
) => {
  return http.post("*/api/dag/notifyDagFinished", async (info) => {
    await delay(1000);
    if (typeof overrideResponse === "function") {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 201 });
  });
};

export const getDashboardControllerGetDashboardMockHandler = (
  overrideResponse?:
    | DashboardResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<DashboardResponseDTO> | DashboardResponseDTO)
) => {
  return http.get("*/api/dashboard/getDashboard/:productId", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getDashboardControllerGetDashboardResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getNetProfitControllerGetNetProfitsHistoryFprProductsMockHandler = (
  overrideResponse?:
    | void
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void)
) => {
  return http.post("*/api/netProfit/getNetProfitsHistoryForProducts", async (info) => {
    await delay(1000);
    if (typeof overrideResponse === "function") {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 201 });
  });
};

export const getOrderHistoryControllerGetOrderHistoryForProductMockHandler = (
  overrideResponse?:
    | GetOrderHistoryForProductResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetOrderHistoryForProductResponseDTO> | GetOrderHistoryForProductResponseDTO)
) => {
  return http.get("*/api/orders/getOrderHistoryForProduct/:productId", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getOrderHistoryControllerGetOrderHistoryForProductResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getProductReportControllerGetProductPriceHistoryMockHandler = (
  overrideResponse?:
    | GetProductPriceHistoryResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetProductPriceHistoryResponseDTO> | GetProductPriceHistoryResponseDTO)
) => {
  return http.get("*/api/product/productPriceHistory/:id", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getProductReportControllerGetProductPriceHistoryResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getProductReportControllerGetProductCardSummaryMockHandler = (
  overrideResponse?:
    | GetProductCardSummaryResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetProductCardSummaryResponseDTO> | GetProductCardSummaryResponseDTO)
) => {
  return http.get("*/api/product/getProductCardSummary/:productId", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getProductReportControllerGetProductCardSummaryResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getProductReportControllerGetProductCardReportMockHandler = (
  overrideResponse?:
    | GetProductCardReportResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetProductCardReportResponseDTO> | GetProductCardReportResponseDTO)
) => {
  return http.get("*/api/product/getProductCardReport/:productId", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getProductReportControllerGetProductCardReportResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getProductReportControllerGetProductCardEconomyMockHandler = (
  overrideResponse?:
    | GetProductCardEconomyResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetProductCardEconomyResponseDTO> | GetProductCardEconomyResponseDTO)
) => {
  return http.get("*/api/product/getProductCardEconomy/:productId", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getProductReportControllerGetProductCardEconomyResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getProductReportControllerGetPurchaseFunnelMockHandler = (
  overrideResponse?:
    | GetPurchaseFunnelResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetPurchaseFunnelResponseDTO> | GetPurchaseFunnelResponseDTO)
) => {
  return http.get("*/api/product/getPurchaseFunnel/:productId", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getProductReportControllerGetPurchaseFunnelResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getRequestLoggerControllerGetMockHandler = (
  overrideResponse?:
    | LogPaginatedResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<LogPaginatedResponse> | LogPaginatedResponse)
) => {
  return http.get("*/api/request-logger", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getRequestLoggerControllerGetResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getReviewControllerGetInfoByBriefcaseForPeriodMockHandler = (
  overrideResponse?:
    | ReviewsByBriefcaseResponseDto[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ReviewsByBriefcaseResponseDto[]> | ReviewsByBriefcaseResponseDto[])
) => {
  return http.get("*/api/review/getAllForPeriod", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getReviewControllerGetInfoByBriefcaseForPeriodResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getReviewControllerGetInfoByGeneralArticleMockHandler = (
  overrideResponse?:
    | ReviewByArticleResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ReviewByArticleResponse> | ReviewByArticleResponse)
) => {
  return http.get("*/api/review/getByArticleForPeriod", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getReviewControllerGetInfoByGeneralArticleResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getReviewControllerGetTFIDFMockHandler = (
  overrideResponse?:
    | WordCloudRes
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<WordCloudRes> | WordCloudRes)
) => {
  return http.get("*/api/review/tfidf", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getReviewControllerGetTFIDFResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getTableControllerGetProductsOverviewMockHandler = (
  overrideResponse?:
    | GetProductsOverviewResponseDTO[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetProductsOverviewResponseDTO[]> | GetProductsOverviewResponseDTO[])
) => {
  return http.get("*/api/general-category/getAll", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getTableControllerGetProductsOverviewResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getTableControllerGetRemainingProductsMockHandler = (
  overrideResponse?:
    | GetRemainingProductsResponseDTO[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetRemainingProductsResponseDTO[]> | GetRemainingProductsResponseDTO[])
) => {
  return http.get("*/api/general-category/getRemainingProducts", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getTableControllerGetRemainingProductsResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getTableControllerGetProductsOrderHistoryMockHandler = (
  overrideResponse?:
    | GetProductOrderHistoryWithManagerResponseDTO[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) =>
        | Promise<GetProductOrderHistoryWithManagerResponseDTO[]>
        | GetProductOrderHistoryWithManagerResponseDTO[])
) => {
  return http.get("*/api/general-category/getProductsOrderHistory", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getTableControllerGetProductsOrderHistoryResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getTableControllerGetRevenueMockHandler = (
  overrideResponse?:
    | GetRevenuesResponseDTO[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetRevenuesResponseDTO[]> | GetRevenuesResponseDTO[])
) => {
  return http.get("*/api/general-category/getRevenue", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getTableControllerGetRevenueResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getMarketShareControllerGetOptionsMockHandler = (
  overrideResponse?:
    | Options
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<Options> | Options)
) => {
  return http.get("*/api/market-share/options", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getMarketShareControllerGetOptionsResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getMarketShareControllerGetBriefcaseShareStatsMockHandler = (
  overrideResponse?:
    | MarketShareStatsByBriefcaseResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<MarketShareStatsByBriefcaseResponse> | MarketShareStatsByBriefcaseResponse)
) => {
  return http.get("*/api/market-share/briefcase", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getMarketShareControllerGetBriefcaseShareStatsResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getMarketShareControllerGetBriefcaseBrandListMockHandler = (
  overrideResponse?:
    | BrandListByBriefcaseResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<BrandListByBriefcaseResponse> | BrandListByBriefcaseResponse)
) => {
  return http.get("*/api/market-share/brand-briefcase", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getMarketShareControllerGetBriefcaseBrandListResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getMarketShareControllerGetCategoryBrandListMockHandler = (
  overrideResponse?:
    | BrandListByCategoryResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<BrandListByCategoryResponse> | BrandListByCategoryResponse)
) => {
  return http.get("*/api/market-share/brand-category", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getMarketShareControllerGetCategoryBrandListResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getMarketShareControllerGetCategoryShareStatsMockHandler = (
  overrideResponse?:
    | MarketShareByCategoryStatsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<MarketShareByCategoryStatsResponse> | MarketShareByCategoryStatsResponse)
) => {
  return http.get("*/api/market-share/category", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getMarketShareControllerGetCategoryShareStatsResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getMarketShareControllerGetPeriodValueMockHandler = (
  overrideResponse?:
    | PeriodValueResponse[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<PeriodValueResponse[]> | PeriodValueResponse[])
) => {
  return http.get("*/api/market-share/marketplace-period", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getMarketShareControllerGetPeriodValueResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getMarketShareControllerGetSegmentMockHandler = (
  overrideResponse?:
    | SegmentResponseDTO[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<SegmentResponseDTO[]> | SegmentResponseDTO[])
) => {
  return http.get("*/api/market-share/segment", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getMarketShareControllerGetSegmentResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getMarketShareControllerGetPeriodSegmentMockHandler = (
  overrideResponse?:
    | SegmentPeriodResponseDTO[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<SegmentPeriodResponseDTO[]> | SegmentPeriodResponseDTO[])
) => {
  return http.get("*/api/market-share/period-segment", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getMarketShareControllerGetPeriodSegmentResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerImportCompetitorStatsMockHandler = (
  overrideResponse?:
    | StatusResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<StatusResponseDTO> | StatusResponseDTO)
) => {
  return http.post("*/api/competitor", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerImportCompetitorStatsResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerGetSkusWithoutStatsMockHandler = (
  overrideResponse?:
    | EmptyStatsResponse[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<EmptyStatsResponse[]> | EmptyStatsResponse[])
) => {
  return http.get("*/api/competitor/relation/skus-without-stats", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerGetSkusWithoutStatsResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerGetLostMockHandler = (
  overrideResponse?:
    | EmptyStatsResponse[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<EmptyStatsResponse[]> | EmptyStatsResponse[])
) => {
  return http.get("*/api/competitor/relation/lost-category", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerGetLostResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerCreateManualCompetitorMockHandler = (
  overrideResponse?:
    | ManualRelationResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<ManualRelationResponse> | ManualRelationResponse)
) => {
  return http.post("*/api/competitor/relation/manual/:sku", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerCreateManualCompetitorResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerMarkMockHandler = (
  overrideResponse?:
    | MarkRelationResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0]
      ) => Promise<MarkRelationResponseDTO> | MarkRelationResponseDTO)
) => {
  return http.patch("*/api/competitor/relation/:sku/mark", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerMarkResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerSearchSkuMockHandler = (
  overrideResponse?:
    | SearchCompetitorResponse[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<SearchCompetitorResponse[]> | SearchCompetitorResponse[])
) => {
  return http.get("*/api/competitor/sku/search", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerSearchSkuResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerImportCompetitorRelationMockHandler = (
  overrideResponse?:
    | StatusResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<StatusResponseDTO> | StatusResponseDTO)
) => {
  return http.post("*/api/competitor/relation", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerImportCompetitorRelationResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerGetCategoryStatMockHandler = (
  overrideResponse?:
    | CategoryStatsResponse[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<CategoryStatsResponse[]> | CategoryStatsResponse[])
) => {
  return http.get("*/api/competitor/relation/category-stats", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerGetCategoryStatResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerGetBriefcaseStatMockHandler = (
  overrideResponse?:
    | BriefcaseCompetitorRelationStatsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) =>
        | Promise<BriefcaseCompetitorRelationStatsResponse>
        | BriefcaseCompetitorRelationStatsResponse)
) => {
  return http.get("*/api/competitor/relation/briefcase-stats", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerGetBriefcaseStatResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerGetMonthlyStatsMockHandler = (
  overrideResponse?:
    | MonthCompetitorStatsResponse[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<MonthCompetitorStatsResponse[]> | MonthCompetitorStatsResponse[])
) => {
  return http.get("*/api/competitor/relation/monthly-stats", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerGetMonthlyStatsResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerGetCompetitorListMockHandler = (
  overrideResponse?:
    | CompetitorRelationListResponse[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<CompetitorRelationListResponse[]> | CompetitorRelationListResponse[])
) => {
  return http.get("*/api/competitor/relation/:sku/list", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerGetCompetitorListResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerGetCompetitorRelationMockHandler = (
  overrideResponse?:
    | CompetitorRelationDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<CompetitorRelationDetailResponse> | CompetitorRelationDetailResponse)
) => {
  return http.get("*/api/competitor/relation/:sku/competitor/:competitor", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerGetCompetitorRelationResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerGetArticleMonthlyStatMockHandler = (
  overrideResponse?:
    | SkuMonthlyCompetitorRelationStatsResponse[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) =>
        | Promise<SkuMonthlyCompetitorRelationStatsResponse[]>
        | SkuMonthlyCompetitorRelationStatsResponse[])
) => {
  return http.get("*/api/competitor/relation/:sku/monthly-stats", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerGetArticleMonthlyStatResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getCompetitorControllerGetSkuStatMockHandler = (
  overrideResponse?:
    | SkuCompetitorRelationStatsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<SkuCompetitorRelationStatsResponse> | SkuCompetitorRelationStatsResponse)
) => {
  return http.get("*/api/competitor/relation/:sku", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getCompetitorControllerGetSkuStatResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getFinrezControllerImportFinrezDailyMockHandler = (
  overrideResponse?:
    | StatusResponseDTO
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<StatusResponseDTO> | StatusResponseDTO)
) => {
  return http.post("*/api/finrez/daily", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getFinrezControllerImportFinrezDailyResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getSalesChannelControllerGetOptionsMockHandler = (
  overrideResponse?:
    | OptionResponseDto
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<OptionResponseDto> | OptionResponseDto)
) => {
  return http.get("*/api/sales-channels/options", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getSalesChannelControllerGetOptionsResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getSalesChannelControllerGetOverviewMockHandler = (
  overrideResponse?:
    | OverviewResponseDto
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<OverviewResponseDto> | OverviewResponseDto)
) => {
  return http.get("*/api/sales-channels/overview", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getSalesChannelControllerGetOverviewResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};

export const getSalesChannelControllerGetMarketplaceDetailMockHandler = (
  overrideResponse?:
    | MarketplaceDetailResponseDto
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<MarketplaceDetailResponseDto> | MarketplaceDetailResponseDto)
) => {
  return http.get("*/api/sales-channels/marketplace/:marketplace", async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === "function"
            ? await overrideResponse(info)
            : overrideResponse
          : getSalesChannelControllerGetMarketplaceDetailResponseMock()
      ),
      { status: 200, headers: { "Content-Type": "application/json" } }
    );
  });
};
export const getChampCrmMock = () => [
  getAdvertisementControllerGetAdvertisementHistoryMockHandler(),
  getAdvertisementControllerGetDailyInnerAdStatMockHandler(),
  getAdvertisementControllerGetAdKeywordMockHandler(),
  getAuthControllerLoginMockHandler(),
  getAuthControllerLogoutMockHandler(),
  getAuthControllerRegistrationMockHandler(),
  getAuthControllerActivateAccountMockHandler(),
  getAuthControllerSendNewActivateLinkMockHandler(),
  getAuthControllerSendResetPasswordLinkMockHandler(),
  getAuthControllerResetPasswordMockHandler(),
  getAuthControllerRefreshMockHandler(),
  getUserControllerGetAllMockHandler(),
  getUserControllerFindOneMockHandler(),
  getUserControllerUpdateMockHandler(),
  getUserControllerRemoveMockHandler(),
  getUserControllerMakeSubordinateMockHandler(),
  getUserControllerUpdateSelfMockHandler(),
  getAlertControllerSseMockHandler(),
  getLogisticControllerUpdateDeliveryDataMockHandler(),
  getBriefcaseControllerGetBriefcasesMockHandler(),
  getProductControllerRemoveMockHandler(),
  getProductControllerSearchProductMockHandler(),
  getProductControllerSaveNewProductsMockHandler(),
  getProductControllerGetUnassignedProductsMockHandler(),
  getCategoryControllerGetAllMockHandler(),
  getCategoryControllerGetOptionsMockHandler(),
  getRatingControllerGetProductRatingHistoryMockHandler(),
  getManagerAppointmentControllerAppointManagerMockHandler(),
  getManagerAppointmentControllerUpdateFavoriteMockHandler(),
  getCommentControllerCreateCommentMockHandler(),
  getCommentControllerGetCommentsForProductMockHandler(),
  getDagControllerNotifyDagFinishedMockHandler(),
  getDashboardControllerGetDashboardMockHandler(),
  getNetProfitControllerGetNetProfitsHistoryFprProductsMockHandler(),
  getOrderHistoryControllerGetOrderHistoryForProductMockHandler(),
  getProductReportControllerGetProductPriceHistoryMockHandler(),
  getProductReportControllerGetProductCardSummaryMockHandler(),
  getProductReportControllerGetProductCardReportMockHandler(),
  getProductReportControllerGetProductCardEconomyMockHandler(),
  getProductReportControllerGetPurchaseFunnelMockHandler(),
  getRequestLoggerControllerGetMockHandler(),
  getReviewControllerGetInfoByBriefcaseForPeriodMockHandler(),
  getReviewControllerGetInfoByGeneralArticleMockHandler(),
  getReviewControllerGetTFIDFMockHandler(),
  getTableControllerGetProductsOverviewMockHandler(),
  getTableControllerGetRemainingProductsMockHandler(),
  getTableControllerGetProductsOrderHistoryMockHandler(),
  getTableControllerGetRevenueMockHandler(),
  getMarketShareControllerGetOptionsMockHandler(),
  getMarketShareControllerGetBriefcaseShareStatsMockHandler(),
  getMarketShareControllerGetBriefcaseBrandListMockHandler(),
  getMarketShareControllerGetCategoryBrandListMockHandler(),
  getMarketShareControllerGetCategoryShareStatsMockHandler(),
  getMarketShareControllerGetPeriodValueMockHandler(),
  getMarketShareControllerGetSegmentMockHandler(),
  getMarketShareControllerGetPeriodSegmentMockHandler(),
  getCompetitorControllerImportCompetitorStatsMockHandler(),
  getCompetitorControllerGetSkusWithoutStatsMockHandler(),
  getCompetitorControllerGetLostMockHandler(),
  getCompetitorControllerCreateManualCompetitorMockHandler(),
  getCompetitorControllerMarkMockHandler(),
  getCompetitorControllerSearchSkuMockHandler(),
  getCompetitorControllerImportCompetitorRelationMockHandler(),
  getCompetitorControllerGetCategoryStatMockHandler(),
  getCompetitorControllerGetBriefcaseStatMockHandler(),
  getCompetitorControllerGetMonthlyStatsMockHandler(),
  getCompetitorControllerGetCompetitorListMockHandler(),
  getCompetitorControllerGetCompetitorRelationMockHandler(),
  getCompetitorControllerGetArticleMonthlyStatMockHandler(),
  getCompetitorControllerGetSkuStatMockHandler(),
  getFinrezControllerImportFinrezDailyMockHandler(),
  getSalesChannelControllerGetOptionsMockHandler(),
  getSalesChannelControllerGetOverviewMockHandler(),
  getSalesChannelControllerGetMarketplaceDetailMockHandler(),
];
